import { LitElement as po, adoptStyles as uo, unsafeCSS as go, nothing as G, html as b } from "lit";
import { property as E, state as Se, query as sn, customElement as te } from "lit/decorators.js";
import { live as fo } from "lit/directives/live.js";
import { unsafeSVG as M } from "lit/directives/unsafe-svg.js";
import { unsafeHTML as nn } from "lit/directives/unsafe-html.js";
import { repeat as on } from "lit/directives/repeat.js";
import { map as an } from "lit/directives/map.js";
import { createRef as mo, ref as wo } from "lit/directives/ref.js";
import { guard as ks } from "lit/directives/guard.js";
function bo(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var or = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var xs;
function vo() {
  return xs || (xs = 1, (function(r) {
    (function() {
      var e = {}.hasOwnProperty;
      function t() {
        for (var o = "", i = 0; i < arguments.length; i++) {
          var a = arguments[i];
          a && (o = s(o, n(a)));
        }
        return o;
      }
      function n(o) {
        if (typeof o == "string" || typeof o == "number")
          return o;
        if (typeof o != "object")
          return "";
        if (Array.isArray(o))
          return t.apply(null, o);
        if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
          return o.toString();
        var i = "";
        for (var a in o)
          e.call(o, a) && o[a] && (i = s(i, a));
        return i;
      }
      function s(o, i) {
        return i ? o ? o + " " + i : o + i : o;
      }
      r.exports ? (t.default = t, r.exports = t) : window.classNames = t;
    })();
  })(or)), or.exports;
}
var yo = vo();
const $e = /* @__PURE__ */ bo(yo);
class oe extends Error {
  constructor(e, t) {
    super(e), this.code = t, this.name = "AuthError";
  }
}
class ln extends oe {
  constructor() {
    super("Token has expired", "TOKEN_EXPIRED");
  }
}
class Rt extends oe {
  constructor(e) {
    super(e || "Token is invalid", "TOKEN_INVALID");
  }
}
class cn extends oe {
  constructor(e) {
    super("Failed to refresh token", "TOKEN_REFRESH_FAILED"), this.innerError = e;
  }
}
class Ss extends oe {
  constructor() {
    super("Auth strategy has not been configured", "STRATEGY_NOT_CONFIGURED");
  }
}
class _o {
  getName() {
    return "null";
  }
  getIdentifier() {
    return null;
  }
  async getAccessToken() {
    throw new Ss();
  }
  async refresh() {
    throw new Ss();
  }
  clear() {
  }
}
class ko {
  constructor() {
    this.strategy = new _o();
  }
  useStrategy(e) {
    this.strategy = e;
  }
  getStrategy() {
    return this.strategy;
  }
  getIdentifier() {
    return this.strategy.getIdentifier();
  }
  getAccessToken() {
    return this.strategy.getAccessToken();
  }
  async refresh() {
    await this.strategy.refresh();
  }
  clear() {
    this.strategy.clear();
  }
}
class xo {
  constructor(e, t) {
    this.parser = e, this.storage = t, this.currentToken = null, this.refreshPromise = null, this.loadFromStorage();
  }
  loadFromStorage() {
    if (this.storage)
      try {
        const e = this.storage.load();
        if (!e) return;
        const t = this.parser.parse(e);
        this.parser.isExpired(t) ? this.storage.clear() : this.currentToken = t;
      } catch {
        this.storage.clear();
      }
  }
  get() {
    return this.currentToken ? this.parser.isExpired(this.currentToken) ? (this.clear(), null) : this.currentToken : null;
  }
  set(e) {
    const t = this.parser.parse(e);
    if (this.parser.isExpired(t))
      throw new ln();
    return this.currentToken = t, this.storage?.save(e), t;
  }
  clear() {
    this.currentToken = null, this.storage?.clear();
  }
  isExpired() {
    return !this.currentToken || this.parser.isExpired(this.currentToken);
  }
  getIdentifier() {
    return this.currentToken?.subject ?? null;
  }
  async refreshWith(e) {
    if (this.refreshPromise) return this.refreshPromise;
    this.refreshPromise = this.performRefresh(e);
    try {
      return await this.refreshPromise;
    } finally {
      this.refreshPromise = null;
    }
  }
  async performRefresh(e) {
    if (!this.isExpired()) return this.currentToken;
    try {
      const t = await e();
      return this.set(t);
    } catch (t) {
      throw this.clear(), t instanceof oe ? t : new cn(t);
    }
  }
}
class hn {
  constructor(e, t) {
    this.parser = e, this.cache = new xo(e, t);
  }
  getIdentifier() {
    return this.cache.getIdentifier();
  }
  async getAccessToken() {
    const e = this.cache.get();
    return e ? e.raw : (await this.refresh(), this.cache.get()?.raw ?? null);
  }
  async refresh() {
    await this.cache.refreshWith(() => this.fetchToken());
  }
  clear() {
    this.cache.clear();
  }
}
class So extends hn {
  constructor(e, t, n) {
    super(t, n), this.baseUrl = e;
  }
  getName() {
    return "visitor";
  }
  async fetchToken() {
    const e = await fetch(`${this.baseUrl}/api/v1/auth/visitor`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });
    if (!e.ok)
      throw new cn(new Error(`HTTP ${e.status}: ${e.statusText}`));
    const t = await e.json();
    if (!t.accessToken)
      throw new Rt("Response missing accessToken");
    return t.accessToken;
  }
}
class To extends hn {
  constructor(e, t) {
    super(t), this.tokenProvider = e;
  }
  getName() {
    return "visma";
  }
  async fetchToken() {
    return this.tokenProvider();
  }
}
class ot extends Error {
}
ot.prototype.name = "InvalidTokenError";
function Eo(r) {
  return decodeURIComponent(atob(r).replace(/(.)/g, (e, t) => {
    let n = t.charCodeAt(0).toString(16).toUpperCase();
    return n.length < 2 && (n = "0" + n), "%" + n;
  }));
}
function Co(r) {
  let e = r.replace(/-/g, "+").replace(/_/g, "/");
  switch (e.length % 4) {
    case 0:
      break;
    case 2:
      e += "==";
      break;
    case 3:
      e += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return Eo(e);
  } catch {
    return atob(e);
  }
}
function Io(r, e) {
  if (typeof r != "string")
    throw new ot("Invalid token specified: must be a string");
  e || (e = {});
  const t = e.header === !0 ? 0 : 1, n = r.split(".")[t];
  if (typeof n != "string")
    throw new ot(`Invalid token specified: missing part #${t + 1}`);
  let s;
  try {
    s = Co(n);
  } catch (o) {
    throw new ot(`Invalid token specified: invalid base64 for part #${t + 1} (${o.message})`);
  }
  try {
    return JSON.parse(s);
  } catch (o) {
    throw new ot(`Invalid token specified: invalid json for part #${t + 1} (${o.message})`);
  }
}
class Ao {
  parse(e) {
    try {
      const t = Io(e);
      if (!t.exp || !t.sub)
        throw new Rt("Missing required claims (exp, sub)");
      return {
        raw: e,
        decoded: t,
        expiresAt: t.exp * 1e3,
        subject: t.sub
      };
    } catch (t) {
      throw t instanceof oe ? t : new Rt("Failed to decode JWT");
    }
  }
  isExpired(e) {
    return e.expiresAt < Date.now();
  }
  getTimeToExpiry(e) {
    return Math.max(0, e.expiresAt - Date.now());
  }
}
class Ro {
  constructor(e) {
    this.config = e;
  }
  create(e, t, n) {
    const s = this.config.parser ?? new Ao();
    switch (e) {
      case "visma":
        if (!t)
          throw new oe(
            "Token provider required for Visma strategy",
            "MISSING_TOKEN_CALLBACK"
          );
        return new To(t, s);
      case "visitor":
        if (!n)
          throw new oe("Base URL required for Visitor strategy", "MISSING_BASE_URL");
        return new So(n, s, this.config.storage);
      default:
        throw new oe(`Unknown strategy type: ${e}`, "UNKNOWN_STRATEGY");
    }
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const br = "lit-localize-status";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const $o = (r, ...e) => ({
  strTag: !0,
  strings: r,
  values: e
}), Po = $o, Mo = (r) => typeof r != "string" && "strTag" in r, dn = (r, e, t) => {
  let n = r[0];
  for (let s = 1; s < r.length; s++)
    n += e[t ? t[s - 1] : s - 1], n += r[s];
  return n;
};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const pn = ((r) => Mo(r) ? dn(r.strings, r.values) : r);
let v = pn, Ts = !1;
function Do(r) {
  if (Ts)
    throw new Error("lit-localize can only be configured once");
  v = r, Ts = !0;
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class Oo {
  constructor(e) {
    this.__litLocalizeEventHandler = (t) => {
      t.detail.status === "ready" && this.host.requestUpdate();
    }, this.host = e;
  }
  hostConnected() {
    window.addEventListener(br, this.__litLocalizeEventHandler);
  }
  hostDisconnected() {
    window.removeEventListener(br, this.__litLocalizeEventHandler);
  }
}
const Lo = (r) => r.addController(new Oo(r)), No = Lo;
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const zo = () => (r, e) => (r.addInitializer(No), r);
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class un {
  constructor() {
    this.settled = !1, this.promise = new Promise((e, t) => {
      this._resolve = e, this._reject = t;
    });
  }
  resolve(e) {
    this.settled = !0, this._resolve(e);
  }
  reject(e) {
    this.settled = !0, this._reject(e);
  }
}
/**
 * @license
 * Copyright 2014 Travis Webb
 * SPDX-License-Identifier: MIT
 */
const fe = [];
for (let r = 0; r < 256; r++)
  fe[r] = (r >> 4 & 15).toString(16) + (r & 15).toString(16);
function Fo(r) {
  let e = 0, t = 8997, n = 0, s = 33826, o = 0, i = 40164, a = 0, c = 52210;
  for (let d = 0; d < r.length; d++)
    t ^= r.charCodeAt(d), e = t * 435, n = s * 435, o = i * 435, a = c * 435, o += t << 8, a += s << 8, n += e >>> 16, t = e & 65535, o += n >>> 16, s = n & 65535, c = a + (o >>> 16) & 65535, i = o & 65535;
  return fe[c >> 8] + fe[c & 255] + fe[i >> 8] + fe[i & 255] + fe[s >> 8] + fe[s & 255] + fe[t >> 8] + fe[t & 255];
}
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Uo = "", Ho = "h", Bo = "s";
function jo(r, e) {
  return (e ? Ho : Bo) + Fo(typeof r == "string" ? r : r.join(Uo));
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Es = /* @__PURE__ */ new WeakMap(), Cs = /* @__PURE__ */ new Map();
function Wo(r, e, t) {
  if (r) {
    const n = t?.id ?? qo(e), s = r[n];
    if (s) {
      if (typeof s == "string")
        return s;
      if ("strTag" in s)
        return dn(
          s.strings,
          // Cast `template` because its type wasn't automatically narrowed (but
          // we know it must be the same type as `localized`).
          e.values,
          s.values
        );
      {
        let o = Es.get(s);
        return o === void 0 && (o = s.values, Es.set(s, o)), {
          ...s,
          values: o.map((i) => e.values[i])
        };
      }
    }
  }
  return pn(e);
}
function qo(r) {
  const e = typeof r == "string" ? r : r.strings;
  let t = Cs.get(e);
  return t === void 0 && (t = jo(e, typeof r != "string" && !("strTag" in r)), Cs.set(e, t)), t;
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function ir(r) {
  window.dispatchEvent(new CustomEvent(br, { detail: r }));
}
let $t = "", ar, gn, Pt, vr, fn, Re = new un();
Re.resolve();
let St = 0;
const Go = (r) => (Do(((e, t) => Wo(fn, e, t))), $t = gn = r.sourceLocale, Pt = new Set(r.targetLocales), Pt.add(r.sourceLocale), vr = r.loadLocale, { getLocale: Vo, setLocale: Yo }), Vo = () => $t, Yo = (r) => {
  if (r === (ar ?? $t))
    return Re.promise;
  if (!Pt || !vr)
    throw new Error("Internal error");
  if (!Pt.has(r))
    throw new Error("Invalid locale code");
  St++;
  const e = St;
  return ar = r, Re.settled && (Re = new un()), ir({ status: "loading", loadingLocale: r }), (r === gn ? (
    // We could switch to the source locale synchronously, but we prefer to
    // queue it on a microtask so that switching locales is consistently
    // asynchronous.
    Promise.resolve({ templates: void 0 })
  ) : vr(r)).then((n) => {
    St === e && ($t = r, ar = void 0, fn = n.templates, ir({ status: "ready", readyLocale: r }), Re.resolve());
  }, (n) => {
    St === e && (ir({
      status: "error",
      errorLocale: r,
      errorMessage: n.toString()
    }), Re.reject(n));
  }), Re.promise;
}, Xo = `/*! tailwindcss v4.1.13 | MIT License | https://tailwindcss.com */@layer properties{@supports (((-webkit-hyphens:none)) and (not (margin-trim:inline))) or ((-moz-orient:inline) and (not (color:rgb(from red r g b)))){*,:before,:after,::backdrop{--tw-rotate-x:initial;--tw-rotate-y:initial;--tw-rotate-z:initial;--tw-skew-x:initial;--tw-skew-y:initial;--tw-space-x-reverse:0;--tw-border-style:solid;--tw-font-weight:initial;--tw-shadow:0 0 #0000;--tw-shadow-color:initial;--tw-shadow-alpha:100%;--tw-inset-shadow:0 0 #0000;--tw-inset-shadow-color:initial;--tw-inset-shadow-alpha:100%;--tw-ring-color:initial;--tw-ring-shadow:0 0 #0000;--tw-inset-ring-color:initial;--tw-inset-ring-shadow:0 0 #0000;--tw-ring-inset:initial;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-offset-shadow:0 0 #0000;--tw-outline-style:solid;--tw-duration:initial;--tw-ease:initial}}}@layer theme{:root,:host{--font-mono:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;--color-red-100:#fcf1ee;--color-red-600:#cc453e;--color-green-100:#eef5ee;--color-green-600:#448548;--color-blue-100:#edf4fe;--color-gray-200:oklch(92.8% .006 264.531);--color-gray-500:oklch(55.1% .027 264.364);--color-neutral-100:#f2f3f5;--color-neutral-200:#e2e4e9;--color-neutral-300:#cccfd7;--color-neutral-600:#6f7687;--color-neutral-700:oklch(37.1% 0 0);--spacing: 4px ;--container-2xl: 672px ;--text-xs: 12px ;--text-xs--line-height:calc(1/.75);--text-sm: 14px ;--text-sm--line-height:calc(1.25/.875);--text-lg: 18px ;--text-lg--line-height:calc(1.75/1.125);--font-weight-medium:500;--font-weight-semibold:600;--font-weight-bold:700;--radius-sm: 4px ;--ease-in-out:cubic-bezier(.4,0,.2,1);--animate-spin:spin 1s linear infinite;--animate-pulse:pulse 2s cubic-bezier(.4,0,.6,1)infinite;--default-transition-duration:.15s;--default-transition-timing-function:cubic-bezier(.4,0,.2,1);--default-font-family:"Inter",sans-serif;--default-mono-font-family:var(--font-mono);--color-primary-600:#377ea0;--color-primary-800:#1f4e66;--color-primary-900:#133445;--color-secondary-100:#fcf0e7;--color-secondary-200:#fae0ce;--color-utility-gray:#b9b9b9;--scrollbar-color-default:var(--color-neutral-300);--scrollbar-color-hover:var(--color-neutral-600);--tw-inset-shadow:0 0 #0000;--tw-inset-ring-shadow:0 0 #0000;--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-outline-style:solid}}@layer base{*,:after,:before,::backdrop{box-sizing:border-box;border:0 solid;margin:0;padding:0}::file-selector-button{box-sizing:border-box;border:0 solid;margin:0;padding:0}html,:host{-webkit-text-size-adjust:100%;tab-size:4;line-height:1.5;font-family:var(--default-font-family,ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji");font-feature-settings:var(--default-font-feature-settings,normal);font-variation-settings:var(--default-font-variation-settings,normal);-webkit-tap-highlight-color:transparent}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;-webkit-text-decoration:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:var(--default-mono-font-family,ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace);font-feature-settings:var(--default-mono-font-feature-settings,normal);font-variation-settings:var(--default-mono-font-variation-settings,normal);font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}:-moz-focusring{outline:auto}progress{vertical-align:baseline}summary{display:list-item}ol,ul,menu{list-style:none}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}button,input,select,optgroup,textarea{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}::file-selector-button{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}:where(select:is([multiple],[size])) optgroup{font-weight:bolder}:where(select:is([multiple],[size])) optgroup option{padding-inline-start:20px}::file-selector-button{margin-inline-end:4px}::placeholder{opacity:1}@supports (not ((-webkit-appearance:-apple-pay-button))) or (contain-intrinsic-size:1px){::placeholder{color:currentColor}@supports (color:color-mix(in lab,red,red)){::placeholder{color:color-mix(in oklab,currentcolor 50%,transparent)}}}textarea{resize:vertical}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-date-and-time-value{min-height:1lh;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-datetime-edit{padding-block:0}::-webkit-datetime-edit-year-field{padding-block:0}::-webkit-datetime-edit-month-field{padding-block:0}::-webkit-datetime-edit-day-field{padding-block:0}::-webkit-datetime-edit-hour-field{padding-block:0}::-webkit-datetime-edit-minute-field{padding-block:0}::-webkit-datetime-edit-second-field{padding-block:0}::-webkit-datetime-edit-millisecond-field{padding-block:0}::-webkit-datetime-edit-meridiem-field{padding-block:0}::-webkit-calendar-picker-indicator{line-height:1}:-moz-ui-invalid{box-shadow:none}button,input:where([type=button],[type=reset],[type=submit]){appearance:button}::file-selector-button{appearance:button}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[hidden]:where(:not([hidden=until-found])){display:none!important}:root,:host,html{font-size:16px}[role=button]:not(:disabled),button:not(:disabled){cursor:pointer}}@layer components{.btn{font-size:var(--text-xs);line-height:var(--tw-leading,var(--text-xs--line-height));z-index:0;white-space:nowrap;cursor:pointer;-webkit-user-select:none;user-select:none;outline-offset:4px;border-radius:4px;outline-width:2px;justify-content:center;align-items:center;transition:all .2s ease-in-out;display:flex;position:relative}.btn:disabled{pointer-events:none}.btn-primary{background-color:var(--color-primary-800);color:var(--color-secondary-100);outline-color:var(--color-primary-800)}@media (hover:hover){.btn-primary:hover{background-color:var(--color-primary-900)}}.btn-primary:disabled{background-color:var(--color-gray-200);color:var(--color-gray-500)}.btn-primary svg{color:var(--color-secondary-200)}.btn-primary:disabled{border-color:var(--color-neutral-200);background-color:var(--color-neutral-200);color:var(--color-neutral-600)}.btn-primary:disabled svg{color:var(--color-neutral-600)}.btn-secondary{border-style:var(--tw-border-style);--tw-border-style:solid;border-style:solid;border-width:1px;border-color:var(--color-primary-800);color:var(--color-primary-800);outline-color:var(--color-primary-800)}@media (hover:hover){.btn-secondary:hover{background-color:var(--color-secondary-200);color:var(--color-primary-900)}}.btn-secondary svg{color:var(--color-primary-800)}@media (hover:hover){.btn-secondary:hover svg{color:var(--color-primary-600)}}.btn-secondary:disabled{border-color:var(--color-neutral-300);background-color:var(--color-neutral-100);color:var(--color-utility-gray)}.btn-secondary:disabled svg{color:var(--color-neutral-600)}.btn-ghost{border-style:var(--tw-border-style);--tw-border-style:solid;outline-color:var(--color-primary-800);background-color:#0000;border:1px solid #0000}@media (hover:hover){.btn-ghost:hover{border-color:var(--color-primary-600);color:var(--color-primary-900);background-color:#0000}}.btn-ghost svg{color:var(--color-primary-800)}@media (hover:hover){.btn-ghost:hover svg{color:var(--color-primary-600)}}.btn-ghost:disabled{color:var(--color-utility-gray)}.btn-ghost:disabled svg{color:var(--color-neutral-300)}.prose>:last-child,.prose>:last-child table,.prose>:last-child pre{margin-bottom:0!important}.text-shimmer-primary{--shimmer-color:var(--color-primary-900);--shimmer-contrast:oklch(60% 0 0)}.text-shimmer{color:#0000;background:var(--shimmer-color)linear-gradient(to right,var(--shimmer-color)0,var(--shimmer-contrast)40%,var(--shimmer-contrast)60%,var(--shimmer-color)100%);background:var(--shimmer-color)-webkit-gradient(linear,100% 0,0 0,from(var(--shimmer-color)),color-stop(.4,var(--shimmer-contrast)),color-stop(.6,var(--shimmer-contrast)),to(var(--shimmer-color)));-webkit-text-fill-color:transparent;background-repeat:no-repeat;background-size:50% 200%;-webkit-background-clip:text;background-clip:text;animation-name:loading-shimmer;animation-duration:3s;animation-iteration-count:infinite;animation-delay:.1s;display:inline-block}.animate-grow{opacity:.3;animation-name:grow;animation-duration:1.5s;animation-timing-function:ease-in-out;animation-iteration-count:infinite;animation-delay:0s}.skeleton{animation:var(--animate-pulse);border-radius:var(--radius-sm);background-color:var(--color-neutral-200)}}@layer utilities{.\\@container\\/main{container:main/inline-size}.invisible{visibility:hidden}.visible{visibility:visible}.absolute{position:absolute}.fixed{position:fixed}.relative{position:relative}.inset-0{inset:calc(var(--spacing)*0)}.bottom-0{bottom:calc(var(--spacing)*0)}.left-1\\/2{left:50%}.z-50{z-index:50}.container{width:100%}@media (min-width:640px){.container{max-width:640px}}@media (min-width:768px){.container{max-width:768px}}@media (min-width:1024px){.container{max-width:1024px}}@media (min-width:1280px){.container{max-width:1280px}}@media (min-width:1536px){.container{max-width:1536px}}.m-0{margin:calc(var(--spacing)*0)}.m-4{margin:calc(var(--spacing)*4)}.mx-auto{margin-inline:auto}.my-1{margin-block:calc(var(--spacing)*1)}.my-auto{margin-block:auto}.prose{color:var(--tw-prose-body);max-width:65ch}.prose :where(p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em;margin-bottom:1.25em}.prose :where([class~=lead]):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-lead);margin-top:1.2em;margin-bottom:1.2em;font-size:1.25em;line-height:1.6}.prose :where(a):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-links);font-weight:500;text-decoration:underline}.prose :where(strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-bold);font-weight:600}.prose :where(a strong):not(:where([class~=not-prose],[class~=not-prose] *)),.prose :where(blockquote strong):not(:where([class~=not-prose],[class~=not-prose] *)),.prose :where(thead th strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(ol):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em;margin-bottom:1.25em;padding-inline-start:1.625em;list-style-type:decimal}.prose :where(ol[type=A]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-alpha}.prose :where(ol[type=a]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-alpha}.prose :where(ol[type=A s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-alpha}.prose :where(ol[type=a s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-alpha}.prose :where(ol[type=I]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-roman}.prose :where(ol[type=i]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-roman}.prose :where(ol[type=I s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-roman}.prose :where(ol[type=i s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-roman}.prose :where(ol[type="1"]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:decimal}.prose :where(ul):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em;margin-bottom:1.25em;padding-inline-start:1.625em;list-style-type:disc}.prose :where(ol>li):not(:where([class~=not-prose],[class~=not-prose] *))::marker{color:var(--tw-prose-counters);font-weight:400}.prose :where(ul>li):not(:where([class~=not-prose],[class~=not-prose] *))::marker{color:var(--tw-prose-bullets)}.prose :where(dt):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);margin-top:1.25em;font-weight:600}.prose :where(hr):not(:where([class~=not-prose],[class~=not-prose] *)){border-color:var(--tw-prose-hr);border-top-width:1px;margin-top:3em;margin-bottom:3em}.prose :where(blockquote):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-quotes);border-inline-start-width:.25rem;border-inline-start-color:var(--tw-prose-quote-borders);quotes:"“""”""‘""’";margin-top:1.6em;margin-bottom:1.6em;padding-inline-start:1em;font-style:italic;font-weight:500}.prose :where(blockquote p:first-of-type):not(:where([class~=not-prose],[class~=not-prose] *)):before{content:open-quote}.prose :where(blockquote p:last-of-type):not(:where([class~=not-prose],[class~=not-prose] *)):after{content:close-quote}.prose :where(h1):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);margin-top:0;margin-bottom:.888889em;font-size:2.25em;font-weight:800;line-height:1.11111}.prose :where(h1 strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-weight:900}.prose :where(h2):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);margin-top:2em;margin-bottom:1em;font-size:1.5em;font-weight:700;line-height:1.33333}.prose :where(h2 strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-weight:800}.prose :where(h3):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);margin-top:1.6em;margin-bottom:.6em;font-size:1.25em;font-weight:600;line-height:1.6}.prose :where(h3 strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-weight:700}.prose :where(h4):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);margin-top:1.5em;margin-bottom:.5em;font-weight:600;line-height:1.5}.prose :where(h4 strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-weight:700}.prose :where(img):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:2em;margin-bottom:2em}.prose :where(picture):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:2em;margin-bottom:2em;display:block}.prose :where(video):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:2em;margin-bottom:2em}.prose :where(kbd):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-kbd);box-shadow:0 0 0 1px var(--tw-prose-kbd-shadows),0 3px 0 var(--tw-prose-kbd-shadows);padding-top:.1875em;padding-inline-end:.375em;padding-bottom:.1875em;border-radius:.3125rem;padding-inline-start:.375em;font-family:inherit;font-size:.875em;font-weight:500}.prose :where(code):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-code);font-size:.875em;font-weight:600}.prose :where(code):not(:where([class~=not-prose],[class~=not-prose] *)):before,.prose :where(code):not(:where([class~=not-prose],[class~=not-prose] *)):after{content:"\`"}.prose :where(a code):not(:where([class~=not-prose],[class~=not-prose] *)),.prose :where(h1 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(h2 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-size:.875em}.prose :where(h3 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-size:.9em}.prose :where(h4 code):not(:where([class~=not-prose],[class~=not-prose] *)),.prose :where(blockquote code):not(:where([class~=not-prose],[class~=not-prose] *)),.prose :where(thead th code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(pre):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-pre-code);background-color:var(--tw-prose-pre-bg);padding-top:.857143em;padding-inline-end:1.14286em;padding-bottom:.857143em;border-radius:.375rem;margin-top:1.71429em;margin-bottom:1.71429em;padding-inline-start:1.14286em;font-size:.875em;font-weight:400;line-height:1.71429;overflow-x:auto}.prose :where(pre code):not(:where([class~=not-prose],[class~=not-prose] *)){font-weight:inherit;color:inherit;font-size:inherit;font-family:inherit;line-height:inherit;background-color:#0000;border-width:0;border-radius:0;padding:0}.prose :where(pre code):not(:where([class~=not-prose],[class~=not-prose] *)):before,.prose :where(pre code):not(:where([class~=not-prose],[class~=not-prose] *)):after{content:none}.prose :where(table):not(:where([class~=not-prose],[class~=not-prose] *)){table-layout:auto;width:100%;margin-top:2em;margin-bottom:2em;font-size:.875em;line-height:1.71429}.prose :where(thead):not(:where([class~=not-prose],[class~=not-prose] *)){border-bottom-width:1px;border-bottom-color:var(--tw-prose-th-borders)}.prose :where(thead th):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);vertical-align:bottom;padding-inline-end:.571429em;padding-bottom:.571429em;padding-inline-start:.571429em;font-weight:600}.prose :where(tbody tr):not(:where([class~=not-prose],[class~=not-prose] *)){border-bottom-width:1px;border-bottom-color:var(--tw-prose-td-borders)}.prose :where(tbody tr:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){border-bottom-width:0}.prose :where(tbody td):not(:where([class~=not-prose],[class~=not-prose] *)){vertical-align:baseline}.prose :where(tfoot):not(:where([class~=not-prose],[class~=not-prose] *)){border-top-width:1px;border-top-color:var(--tw-prose-th-borders)}.prose :where(tfoot td):not(:where([class~=not-prose],[class~=not-prose] *)){vertical-align:top}.prose :where(th,td):not(:where([class~=not-prose],[class~=not-prose] *)){text-align:start}.prose :where(figure>*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0;margin-bottom:0}.prose :where(figcaption):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-captions);margin-top:.857143em;font-size:.875em;line-height:1.42857}.prose{--tw-prose-body:oklch(37.3% .034 259.733);--tw-prose-headings:oklch(21% .034 264.665);--tw-prose-lead:oklch(44.6% .03 256.802);--tw-prose-links:oklch(21% .034 264.665);--tw-prose-bold:oklch(21% .034 264.665);--tw-prose-counters:oklch(55.1% .027 264.364);--tw-prose-bullets:oklch(87.2% .01 258.338);--tw-prose-hr:oklch(92.8% .006 264.531);--tw-prose-quotes:oklch(21% .034 264.665);--tw-prose-quote-borders:oklch(92.8% .006 264.531);--tw-prose-captions:oklch(55.1% .027 264.364);--tw-prose-kbd:oklch(21% .034 264.665);--tw-prose-kbd-shadows:oklab(21% -.00316127 -.0338527/.1);--tw-prose-code:oklch(21% .034 264.665);--tw-prose-pre-code:oklch(92.8% .006 264.531);--tw-prose-pre-bg:oklch(27.8% .033 256.848);--tw-prose-th-borders:oklch(87.2% .01 258.338);--tw-prose-td-borders:oklch(92.8% .006 264.531);--tw-prose-invert-body:oklch(87.2% .01 258.338);--tw-prose-invert-headings:#fff;--tw-prose-invert-lead:oklch(70.7% .022 261.325);--tw-prose-invert-links:#fff;--tw-prose-invert-bold:#fff;--tw-prose-invert-counters:oklch(70.7% .022 261.325);--tw-prose-invert-bullets:oklch(44.6% .03 256.802);--tw-prose-invert-hr:oklch(37.3% .034 259.733);--tw-prose-invert-quotes:oklch(96.7% .003 264.542);--tw-prose-invert-quote-borders:oklch(37.3% .034 259.733);--tw-prose-invert-captions:oklch(70.7% .022 261.325);--tw-prose-invert-kbd:#fff;--tw-prose-invert-kbd-shadows:#ffffff1a;--tw-prose-invert-code:#fff;--tw-prose-invert-pre-code:oklch(87.2% .01 258.338);--tw-prose-invert-pre-bg:#00000080;--tw-prose-invert-th-borders:oklch(44.6% .03 256.802);--tw-prose-invert-td-borders:oklch(37.3% .034 259.733);font-size:1rem;line-height:1.75}.prose :where(picture>img):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0;margin-bottom:0}.prose :where(li):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.5em;margin-bottom:.5em}.prose :where(ol>li):not(:where([class~=not-prose],[class~=not-prose] *)),.prose :where(ul>li):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:.375em}.prose :where(.prose>ul>li p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.75em;margin-bottom:.75em}.prose :where(.prose>ul>li>p:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em}.prose :where(.prose>ul>li>p:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em}.prose :where(.prose>ol>li>p:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em}.prose :where(.prose>ol>li>p:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em}.prose :where(ul ul,ul ol,ol ul,ol ol):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.75em;margin-bottom:.75em}.prose :where(dl):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em;margin-bottom:1.25em}.prose :where(dd):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.5em;padding-inline-start:1.625em}.prose :where(hr+*):not(:where([class~=not-prose],[class~=not-prose] *)),.prose :where(h2+*):not(:where([class~=not-prose],[class~=not-prose] *)),.prose :where(h3+*):not(:where([class~=not-prose],[class~=not-prose] *)),.prose :where(h4+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(thead th:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:0}.prose :where(thead th:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-end:0}.prose :where(tbody td,tfoot td):not(:where([class~=not-prose],[class~=not-prose] *)){padding-top:.571429em;padding-inline-end:.571429em;padding-bottom:.571429em;padding-inline-start:.571429em}.prose :where(tbody td:first-child,tfoot td:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-start:0}.prose :where(tbody td:last-child,tfoot td:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-inline-end:0}.prose :where(figure):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:2em;margin-bottom:2em}.prose :where(.prose>:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(.prose>:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:0}.mt-2{margin-top:calc(var(--spacing)*2)}.mt-3{margin-top:calc(var(--spacing)*3)}.mr-4{margin-right:calc(var(--spacing)*4)}.mb-1{margin-bottom:calc(var(--spacing)*1)}.block{display:block}.flex{display:flex}.grid{display:grid}.hidden{display:none}.inline{display:inline}.table{display:table}.aspect-square{aspect-ratio:1}.size-4{width:calc(var(--spacing)*4);height:calc(var(--spacing)*4)}.size-5{width:calc(var(--spacing)*5);height:calc(var(--spacing)*5)}.size-6{width:calc(var(--spacing)*6);height:calc(var(--spacing)*6)}.size-8{width:calc(var(--spacing)*8);height:calc(var(--spacing)*8)}.h-0{height:calc(var(--spacing)*0)}.h-2{height:calc(var(--spacing)*2)}.h-4{height:calc(var(--spacing)*4)}.h-5{height:calc(var(--spacing)*5)}.h-6{height:calc(var(--spacing)*6)}.h-14{height:calc(var(--spacing)*14)}.h-24{height:calc(var(--spacing)*24)}.h-\\[18\\.4px\\]{height:18.4px}.h-auto{height:auto}.h-full{height:100%}.min-h-8{min-height:calc(var(--spacing)*8)}.min-h-9{min-height:calc(var(--spacing)*9)}.min-h-full{min-height:100%}.w-2{width:calc(var(--spacing)*2)}.w-fit{width:fit-content}.w-full{width:100%}.max-w-2xl{max-width:var(--container-2xl)}.max-w-\\[90\\%\\]{max-width:90%}.max-w-\\[calc\\(100\\%-80px\\)\\]{max-width:calc(100% - 80px)}.max-w-full{max-width:100%}.min-w-0{min-width:calc(var(--spacing)*0)}.flex-grow-1{flex-grow:1}.basis-auto{flex-basis:auto}.transform{transform:var(--tw-rotate-x,)var(--tw-rotate-y,)var(--tw-rotate-z,)var(--tw-skew-x,)var(--tw-skew-y,)}.animate-spin{animation:var(--animate-spin)}.resize-none{resize:none}.grid-cols-\\[auto_1fr_auto\\]{grid-template-columns:auto 1fr auto}.\\[grid-template-rows\\:auto_1fr_auto\\]{grid-template-rows:auto 1fr auto}.flex-col{flex-direction:column}.flex-col-reverse{flex-direction:column-reverse}.flex-row{flex-direction:row}.items-center{align-items:center}.items-end{align-items:flex-end}.items-start{align-items:flex-start}.justify-between{justify-content:space-between}.justify-center{justify-content:center}.justify-end{justify-content:flex-end}.justify-start{justify-content:flex-start}.gap-0{gap:calc(var(--spacing)*0)}.gap-1{gap:calc(var(--spacing)*1)}.gap-2{gap:calc(var(--spacing)*2)}.gap-4{gap:calc(var(--spacing)*4)}.gap-x-2{column-gap:calc(var(--spacing)*2)}:where(.space-x-1>:not(:last-child)){--tw-space-x-reverse:0;margin-inline-start:calc(calc(var(--spacing)*1)*var(--tw-space-x-reverse));margin-inline-end:calc(calc(var(--spacing)*1)*calc(1 - var(--tw-space-x-reverse)))}.gap-y-1{row-gap:calc(var(--spacing)*1)}.gap-y-4{row-gap:calc(var(--spacing)*4)}.gap-y-8{row-gap:calc(var(--spacing)*8)}.self-start{align-self:flex-start}.truncate{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.overflow-hidden{overflow:hidden}.overflow-x-auto{overflow-x:auto}.overflow-x-clip{overflow-x:clip}.overflow-x-hidden{overflow-x:hidden}.overflow-y-auto{overflow-y:auto}.rounded-full{border-radius:3.40282e38px}.rounded-sm{border-radius:var(--radius-sm)}.border{border-style:var(--tw-border-style);border-width:1px}.border-b{border-bottom-style:var(--tw-border-style);border-bottom-width:1px}.border-solid{--tw-border-style:solid;border-style:solid}.border-green-600{border-color:var(--color-green-600)}.border-neutral-300{border-color:var(--color-neutral-300)}.border-neutral-600{border-color:var(--color-neutral-600)}.border-red-600{border-color:var(--color-red-600)}.bg-blue-100{background-color:var(--color-blue-100)}.bg-green-100{background-color:var(--color-green-100)}.bg-neutral-100{background-color:var(--color-neutral-100)}.bg-neutral-600{background-color:var(--color-neutral-600)}.bg-red-100{background-color:var(--color-red-100)}.bg-secondary-200{background-color:var(--color-secondary-200)}.object-cover{object-fit:cover}.p-0\\.5{padding:calc(var(--spacing)*.5)}.p-1{padding:calc(var(--spacing)*1)}.p-2{padding:calc(var(--spacing)*2)}.p-4{padding:calc(var(--spacing)*4)}.px-1\\.5{padding-inline:calc(var(--spacing)*1.5)}.px-2{padding-inline:calc(var(--spacing)*2)}.px-3{padding-inline:calc(var(--spacing)*3)}.px-4{padding-inline:calc(var(--spacing)*4)}.py-1\\.5{padding-block:calc(var(--spacing)*1.5)}.py-2{padding-block:calc(var(--spacing)*2)}.py-3{padding-block:calc(var(--spacing)*3)}.pt-2{padding-top:calc(var(--spacing)*2)}.pb-1{padding-bottom:calc(var(--spacing)*1)}.pb-2{padding-bottom:calc(var(--spacing)*2)}.text-center{text-align:center}.text-start{text-align:start}.text-lg{font-size:var(--text-lg);line-height:var(--tw-leading,var(--text-lg--line-height))}.text-sm{font-size:var(--text-sm);line-height:var(--tw-leading,var(--text-sm--line-height))}.text-xs{font-size:var(--text-xs);line-height:var(--tw-leading,var(--text-xs--line-height))}.font-bold{--tw-font-weight:var(--font-weight-bold);font-weight:var(--font-weight-bold)}.font-medium{--tw-font-weight:var(--font-weight-medium);font-weight:var(--font-weight-medium)}.font-semibold{--tw-font-weight:var(--font-weight-semibold);font-weight:var(--font-weight-semibold)}.text-wrap{text-wrap:wrap}.break-words{overflow-wrap:break-word}.whitespace-normal{white-space:normal}.whitespace-pre-wrap{white-space:pre-wrap}.text-neutral-600{color:var(--color-neutral-600)}.text-neutral-700{color:var(--color-neutral-700)}.text-primary-800{color:var(--color-primary-800)}.text-primary-900{color:var(--color-primary-900)}.text-red-600{color:var(--color-red-600)}.opacity-0{opacity:0}.opacity-100{opacity:1}.shadow-md{--tw-shadow:0 4px 6px -1px var(--tw-shadow-color,#0000001a),0 2px 4px -2px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.outline-2{outline-style:var(--tw-outline-style);outline-width:2px}.outline-primary-800{outline-color:var(--color-primary-800)}.transition-\\[transform\\,opacity\\,height\\,visibility\\]{transition-property:transform,opacity,height,visibility;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.transition-transform{transition-property:transform,translate,scale,rotate;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.duration-200{--tw-duration:.2s;transition-duration:.2s}.ease-in-out{--tw-ease:var(--ease-in-out);transition-timing-function:var(--ease-in-out)}.outline-none{--tw-outline-style:none;outline-style:none}.select-none{-webkit-user-select:none;user-select:none}.\\[-webkit-mask\\:radial-gradient\\(farthest-side\\,transparent_calc\\(100\\%-3px\\)\\,\\#000_0\\)\\]{-webkit-mask:radial-gradient(farthest-side,#0000 calc(100% - 3px),#000 0)}.\\[animation-delay\\:0\\.3s\\]{animation-delay:.3s}.\\[animation-delay\\:0\\.6s\\]{animation-delay:.6s}.\\[background\\:conic-gradient\\(theme\\(colors\\.primary-600\\)_0_30\\%\\,transparent_30\\%_100\\%\\)\\]{background:conic-gradient(#377ea0 0 30%,transparent 30% 100%)}.\\[grid-area\\:content\\]{grid-area:content}.\\[grid-area\\:footer\\]{grid-area:footer}.\\[grid-area\\:header\\]{grid-area:header}.\\[grid-area\\:leading\\]{grid-area:leading}.\\[grid-area\\:primary\\]{grid-area:primary}.\\[grid-area\\:trailing\\]{grid-area:trailing}.\\[grid-template-areas\\:\\'header\\'\\'content\\'\\'footer\\'\\]{grid-template-areas:"header""content""footer"}.\\[grid-template-areas\\:\\'header_header_header\\'_\\'leading_primary_trailing\\'_\\'\\._footer_\\.\\'\\]{grid-template-areas:"header header header""leading primary trailing"".footer."}.\\[grid-template-areas\\:\\'leading_primary\\'\\]{grid-template-areas:"leading primary"}.\\[grid-template-areas\\:\\'leading_primary_trailing\\'\\]{grid-template-areas:"leading primary trailing"}.\\[mask\\:radial-gradient\\(farthest-side\\,transparent_calc\\(100\\%-3px\\)\\,\\#000_0\\)\\]{-webkit-mask:radial-gradient(farthest-side,#0000 calc(100% - 3px),#000 0);mask:radial-gradient(farthest-side,#0000 calc(100% - 3px),#000 0)}.not-group-aria-expanded\\:-rotate-90:not(:is(:where(.group)[aria-expanded=true] *)){rotate:-90deg}.group-focus-within\\/composer\\:outline-solid:is(:where(.group\\/composer):focus-within *){--tw-outline-style:solid;outline-style:solid}.group-data-expanded\\/composer\\:\\[grid-template-areas\\:\\'header_header_header\\'_\\'primary_primary_primary\\'_\\'leading_footer_trailing\\'\\]:is(:where(.group\\/composer)[data-expanded] *){grid-template-areas:"header header header""primary primary primary""leading footer trailing"}.group-data-\\[error\\=true\\]\\/composer\\:border-red-600:is(:where(.group\\/composer)[data-error=true] *){border-color:var(--color-red-600)}.group-data-\\[error\\=true\\]\\/composer\\:bg-red-100:is(:where(.group\\/composer)[data-error=true] *){background-color:var(--color-red-100)}.group-data-\\[error\\=true\\]\\/composer\\:outline-red-600:is(:where(.group\\/composer)[data-error=true] *){outline-color:var(--color-red-600)}.placeholder\\:text-utility-gray::placeholder{color:var(--color-utility-gray)}.empty\\:hidden:empty{display:none}@media (hover:hover){.hover\\:text-primary-900:hover{color:var(--color-primary-900)}.hover\\:underline:hover{text-decoration-line:underline}}.active\\:outline-2:active{outline-style:var(--tw-outline-style);outline-width:2px}.data-\\[loading\\=true\\]\\:bg-transparent[data-loading=true]{background-color:#0000}.data-\\[selected\\=true\\]\\:bg-secondary-200[data-selected=true]{background-color:var(--color-secondary-200)}.data-\\[selected\\=true\\]\\:text-primary-900[data-selected=true]{color:var(--color-primary-900)}@container (min-width:320px){.\\@xs\\:flex{display:flex}}@container (min-width:448px){.\\@md\\:w-1\\/2{width:50%}.\\@md\\:w-36{width:calc(var(--spacing)*36)}.\\@md\\:w-\\[90\\%\\]{width:90%}.\\@md\\:flex-row{flex-direction:row}}@container main (min-width:512px){.\\@lg\\/main\\:px-4{padding-inline:calc(var(--spacing)*4)}}@container (min-width:576px){.\\@xl\\:grid{display:grid}.\\@xl\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}}.prose-table\\:min-w-max :where(table):not(:where([class~=not-prose],[class~=not-prose] *)){min-width:max-content}.\\[\\&_svg\\]\\:text-green-600 svg{color:var(--color-green-600)}.\\[\\&_svg\\]\\:text-red-600 svg{color:var(--color-red-600)}.text-message{font-size:14px;line-height:1.7143}}@layer scroll{.overflow-auto:hover,.overflow-scroll:hover,.overflow-x-auto:hover,.overflow-y-auto:hover,textarea:hover{scrollbar-color:var(--scrollbar-color-hover)transparent}.overflow-auto,.overflow-scroll,.overflow-x-auto,.overflow-y-auto,textarea{scrollbar-gutter:stable both-edges;scrollbar-color:var(--scrollbar-color-default)transparent;scrollbar-width:thin;padding-inline:4px}:host-context([data-platform="windows"]) .overflow-scroll{padding-inline:0}:host-context([data-platform="windows"]) .overflow-x-auto{padding-inline:0}:host-context([data-platform="windows"]) .overflow-y-auto{padding-inline:0}:host-context([data-platform="windows"]) textarea{padding-inline:0}}@keyframes loading-shimmer{0%{background-position:-100% 0}to{background-position:250% 0}}@keyframes grow{0%{opacity:.3;transform:scale(.8)}40%{opacity:1;transform:scale(1)}80%{opacity:.3;transform:scale(.8)}to{opacity:.3;transform:scale(.8)}}:host{box-sizing:border-box}.prose-gaia{--tw-prose-body:var(--color-primary-900);--tw-prose-headings:var(--color-primary-900);--tw-prose-lead:var(--color-primary-900);--tw-prose-links:var(--color-primary-800);--tw-prose-bold:var(--color-primary-900);--tw-prose-counters:var(--color-primary-900);--tw-prose-bullets:var(--color-primary-900);--tw-prose-hr:var(--color-neutral-300);--tw-prose-quotes:var(--color-primary-800);--tw-prose-quote-borders:var(--color-neutral-300);--tw-prose-captions:var(--color-primary-900);--tw-prose-kbd:var(--color-primary-900);--tw-prose-kbd-shadows:0 0 0;--tw-prose-code:var(--color-primary-900);--tw-prose-pre-code:oklch(92.8% .006 264.531);--tw-prose-pre-bg:oklch(27.8% .033 256.848);--tw-prose-th-borders:var(--color-neutral-300);--tw-prose-td-borders:var(--color-neutral-200);width:100%;max-width:unset;overflow-wrap:break-word;font-size:14px;line-height:1.7143}svg{width:inherit;height:inherit}@property --tw-rotate-x{syntax:"*";inherits:false}@property --tw-rotate-y{syntax:"*";inherits:false}@property --tw-rotate-z{syntax:"*";inherits:false}@property --tw-skew-x{syntax:"*";inherits:false}@property --tw-skew-y{syntax:"*";inherits:false}@property --tw-space-x-reverse{syntax:"*";inherits:false;initial-value:0}@property --tw-border-style{syntax:"*";inherits:false;initial-value:solid}@property --tw-font-weight{syntax:"*";inherits:false}@property --tw-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-shadow-color{syntax:"*";inherits:false}@property --tw-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-inset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-shadow-color{syntax:"*";inherits:false}@property --tw-inset-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-ring-color{syntax:"*";inherits:false}@property --tw-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-ring-color{syntax:"*";inherits:false}@property --tw-inset-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-ring-inset{syntax:"*";inherits:false}@property --tw-ring-offset-width{syntax:"<length>";inherits:false;initial-value:0}@property --tw-ring-offset-color{syntax:"*";inherits:false;initial-value:#fff}@property --tw-ring-offset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-outline-style{syntax:"*";inherits:false;initial-value:solid}@property --tw-duration{syntax:"*";inherits:false}@property --tw-ease{syntax:"*";inherits:false}@keyframes spin{to{transform:rotate(360deg)}}@keyframes pulse{50%{opacity:.5}}`;
var Zo = Object.getOwnPropertyDescriptor, Ko = (r, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? Zo(e, t) : e, o = r.length - 1, i; o >= 0; o--)
    (i = r[o]) && (s = i(s) || s);
  return s;
};
let ie = class extends po {
  connectedCallback() {
    super.connectedCallback(), this.shadowRoot && uo(this.shadowRoot, [go(Xo), ...this.shadowRoot.adoptedStyleSheets]);
  }
};
ie = Ko([
  zo()
], ie);
const Jo = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-up-icon lucide-arrow-up"><path d="m5 12 7-7 7 7"/><path d="M12 19V5"/></svg>', $r = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-alert-icon lucide-circle-alert"><circle cx="12" cy="12" r="10"/><line x1="12" x2="12" y1="8" y2="12"/><line x1="12" x2="12.01" y1="16" y2="16"/></svg>';
class Qo extends CustomEvent {
  constructor(e) {
    super("send-message", {
      detail: { message: e },
      composed: !0
    });
  }
}
class ei extends CustomEvent {
  constructor(e, t) {
    super("approve-tool-call", {
      detail: { turnId: e, messageId: t },
      composed: !0
    });
  }
}
class ti extends CustomEvent {
  constructor(e, t) {
    super("decline-tool-call", {
      detail: { turnId: e, messageId: t },
      composed: !0
    });
  }
}
class ri extends CustomEvent {
  constructor(e, t, n) {
    super("submit-feedback", { detail: { target: e, rating: t, comment: n }, composed: !0 });
  }
}
class Pr extends CustomEvent {
  constructor(e) {
    super("toggle-feedback-form", { detail: { target: e }, composed: !0 });
  }
}
class Mr extends CustomEvent {
  constructor() {
    super("clear-conversation", { composed: !0 });
  }
}
class si extends CustomEvent {
  constructor() {
    super("clear-error", { composed: !0 });
  }
}
class ni extends CustomEvent {
  constructor() {
    super("send-typing", { composed: !0 });
  }
}
class oi extends CustomEvent {
  constructor() {
    super("close-chat", { composed: !0 });
  }
}
var ii = Object.defineProperty, ai = Object.getOwnPropertyDescriptor, Le = (r, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? ai(e, t) : e, o = r.length - 1, i; o >= 0; o--)
    (i = r[o]) && (s = (n ? i(e, t, s) : i(s)) || s);
  return n && s && ii(e, t, s), s;
};
let ke = class extends ie {
  constructor() {
    super(...arguments), this.maxHeightPx = 192, this.typingThrottleMs = 2e3, this.lastTypingSent = 0, this.maxInputLength = 100, this.disabled = !1, this.loading = !1, this.text = "", this.error = "";
  }
  get canSubmit() {
    return this.text.trim() !== "" && !this.loading && !this.hasError && !this.disabled;
  }
  get hasError() {
    return this.error.length > 0;
  }
  validateInput() {
    this.text.length > this.maxInputLength ? this.error = v("Character limit exceeded.", { id: "composer-error-character-limit" }) : this.error = "";
  }
  sendMessage() {
    this.canSubmit && (this.dispatchEvent(new Qo(this.text)), this.text = "", this.textarea.style.height = "auto");
  }
  onKeyDown(r) {
    r.key === "Enter" && !r.shiftKey && (r.preventDefault(), this.sendMessage());
  }
  onInput() {
    this.text = this.textarea.value, this.maybeEmitTyping(), this.textarea.style.height = "auto", this.textarea.style.height = Math.min(this.textarea.scrollHeight, this.maxHeightPx) + "px", this.textarea.style.overflowY = this.textarea.scrollHeight > this.maxHeightPx ? "auto" : "hidden", this.validateInput();
  }
  maybeEmitTyping() {
    if (this.disabled) return;
    const r = Date.now();
    r - this.lastTypingSent >= this.typingThrottleMs && (this.dispatchEvent(new ni()), this.lastTypingSent = r);
  }
  render() {
    return b` <div class="group/composer w-full p-4 max-w-2xl mx-auto" data-error=${this.hasError}>
      <div
        class="outline-primary-800 rounded-sm outline-none border border-solid border-neutral-600 px-2 outline-2 group-focus-within/composer:outline-solid group-data-[error=true]/composer:border-red-600 group-data-[error=true]/composer:bg-red-100 group-data-[error=true]/composer:outline-red-600"
      >
        <div
          class="grid grid-cols-[auto_1fr_auto] [grid-template-areas:'header_header_header'_'leading_primary_trailing'_'._footer_.'] group-data-expanded/composer:[grid-template-areas:'header_header_header'_'primary_primary_primary'_'leading_footer_trailing']"
        >
          <div class="flex items-center overflow-x-hidden px-1.5 py-2 [grid-area:primary]">
            <textarea style=${`max-height: ${this.maxHeightPx}px`}
              data-testid="composer-textarea"
              name="composer-textarea"
              class="text-primary-900 placeholder:text-utility-gray h-[18.4px] w-full resize-none overflow-hidden text-sm outline-none"
              spellcheck="false"
              @keydown=${this.onKeyDown}
              @input=${this.onInput}
              .disabled=${this.disabled}
              .value=${fo(this.text)}
              rows="1"
              placeholder=${v("Type your question here...", { id: "composer-placeholder" })}
            ></textarea>
          </div>
          <div class="flex items-center [grid-area:leading]"></div>
          <div class="flex items-end py-2 [grid-area:trailing]">
            <span class="flex">
              <button
                data-testid="send-message-btn"
                aria-label="Send message"
                class="btn btn-primary size-8 data-[loading=true]:bg-transparent"
                @click=${this.sendMessage}
                ?disabled=${!this.canSubmit}
                data-loading=${this.loading}
              >
                <div class="flex items-center justify-center">
                  ${this.loading ? b`
                          <div class="relative size-4">
                            <div
                              class="bg-secondary-200 absolute inset-0 rounded-full [-webkit-mask:radial-gradient(farthest-side,transparent_calc(100%-3px),#000_0)] [mask:radial-gradient(farthest-side,transparent_calc(100%-3px),#000_0)]"
                            ></div>
                            <div
                              class="[background:conic-gradient(theme(colors.primary-600)_0_30%,transparent_30%_100%)] absolute inset-0 animate-spin rounded-full [-webkit-mask:radial-gradient(farthest-side,transparent_calc(100%-3px),#000_0)] [mask:radial-gradient(farthest-side,transparent_calc(100%-3px),#000_0)]"
                            ></div>
                          </div>
                        ` : b`<div class="flex size-5 items-center justify-center">
                          ${M(Jo)}
                        </div>`}
                </div>
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="relative flex h-6 w-full items-center justify-between gap-x-2">
        <div class="flex max-w-[calc(100%-80px)] flex-row items-center gap-x-2 overflow-x-clip">
          ${this.hasError ? b`
                  <div class="flex size-4 items-center justify-center text-red-600">
                    ${M($r)}
                  </div>
                  <span class="text-primary-900 truncate text-xs">${this.error}</span>
                ` : G}
          </div>
          <div class="flex flex-col items-end">
            <span class="text-primary-900 text-xs font-medium">
              ${this.text.length}/${this.maxInputLength}
            </span>
          </div>
        </div>
      </div>
    </div>`;
  }
};
Le([
  E({ type: Number, attribute: "max-input-length" })
], ke.prototype, "maxInputLength", 2);
Le([
  E({ attribute: !1 })
], ke.prototype, "disabled", 2);
Le([
  E({ attribute: !1 })
], ke.prototype, "loading", 2);
Le([
  Se()
], ke.prototype, "text", 2);
Le([
  Se()
], ke.prototype, "error", 2);
Le([
  sn('textarea[name="composer-textarea"]')
], ke.prototype, "textarea", 2);
ke = Le([
  te("gaia-chat-composer")
], ke);
const mn = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-megaphone-icon lucide-megaphone"><path d="M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"/><path d="M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14"/><path d="M8 6v8"/></svg>', li = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-minimize2-icon lucide-minimize-2"><path d="m14 10 7-7"/><path d="M20 10h-6V4"/><path d="m3 21 7-7"/><path d="M4 14h6v6"/></svg>', wn = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen-icon lucide-square-pen"><path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"/></svg>';
var ci = Object.defineProperty, hi = Object.getOwnPropertyDescriptor, Ht = (r, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? hi(e, t) : e, o = r.length - 1, i; o >= 0; o--)
    (i = r[o]) && (s = (n ? i(e, t, s) : i(s)) || s);
  return n && s && ci(e, t, s), s;
};
let ct = class extends ie {
  constructor() {
    super(...arguments), this.hasEmptyMessages = !0, this.disabled = !1, this.closeable = !0;
  }
  clearConversation() {
    this.dispatchEvent(new Mr());
  }
  openFeedbackForm() {
    this.dispatchEvent(new Pr("assistant"));
  }
  closeChat() {
    this.dispatchEvent(new oi());
  }
  render() {
    return b` <div class="relative w-full border-b border-solid border-neutral-300 p-4">
      <div class="flex items-center justify-between">
        <div class="flex">
          <h2 class="text-primary-900 text-sm font-bold">GAiA</h2>
        </div>
        <div class="flex items-center gap-0">
          <button
            data-testid="open-feedback-form-btn"
            type="button"
            aria-label="Open feedback form"
            class="btn btn-ghost p-1"
            @click=${this.openFeedbackForm}
            ?disabled=${this.hasEmptyMessages || this.disabled}
          >
            <div class="flex size-4 items-center justify-center" aria-hidden="true">
              ${nn(mn)}
            </div>
          </button>
          <button
            data-testid="clear-conversation-btn"
            type="button"
            aria-label="Clear conversation"
            class="btn btn-ghost p-1"
            @click=${this.clearConversation}
            ?disabled=${this.hasEmptyMessages || this.disabled}
          >
            <div class="flex size-4 items-center justify-center" aria-hidden="true">
              ${M(wn)}
            </div>
          </button>
          ${this.closeable ? b`
                <button
                  data-testid="close-chat-btn"
                  type="button"
                  aria-label="Minimize chat"
                  class="btn btn-ghost p-1"
                  @click=${this.closeChat}
                >
                  <div class="flex size-4 items-center justify-center" aria-hidden="true">
                    ${M(li)}
                  </div>
                </button>
              ` : G}
        </div>
      </div>
    </div>`;
  }
};
Ht([
  E({ attribute: !1 })
], ct.prototype, "hasEmptyMessages", 2);
Ht([
  E({ attribute: !1 })
], ct.prototype, "disabled", 2);
Ht([
  E({ attribute: !1 })
], ct.prototype, "closeable", 2);
ct = Ht([
  te("gaia-chat-menu")
], ct);
const di = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x-icon lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
class qe extends Error {
  constructor(e, t, n, s, o, i) {
    super(e), this.status = t, this.url = n, this.innerError = s, this.bodyText = o, this.problem = i, this.name = "ApiError";
  }
  get isUnauthorized() {
    return this.status === 401;
  }
  get isForbidden() {
    return this.status === 403;
  }
  get isNotFound() {
    return this.status === 404;
  }
  get isServerError() {
    return this.status >= 500;
  }
  get isNetworkError() {
    return this.status === 0;
  }
}
class bn extends Error {
  constructor(e, t) {
    super(e), this.innerError = t, this.name = "SignalRError";
  }
}
class Dr extends Error {
  constructor(e, t, n) {
    super(t), this.innerError = e, this.errorType = n;
  }
}
function gt(r) {
  if (r instanceof DOMException && r.name === "AbortError")
    return {
      code: "CANCELED",
      message: v("Request canceled.", { id: "error-request-canceled" }),
      retryable: !1,
      source: "ui",
      cause: r
    };
  if (r instanceof oe) {
    const e = {
      code: "UNAUTHORIZED",
      retryable: !1,
      source: "auth",
      cause: r
    };
    return r instanceof ln ? {
      ...e,
      message: v("Your access token has expired.", {
        id: "error-token-expired"
      })
    } : r instanceof Rt ? {
      ...e,
      message: v("Your access token is invalid.", {
        id: "error-token-invalid"
      })
    } : {
      ...e,
      message: v("Authentication error. Please authenticate again.", {
        id: "error-auth-generic"
      })
    };
  }
  return r instanceof qe ? r.isNetworkError ? {
    code: "NETWORK",
    message: v("Network error. Check your connection.", { id: "error-network-error" }),
    retryable: !0,
    source: "http",
    http: { status: 0, url: r.url },
    cause: r
  } : r.isUnauthorized ? {
    code: "UNAUTHORIZED",
    message: v("Your session expired. Please sign in again.", {
      id: "error-session-expired"
    }),
    retryable: !1,
    source: "http",
    http: { status: 401, url: r.url },
    cause: r
  } : r.isForbidden ? {
    code: "FORBIDDEN",
    message: v("You don't have access to this action.", { id: "error-forbidden" }),
    retryable: !1,
    source: "http",
    http: { status: 403, url: r.url },
    cause: r
  } : r.isNotFound ? {
    code: "NOT_FOUND",
    message: v("Not found.", { id: "error-not-found" }),
    retryable: !1,
    source: "http",
    http: { status: 404, url: r.url },
    cause: r
  } : r.status === 429 ? {
    code: "RATE_LIMIT",
    message: v("Too many requests. Please slow down.", { id: "error-rate-limit" }),
    retryable: !0,
    source: "http",
    http: { status: 429, url: r.url },
    cause: r
  } : r.isServerError ? {
    code: "SERVER",
    message: v("The server had a problem. Please try again.", { id: "error-server-error" }),
    retryable: !0,
    source: "http",
    http: { status: r.status, url: r.url },
    cause: r
  } : {
    code: "UNKNOWN",
    message: v("Something went wrong.", { id: "error-something-went-wrong" }),
    retryable: !0,
    source: "http",
    http: { status: r.status, url: r.url },
    cause: r
  } : r instanceof Dr ? r.errorType && r.errorType === "ProfileNotFoundException" ? {
    code: "NOT_FOUND",
    message: v("Failed to load the current profile. Are you using the correct profile?", {
      id: "error-profile-not-found"
    }),
    retryable: !1
  } : {
    code: "SSE",
    message: v("Live response stream interrupted. Try again.", { id: "error-sse-error" }),
    retryable: !0,
    source: "sse",
    cause: r
  } : r instanceof bn ? {
    code: "WS",
    message: v("Live chat connection error. Reconnecting might help.", {
      id: "error-ws-error"
    }),
    retryable: !0,
    source: "ws",
    cause: r
  } : {
    code: "UNKNOWN",
    message: v("Unexpected error. Please try again.", { id: "error-unexpected-error" }),
    retryable: !0,
    source: "unknown",
    cause: r
  };
}
var pi = Object.defineProperty, ui = Object.getOwnPropertyDescriptor, vn = (r, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? ui(e, t) : e, o = r.length - 1, i; o >= 0; o--)
    (i = r[o]) && (s = (n ? i(e, t, s) : i(s)) || s);
  return n && s && pi(e, t, s), s;
};
let yr = class extends ie {
  clearError() {
    this.dispatchEvent(new si());
  }
  render() {
    return this.error ? b` <div
      role="alert"
      data-testid="error-message"
      aria-live="assertive"
      class="absolute bottom-0 left-1/2 z-50 flex w-full items-center justify-center"
      style="transform: translateX(-50%) translateY(16px)"
    >
      <div
        class="m-4 grid grid-cols-[auto_1fr_auto] gap-2 rounded-sm border border-solid border-red-600 bg-red-100 p-4 [grid-template-areas:'leading_primary_trailing']"
      >
        <div class="flex [grid-area:primary]">
          <p class="text-primary-900 text-sm">${this.error.message}</p>
        </div>
        <div class="flex [grid-area:leading]">
          <div class="flex size-5 items-center justify-center text-red-600">
            ${M($r)}
          </div>
        </div>
        <div class="flex [grid-area:trailing]">
          <button class="btn self-start" @click=${this.clearError}>
            <div class="text-primary-900 flex size-5 items-center justify-center">
              ${M(di)}
            </div>
          </button>
        </div>
      </div>
    </div>` : G;
  }
};
vn([
  E({ attribute: !1 })
], yr.prototype, "error", 2);
yr = vn([
  te("gaia-chat-error")
], yr);
const gi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-send-icon lucide-send"><path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"/><path d="m21.854 2.147-10.94 10.939"/></svg>';
var fi = Object.defineProperty, mi = Object.getOwnPropertyDescriptor, Or = (r, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? mi(e, t) : e, o = r.length - 1, i; o >= 0; o--)
    (i = r[o]) && (s = (n ? i(e, t, s) : i(s)) || s);
  return n && s && fi(e, t, s), s;
};
let Mt = class extends ie {
  constructor() {
    super(...arguments), this.ratings = [1, 2, 3, 4, 5], this.target = "assistant", this.textareaRef = mo(), this.selectedRating = 0, this.onSubmit = () => {
      const r = this.textareaRef.value?.value ?? null;
      this.isValid && (this.dispatchEvent(new ri(this.target, this.selectedRating, r)), this.target === "support" && this.dispatchEvent(new Mr()));
    }, this.onCancel = () => {
      this.dispatchEvent(new Pr(null));
    };
  }
  onRatingClick(r) {
    this.selectedRating = r;
  }
  get isValid() {
    return this.selectedRating > 0 && this.selectedRating <= 5;
  }
  render() {
    return b` <div data-testid="feedback-form" class="relative w-full px-2 py-3">
      <div
        class="text-primary-900 flex flex-col gap-y-4 rounded-sm border border-solid border-neutral-600 p-4"
      >
        <div>
          <h4 class="pb-2 text-sm font-bold">${v("Feedback", { id: "feedback-form-title" })}</h4>
          <p class="text-xs">
            ${v("Please share your thoughts and suggestions to help us improve.", {
      id: "feedback-form-description"
    })}
          </p>
        </div>
        <div>
          <h4 class="pb-2 text-sm font-medium">
            ${this.target === "support" ? v("How satisfied are you with the help you received?", {
      id: "feedback-form-satisfaction-title--support"
    }) : v("How satisfied are you with the assistant?", {
      id: "feedback-form-satisfaction-title--assistant"
    })}
          </h4>
          <div class="flex items-center gap-x-2">
            ${an(
      this.ratings,
      (r) => b`
                <button
                  class="btn btn-secondary data-[selected=true]:text-primary-900 data-[selected=true]:bg-secondary-200 size-8"
                  @click=${() => this.onRatingClick(r)}
                  data-selected=${this.selectedRating === r}
                >
                  <div class="flex items-center justify-center">${r}</div>
                </button>
              `
    )}
          </div>
        </div>
        <div>
          <h4 class="pb-2 text-sm font-medium">
            ${v("Any additional comments?", { id: "feedback-form-comments-title" })}
          </h4>
          <textarea
            ${wo(this.textareaRef)}
            name="feedback-comment"
            class="text-primary-900 placeholder:text-utility-gray outline-primary-800 h-24 w-full resize-none rounded-sm border border-solid border-neutral-600 p-2 text-sm active:outline-2"
            spellcheck="false"
            placeholder=${v("Enter your comment here", {
      id: "feedback-form-comment-placeholder"
    })}
          ></textarea>
        </div>
        <div class="flex items-center justify-end gap-x-2">
          <button
            class="btn btn-primary px-4 py-2"
            ?disabled=${!this.isValid}
            @click=${this.onSubmit}
          >
            <div class="flex items-center justify-center gap-x-2">
              <div class="flex size-4 items-center justify-center">${M(gi)}</div>
              ${v("Submit feedback", { id: "feedback-form-submit" })}
            </div>
          </button>
          <button class="btn btn-secondary px-4 py-2" @click=${this.onCancel}>
            <div class="flex items-center justify-center">
              ${v("Cancel", { id: "feedback-form-cancel" })}
            </div>
          </button>
        </div>
      </div>
    </div>`;
  }
};
Or([
  E({ type: String, attribute: "target" })
], Mt.prototype, "target", 2);
Or([
  Se()
], Mt.prototype, "selectedRating", 2);
Mt = Or([
  te("gaia-chat-feedback-form")
], Mt);
const wi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check-icon lucide-check"><path d="M20 6 9 17l-5-5"/></svg>', bi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down-icon lucide-chevron-down"><path d="m6 9 6 6 6-6"/></svg>', vi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-x-icon lucide-circle-x"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>', yi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-icon lucide-file"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/></svg>', ht = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-sparkles-icon lucide-sparkles"><path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"/><path d="M20 2v4"/><path d="M22 4h-4"/><circle cx="4" cy="20" r="2"/></svg>';
/*! @license DOMPurify 3.2.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.7/LICENSE */
const {
  entries: yn,
  setPrototypeOf: Is,
  isFrozen: _i,
  getPrototypeOf: ki,
  getOwnPropertyDescriptor: xi
} = Object;
let {
  freeze: Y,
  seal: Q,
  create: _n
} = Object, {
  apply: _r,
  construct: kr
} = typeof Reflect < "u" && Reflect;
Y || (Y = function(e) {
  return e;
});
Q || (Q = function(e) {
  return e;
});
_r || (_r = function(e, t) {
  for (var n = arguments.length, s = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++)
    s[o - 2] = arguments[o];
  return e.apply(t, s);
});
kr || (kr = function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
    n[s - 1] = arguments[s];
  return new e(...n);
});
const Tt = X(Array.prototype.forEach), Si = X(Array.prototype.lastIndexOf), As = X(Array.prototype.pop), Je = X(Array.prototype.push), Ti = X(Array.prototype.splice), At = X(String.prototype.toLowerCase), lr = X(String.prototype.toString), cr = X(String.prototype.match), Qe = X(String.prototype.replace), Ei = X(String.prototype.indexOf), Ci = X(String.prototype.trim), se = X(Object.prototype.hasOwnProperty), q = X(RegExp.prototype.test), et = Ii(TypeError);
function X(r) {
  return function(e) {
    e instanceof RegExp && (e.lastIndex = 0);
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
      n[s - 1] = arguments[s];
    return _r(r, e, n);
  };
}
function Ii(r) {
  return function() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return kr(r, t);
  };
}
function _(r, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : At;
  Is && Is(r, null);
  let n = e.length;
  for (; n--; ) {
    let s = e[n];
    if (typeof s == "string") {
      const o = t(s);
      o !== s && (_i(e) || (e[n] = o), s = o);
    }
    r[s] = !0;
  }
  return r;
}
function Ai(r) {
  for (let e = 0; e < r.length; e++)
    se(r, e) || (r[e] = null);
  return r;
}
function me(r) {
  const e = _n(null);
  for (const [t, n] of yn(r))
    se(r, t) && (Array.isArray(n) ? e[t] = Ai(n) : n && typeof n == "object" && n.constructor === Object ? e[t] = me(n) : e[t] = n);
  return e;
}
function tt(r, e) {
  for (; r !== null; ) {
    const n = xi(r, e);
    if (n) {
      if (n.get)
        return X(n.get);
      if (typeof n.value == "function")
        return X(n.value);
    }
    r = ki(r);
  }
  function t() {
    return null;
  }
  return t;
}
const Rs = Y(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), hr = Y(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "slot", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), dr = Y(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Ri = Y(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), pr = Y(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), $i = Y(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), $s = Y(["#text"]), Ps = Y(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), ur = Y(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Ms = Y(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Et = Y(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Pi = Q(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Mi = Q(/<%[\w\W]*|[\w\W]*%>/gm), Di = Q(/\$\{[\w\W]*/gm), Oi = Q(/^data-[\-\w.\u00B7-\uFFFF]+$/), Li = Q(/^aria-[\-\w]+$/), kn = Q(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), Ni = Q(/^(?:\w+script|data):/i), zi = Q(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), xn = Q(/^html$/i), Fi = Q(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Ds = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: Li,
  ATTR_WHITESPACE: zi,
  CUSTOM_ELEMENT: Fi,
  DATA_ATTR: Oi,
  DOCTYPE_NAME: xn,
  ERB_EXPR: Mi,
  IS_ALLOWED_URI: kn,
  IS_SCRIPT_OR_DATA: Ni,
  MUSTACHE_EXPR: Pi,
  TMPLIT_EXPR: Di
});
const rt = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, Ui = function() {
  return typeof window > "u" ? null : window;
}, Hi = function(e, t) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let n = null;
  const s = "data-tt-policy-suffix";
  t && t.hasAttribute(s) && (n = t.getAttribute(s));
  const o = "dompurify" + (n ? "#" + n : "");
  try {
    return e.createPolicy(o, {
      createHTML(i) {
        return i;
      },
      createScriptURL(i) {
        return i;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + o + " could not be created."), null;
  }
}, Os = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function Sn() {
  let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Ui();
  const e = (f) => Sn(f);
  if (e.version = "3.2.7", e.removed = [], !r || !r.document || r.document.nodeType !== rt.document || !r.Element)
    return e.isSupported = !1, e;
  let {
    document: t
  } = r;
  const n = t, s = n.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: i,
    Node: a,
    Element: c,
    NodeFilter: d,
    NamedNodeMap: u = r.NamedNodeMap || r.MozNamedAttrMap,
    HTMLFormElement: w,
    DOMParser: k,
    trustedTypes: R
  } = r, T = c.prototype, y = tt(T, "cloneNode"), $ = tt(T, "remove"), J = tt(T, "nextSibling"), ye = tt(T, "childNodes"), re = tt(T, "parentNode");
  if (typeof i == "function") {
    const f = t.createElement("template");
    f.content && f.content.ownerDocument && (t = f.content.ownerDocument);
  }
  let N, Te = "";
  const {
    implementation: Ee,
    createNodeIterator: Ce,
    createDocumentFragment: Zn,
    getElementsByTagName: Kn
  } = t, {
    importNode: Jn
  } = n;
  let W = Os();
  e.isSupported = typeof yn == "function" && typeof re == "function" && Ee && Ee.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: qt,
    ERB_EXPR: Gt,
    TMPLIT_EXPR: Vt,
    DATA_ATTR: Qn,
    ARIA_ATTR: eo,
    IS_SCRIPT_OR_DATA: to,
    ATTR_WHITESPACE: Kr,
    CUSTOM_ELEMENT: ro
  } = Ds;
  let {
    IS_ALLOWED_URI: Jr
  } = Ds, z = null;
  const Qr = _({}, [...Rs, ...hr, ...dr, ...pr, ...$s]);
  let U = null;
  const es = _({}, [...Ps, ...ur, ...Ms, ...Et]);
  let P = Object.seal(_n(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Xe = null, Yt = null, ts = !0, Xt = !0, rs = !1, ss = !0, ze = !1, wt = !0, Ie = !1, Zt = !1, Kt = !1, Fe = !1, bt = !1, vt = !1, ns = !0, os = !1;
  const so = "user-content-";
  let Jt = !0, Ze = !1, Ue = {}, He = null;
  const is = _({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let as = null;
  const ls = _({}, ["audio", "video", "img", "source", "image", "track"]);
  let Qt = null;
  const cs = _({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), yt = "http://www.w3.org/1998/Math/MathML", _t = "http://www.w3.org/2000/svg", pe = "http://www.w3.org/1999/xhtml";
  let Be = pe, er = !1, tr = null;
  const no = _({}, [yt, _t, pe], lr);
  let kt = _({}, ["mi", "mo", "mn", "ms", "mtext"]), xt = _({}, ["annotation-xml"]);
  const oo = _({}, ["title", "style", "font", "a", "script"]);
  let Ke = null;
  const io = ["application/xhtml+xml", "text/html"], ao = "text/html";
  let F = null, je = null;
  const lo = t.createElement("form"), hs = function(l) {
    return l instanceof RegExp || l instanceof Function;
  }, rr = function() {
    let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(je && je === l)) {
      if ((!l || typeof l != "object") && (l = {}), l = me(l), Ke = // eslint-disable-next-line unicorn/prefer-includes
      io.indexOf(l.PARSER_MEDIA_TYPE) === -1 ? ao : l.PARSER_MEDIA_TYPE, F = Ke === "application/xhtml+xml" ? lr : At, z = se(l, "ALLOWED_TAGS") ? _({}, l.ALLOWED_TAGS, F) : Qr, U = se(l, "ALLOWED_ATTR") ? _({}, l.ALLOWED_ATTR, F) : es, tr = se(l, "ALLOWED_NAMESPACES") ? _({}, l.ALLOWED_NAMESPACES, lr) : no, Qt = se(l, "ADD_URI_SAFE_ATTR") ? _(me(cs), l.ADD_URI_SAFE_ATTR, F) : cs, as = se(l, "ADD_DATA_URI_TAGS") ? _(me(ls), l.ADD_DATA_URI_TAGS, F) : ls, He = se(l, "FORBID_CONTENTS") ? _({}, l.FORBID_CONTENTS, F) : is, Xe = se(l, "FORBID_TAGS") ? _({}, l.FORBID_TAGS, F) : me({}), Yt = se(l, "FORBID_ATTR") ? _({}, l.FORBID_ATTR, F) : me({}), Ue = se(l, "USE_PROFILES") ? l.USE_PROFILES : !1, ts = l.ALLOW_ARIA_ATTR !== !1, Xt = l.ALLOW_DATA_ATTR !== !1, rs = l.ALLOW_UNKNOWN_PROTOCOLS || !1, ss = l.ALLOW_SELF_CLOSE_IN_ATTR !== !1, ze = l.SAFE_FOR_TEMPLATES || !1, wt = l.SAFE_FOR_XML !== !1, Ie = l.WHOLE_DOCUMENT || !1, Fe = l.RETURN_DOM || !1, bt = l.RETURN_DOM_FRAGMENT || !1, vt = l.RETURN_TRUSTED_TYPE || !1, Kt = l.FORCE_BODY || !1, ns = l.SANITIZE_DOM !== !1, os = l.SANITIZE_NAMED_PROPS || !1, Jt = l.KEEP_CONTENT !== !1, Ze = l.IN_PLACE || !1, Jr = l.ALLOWED_URI_REGEXP || kn, Be = l.NAMESPACE || pe, kt = l.MATHML_TEXT_INTEGRATION_POINTS || kt, xt = l.HTML_INTEGRATION_POINTS || xt, P = l.CUSTOM_ELEMENT_HANDLING || {}, l.CUSTOM_ELEMENT_HANDLING && hs(l.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (P.tagNameCheck = l.CUSTOM_ELEMENT_HANDLING.tagNameCheck), l.CUSTOM_ELEMENT_HANDLING && hs(l.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (P.attributeNameCheck = l.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), l.CUSTOM_ELEMENT_HANDLING && typeof l.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (P.allowCustomizedBuiltInElements = l.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), ze && (Xt = !1), bt && (Fe = !0), Ue && (z = _({}, $s), U = [], Ue.html === !0 && (_(z, Rs), _(U, Ps)), Ue.svg === !0 && (_(z, hr), _(U, ur), _(U, Et)), Ue.svgFilters === !0 && (_(z, dr), _(U, ur), _(U, Et)), Ue.mathMl === !0 && (_(z, pr), _(U, Ms), _(U, Et))), l.ADD_TAGS && (z === Qr && (z = me(z)), _(z, l.ADD_TAGS, F)), l.ADD_ATTR && (U === es && (U = me(U)), _(U, l.ADD_ATTR, F)), l.ADD_URI_SAFE_ATTR && _(Qt, l.ADD_URI_SAFE_ATTR, F), l.FORBID_CONTENTS && (He === is && (He = me(He)), _(He, l.FORBID_CONTENTS, F)), Jt && (z["#text"] = !0), Ie && _(z, ["html", "head", "body"]), z.table && (_(z, ["tbody"]), delete Xe.tbody), l.TRUSTED_TYPES_POLICY) {
        if (typeof l.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw et('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof l.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw et('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        N = l.TRUSTED_TYPES_POLICY, Te = N.createHTML("");
      } else
        N === void 0 && (N = Hi(R, s)), N !== null && typeof Te == "string" && (Te = N.createHTML(""));
      Y && Y(l), je = l;
    }
  }, ds = _({}, [...hr, ...dr, ...Ri]), ps = _({}, [...pr, ...$i]), co = function(l) {
    let p = re(l);
    (!p || !p.tagName) && (p = {
      namespaceURI: Be,
      tagName: "template"
    });
    const g = At(l.tagName), C = At(p.tagName);
    return tr[l.namespaceURI] ? l.namespaceURI === _t ? p.namespaceURI === pe ? g === "svg" : p.namespaceURI === yt ? g === "svg" && (C === "annotation-xml" || kt[C]) : !!ds[g] : l.namespaceURI === yt ? p.namespaceURI === pe ? g === "math" : p.namespaceURI === _t ? g === "math" && xt[C] : !!ps[g] : l.namespaceURI === pe ? p.namespaceURI === _t && !xt[C] || p.namespaceURI === yt && !kt[C] ? !1 : !ps[g] && (oo[g] || !ds[g]) : !!(Ke === "application/xhtml+xml" && tr[l.namespaceURI]) : !1;
  }, ce = function(l) {
    Je(e.removed, {
      element: l
    });
    try {
      re(l).removeChild(l);
    } catch {
      $(l);
    }
  }, Ae = function(l, p) {
    try {
      Je(e.removed, {
        attribute: p.getAttributeNode(l),
        from: p
      });
    } catch {
      Je(e.removed, {
        attribute: null,
        from: p
      });
    }
    if (p.removeAttribute(l), l === "is")
      if (Fe || bt)
        try {
          ce(p);
        } catch {
        }
      else
        try {
          p.setAttribute(l, "");
        } catch {
        }
  }, us = function(l) {
    let p = null, g = null;
    if (Kt)
      l = "<remove></remove>" + l;
    else {
      const D = cr(l, /^[\r\n\t ]+/);
      g = D && D[0];
    }
    Ke === "application/xhtml+xml" && Be === pe && (l = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + l + "</body></html>");
    const C = N ? N.createHTML(l) : l;
    if (Be === pe)
      try {
        p = new k().parseFromString(C, Ke);
      } catch {
      }
    if (!p || !p.documentElement) {
      p = Ee.createDocument(Be, "template", null);
      try {
        p.documentElement.innerHTML = er ? Te : C;
      } catch {
      }
    }
    const B = p.body || p.documentElement;
    return l && g && B.insertBefore(t.createTextNode(g), B.childNodes[0] || null), Be === pe ? Kn.call(p, Ie ? "html" : "body")[0] : Ie ? p.documentElement : B;
  }, gs = function(l) {
    return Ce.call(
      l.ownerDocument || l,
      l,
      // eslint-disable-next-line no-bitwise
      d.SHOW_ELEMENT | d.SHOW_COMMENT | d.SHOW_TEXT | d.SHOW_PROCESSING_INSTRUCTION | d.SHOW_CDATA_SECTION,
      null
    );
  }, sr = function(l) {
    return l instanceof w && (typeof l.nodeName != "string" || typeof l.textContent != "string" || typeof l.removeChild != "function" || !(l.attributes instanceof u) || typeof l.removeAttribute != "function" || typeof l.setAttribute != "function" || typeof l.namespaceURI != "string" || typeof l.insertBefore != "function" || typeof l.hasChildNodes != "function");
  }, fs = function(l) {
    return typeof a == "function" && l instanceof a;
  };
  function ue(f, l, p) {
    Tt(f, (g) => {
      g.call(e, l, p, je);
    });
  }
  const ms = function(l) {
    let p = null;
    if (ue(W.beforeSanitizeElements, l, null), sr(l))
      return ce(l), !0;
    const g = F(l.nodeName);
    if (ue(W.uponSanitizeElement, l, {
      tagName: g,
      allowedTags: z
    }), wt && l.hasChildNodes() && !fs(l.firstElementChild) && q(/<[/\w!]/g, l.innerHTML) && q(/<[/\w!]/g, l.textContent) || l.nodeType === rt.progressingInstruction || wt && l.nodeType === rt.comment && q(/<[/\w]/g, l.data))
      return ce(l), !0;
    if (!z[g] || Xe[g]) {
      if (!Xe[g] && bs(g) && (P.tagNameCheck instanceof RegExp && q(P.tagNameCheck, g) || P.tagNameCheck instanceof Function && P.tagNameCheck(g)))
        return !1;
      if (Jt && !He[g]) {
        const C = re(l) || l.parentNode, B = ye(l) || l.childNodes;
        if (B && C) {
          const D = B.length;
          for (let Z = D - 1; Z >= 0; --Z) {
            const ge = y(B[Z], !0);
            ge.__removalCount = (l.__removalCount || 0) + 1, C.insertBefore(ge, J(l));
          }
        }
      }
      return ce(l), !0;
    }
    return l instanceof c && !co(l) || (g === "noscript" || g === "noembed" || g === "noframes") && q(/<\/no(script|embed|frames)/i, l.innerHTML) ? (ce(l), !0) : (ze && l.nodeType === rt.text && (p = l.textContent, Tt([qt, Gt, Vt], (C) => {
      p = Qe(p, C, " ");
    }), l.textContent !== p && (Je(e.removed, {
      element: l.cloneNode()
    }), l.textContent = p)), ue(W.afterSanitizeElements, l, null), !1);
  }, ws = function(l, p, g) {
    if (ns && (p === "id" || p === "name") && (g in t || g in lo))
      return !1;
    if (!(Xt && !Yt[p] && q(Qn, p))) {
      if (!(ts && q(eo, p))) {
        if (!U[p] || Yt[p]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(bs(l) && (P.tagNameCheck instanceof RegExp && q(P.tagNameCheck, l) || P.tagNameCheck instanceof Function && P.tagNameCheck(l)) && (P.attributeNameCheck instanceof RegExp && q(P.attributeNameCheck, p) || P.attributeNameCheck instanceof Function && P.attributeNameCheck(p, l)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            p === "is" && P.allowCustomizedBuiltInElements && (P.tagNameCheck instanceof RegExp && q(P.tagNameCheck, g) || P.tagNameCheck instanceof Function && P.tagNameCheck(g)))
          ) return !1;
        } else if (!Qt[p]) {
          if (!q(Jr, Qe(g, Kr, ""))) {
            if (!((p === "src" || p === "xlink:href" || p === "href") && l !== "script" && Ei(g, "data:") === 0 && as[l])) {
              if (!(rs && !q(to, Qe(g, Kr, "")))) {
                if (g)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, bs = function(l) {
    return l !== "annotation-xml" && cr(l, ro);
  }, vs = function(l) {
    ue(W.beforeSanitizeAttributes, l, null);
    const {
      attributes: p
    } = l;
    if (!p || sr(l))
      return;
    const g = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: U,
      forceKeepAttr: void 0
    };
    let C = p.length;
    for (; C--; ) {
      const B = p[C], {
        name: D,
        namespaceURI: Z,
        value: ge
      } = B, We = F(D), nr = ge;
      let H = D === "value" ? nr : Ci(nr);
      if (g.attrName = We, g.attrValue = H, g.keepAttr = !0, g.forceKeepAttr = void 0, ue(W.uponSanitizeAttribute, l, g), H = g.attrValue, os && (We === "id" || We === "name") && (Ae(D, l), H = so + H), wt && q(/((--!?|])>)|<\/(style|title|textarea)/i, H)) {
        Ae(D, l);
        continue;
      }
      if (We === "attributename" && cr(H, "href")) {
        Ae(D, l);
        continue;
      }
      if (g.forceKeepAttr)
        continue;
      if (!g.keepAttr) {
        Ae(D, l);
        continue;
      }
      if (!ss && q(/\/>/i, H)) {
        Ae(D, l);
        continue;
      }
      ze && Tt([qt, Gt, Vt], (_s) => {
        H = Qe(H, _s, " ");
      });
      const ys = F(l.nodeName);
      if (!ws(ys, We, H)) {
        Ae(D, l);
        continue;
      }
      if (N && typeof R == "object" && typeof R.getAttributeType == "function" && !Z)
        switch (R.getAttributeType(ys, We)) {
          case "TrustedHTML": {
            H = N.createHTML(H);
            break;
          }
          case "TrustedScriptURL": {
            H = N.createScriptURL(H);
            break;
          }
        }
      if (H !== nr)
        try {
          Z ? l.setAttributeNS(Z, D, H) : l.setAttribute(D, H), sr(l) ? ce(l) : As(e.removed);
        } catch {
          Ae(D, l);
        }
    }
    ue(W.afterSanitizeAttributes, l, null);
  }, ho = function f(l) {
    let p = null;
    const g = gs(l);
    for (ue(W.beforeSanitizeShadowDOM, l, null); p = g.nextNode(); )
      ue(W.uponSanitizeShadowNode, p, null), ms(p), vs(p), p.content instanceof o && f(p.content);
    ue(W.afterSanitizeShadowDOM, l, null);
  };
  return e.sanitize = function(f) {
    let l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, p = null, g = null, C = null, B = null;
    if (er = !f, er && (f = "<!-->"), typeof f != "string" && !fs(f))
      if (typeof f.toString == "function") {
        if (f = f.toString(), typeof f != "string")
          throw et("dirty is not a string, aborting");
      } else
        throw et("toString is not a function");
    if (!e.isSupported)
      return f;
    if (Zt || rr(l), e.removed = [], typeof f == "string" && (Ze = !1), Ze) {
      if (f.nodeName) {
        const ge = F(f.nodeName);
        if (!z[ge] || Xe[ge])
          throw et("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (f instanceof a)
      p = us("<!---->"), g = p.ownerDocument.importNode(f, !0), g.nodeType === rt.element && g.nodeName === "BODY" || g.nodeName === "HTML" ? p = g : p.appendChild(g);
    else {
      if (!Fe && !ze && !Ie && // eslint-disable-next-line unicorn/prefer-includes
      f.indexOf("<") === -1)
        return N && vt ? N.createHTML(f) : f;
      if (p = us(f), !p)
        return Fe ? null : vt ? Te : "";
    }
    p && Kt && ce(p.firstChild);
    const D = gs(Ze ? f : p);
    for (; C = D.nextNode(); )
      ms(C), vs(C), C.content instanceof o && ho(C.content);
    if (Ze)
      return f;
    if (Fe) {
      if (bt)
        for (B = Zn.call(p.ownerDocument); p.firstChild; )
          B.appendChild(p.firstChild);
      else
        B = p;
      return (U.shadowroot || U.shadowrootmode) && (B = Jn.call(n, B, !0)), B;
    }
    let Z = Ie ? p.outerHTML : p.innerHTML;
    return Ie && z["!doctype"] && p.ownerDocument && p.ownerDocument.doctype && p.ownerDocument.doctype.name && q(xn, p.ownerDocument.doctype.name) && (Z = "<!DOCTYPE " + p.ownerDocument.doctype.name + `>
` + Z), ze && Tt([qt, Gt, Vt], (ge) => {
      Z = Qe(Z, ge, " ");
    }), N && vt ? N.createHTML(Z) : Z;
  }, e.setConfig = function() {
    let f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    rr(f), Zt = !0;
  }, e.clearConfig = function() {
    je = null, Zt = !1;
  }, e.isValidAttribute = function(f, l, p) {
    je || rr({});
    const g = F(f), C = F(l);
    return ws(g, C, p);
  }, e.addHook = function(f, l) {
    typeof l == "function" && Je(W[f], l);
  }, e.removeHook = function(f, l) {
    if (l !== void 0) {
      const p = Si(W[f], l);
      return p === -1 ? void 0 : Ti(W[f], p, 1)[0];
    }
    return As(W[f]);
  }, e.removeHooks = function(f) {
    W[f] = [];
  }, e.removeAllHooks = function() {
    W = Os();
  }, e;
}
var Tn = Sn();
function Lr() {
  return { async: !1, breaks: !1, extensions: null, gfm: !0, hooks: null, pedantic: !1, renderer: null, silent: !1, tokenizer: null, walkTokens: null };
}
var Ne = Lr();
function En(r) {
  Ne = r;
}
var at = { exec: () => null };
function S(r, e = "") {
  let t = typeof r == "string" ? r : r.source, n = { replace: (s, o) => {
    let i = typeof o == "string" ? o : o.source;
    return i = i.replace(V.caret, "$1"), t = t.replace(s, i), n;
  }, getRegex: () => new RegExp(t, e) };
  return n;
}
var V = { codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm, outputLinkReplace: /\\([\[\]])/g, indentCodeCompensation: /^(\s+)(?:```)/, beginningSpace: /^\s+/, endingHash: /#$/, startingSpaceChar: /^ /, endingSpaceChar: / $/, nonSpaceChar: /[^ ]/, newLineCharGlobal: /\n/g, tabCharGlobal: /\t/g, multipleSpaceGlobal: /\s+/g, blankLine: /^[ \t]*$/, doubleBlankLine: /\n[ \t]*\n[ \t]*$/, blockquoteStart: /^ {0,3}>/, blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g, blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm, listReplaceTabs: /^\t+/, listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g, listIsTask: /^\[[ xX]\] /, listReplaceTask: /^\[[ xX]\] +/, anyLine: /\n.*\n/, hrefBrackets: /^<(.*)>$/, tableDelimiter: /[:|]/, tableAlignChars: /^\||\| *$/g, tableRowBlankLine: /\n[ \t]*$/, tableAlignRight: /^ *-+: *$/, tableAlignCenter: /^ *:-+: *$/, tableAlignLeft: /^ *:-+ *$/, startATag: /^<a /i, endATag: /^<\/a>/i, startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i, endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i, startAngleBracket: /^</, endAngleBracket: />$/, pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/, unicodeAlphaNumeric: /[\p{L}\p{N}]/u, escapeTest: /[&<>"']/, escapeReplace: /[&<>"']/g, escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/, escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g, unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig, caret: /(^|[^\[])\^/g, percentDecode: /%25/g, findPipe: /\|/g, splitPipe: / \|/, slashPipe: /\\\|/g, carriageReturn: /\r\n|\r/g, spaceLine: /^ +$/gm, notSpaceStart: /^\S*/, endingNewline: /\n$/, listItemRegex: (r) => new RegExp(`^( {0,3}${r})((?:[	 ][^\\n]*)?(?:\\n|$))`), nextBulletRegex: (r) => new RegExp(`^ {0,${Math.min(3, r - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`), hrRegex: (r) => new RegExp(`^ {0,${Math.min(3, r - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`), fencesBeginRegex: (r) => new RegExp(`^ {0,${Math.min(3, r - 1)}}(?:\`\`\`|~~~)`), headingBeginRegex: (r) => new RegExp(`^ {0,${Math.min(3, r - 1)}}#`), htmlBeginRegex: (r) => new RegExp(`^ {0,${Math.min(3, r - 1)}}<(?:[a-z].*>|!--)`, "i") }, Bi = /^(?:[ \t]*(?:\n|$))+/, ji = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, Wi = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, ft = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, qi = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, Nr = /(?:[*+-]|\d{1,9}[.)])/, Cn = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, In = S(Cn).replace(/bull/g, Nr).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), Gi = S(Cn).replace(/bull/g, Nr).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), zr = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, Vi = /^[^\n]+/, Fr = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\])+/, Yi = S(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", Fr).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), Xi = S(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, Nr).getRegex(), Bt = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", Ur = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, Zi = S("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", Ur).replace("tag", Bt).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), An = S(zr).replace("hr", ft).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Bt).getRegex(), Ki = S(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", An).getRegex(), Hr = { blockquote: Ki, code: ji, def: Yi, fences: Wi, heading: qi, hr: ft, html: Zi, lheading: In, list: Xi, newline: Bi, paragraph: An, table: at, text: Vi }, Ls = S("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", ft).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Bt).getRegex(), Ji = { ...Hr, lheading: Gi, table: Ls, paragraph: S(zr).replace("hr", ft).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", Ls).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Bt).getRegex() }, Qi = { ...Hr, html: S(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", Ur).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(), def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/, heading: /^(#{1,6})(.*)(?:\n+|$)/, fences: at, lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/, paragraph: S(zr).replace("hr", ft).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", In).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex() }, ea = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, ta = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, Rn = /^( {2,}|\\)\n(?!\s*$)/, ra = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, jt = /[\p{P}\p{S}]/u, Br = /[\s\p{P}\p{S}]/u, $n = /[^\s\p{P}\p{S}]/u, sa = S(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, Br).getRegex(), Pn = /(?!~)[\p{P}\p{S}]/u, na = /(?!~)[\s\p{P}\p{S}]/u, oa = /(?:[^\s\p{P}\p{S}]|~)/u, ia = /\[[^\[\]]*?\]\((?:\\[\s\S]|[^\\\(\)]|\((?:\\[\s\S]|[^\\\(\)])*\))*\)|`[^`]*?`|<(?! )[^<>]*?>/g, Mn = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/, aa = S(Mn, "u").replace(/punct/g, jt).getRegex(), la = S(Mn, "u").replace(/punct/g, Pn).getRegex(), Dn = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", ca = S(Dn, "gu").replace(/notPunctSpace/g, $n).replace(/punctSpace/g, Br).replace(/punct/g, jt).getRegex(), ha = S(Dn, "gu").replace(/notPunctSpace/g, oa).replace(/punctSpace/g, na).replace(/punct/g, Pn).getRegex(), da = S("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, $n).replace(/punctSpace/g, Br).replace(/punct/g, jt).getRegex(), pa = S(/\\(punct)/, "gu").replace(/punct/g, jt).getRegex(), ua = S(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), ga = S(Ur).replace("(?:-->|$)", "-->").getRegex(), fa = S("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", ga).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), Dt = /(?:\[(?:\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`[^`]*`|[^\[\]\\`])*?/, ma = S(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]*(?:\n[ \t]*)?)(title))?\s*\)/).replace("label", Dt).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), On = S(/^!?\[(label)\]\[(ref)\]/).replace("label", Dt).replace("ref", Fr).getRegex(), Ln = S(/^!?\[(ref)\](?:\[\])?/).replace("ref", Fr).getRegex(), wa = S("reflink|nolink(?!\\()", "g").replace("reflink", On).replace("nolink", Ln).getRegex(), jr = { _backpedal: at, anyPunctuation: pa, autolink: ua, blockSkip: ia, br: Rn, code: ta, del: at, emStrongLDelim: aa, emStrongRDelimAst: ca, emStrongRDelimUnd: da, escape: ea, link: ma, nolink: Ln, punctuation: sa, reflink: On, reflinkSearch: wa, tag: fa, text: ra, url: at }, ba = { ...jr, link: S(/^!?\[(label)\]\((.*?)\)/).replace("label", Dt).getRegex(), reflink: S(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", Dt).getRegex() }, xr = { ...jr, emStrongRDelimAst: ha, emStrongLDelim: la, url: S(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(), _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/, del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/, text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/ }, va = { ...xr, br: S(Rn).replace("{2,}", "*").getRegex(), text: S(xr.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex() }, Ct = { normal: Hr, gfm: Ji, pedantic: Qi }, st = { normal: jr, gfm: xr, breaks: va, pedantic: ba }, ya = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, Ns = (r) => ya[r];
function he(r, e) {
  if (e) {
    if (V.escapeTest.test(r)) return r.replace(V.escapeReplace, Ns);
  } else if (V.escapeTestNoEncode.test(r)) return r.replace(V.escapeReplaceNoEncode, Ns);
  return r;
}
function zs(r) {
  try {
    r = encodeURI(r).replace(V.percentDecode, "%");
  } catch {
    return null;
  }
  return r;
}
function Fs(r, e) {
  let t = r.replace(V.findPipe, (o, i, a) => {
    let c = !1, d = i;
    for (; --d >= 0 && a[d] === "\\"; ) c = !c;
    return c ? "|" : " |";
  }), n = t.split(V.splitPipe), s = 0;
  if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), e) if (n.length > e) n.splice(e);
  else for (; n.length < e; ) n.push("");
  for (; s < n.length; s++) n[s] = n[s].trim().replace(V.slashPipe, "|");
  return n;
}
function nt(r, e, t) {
  let n = r.length;
  if (n === 0) return "";
  let s = 0;
  for (; s < n && r.charAt(n - s - 1) === e; )
    s++;
  return r.slice(0, n - s);
}
function _a(r, e) {
  if (r.indexOf(e[1]) === -1) return -1;
  let t = 0;
  for (let n = 0; n < r.length; n++) if (r[n] === "\\") n++;
  else if (r[n] === e[0]) t++;
  else if (r[n] === e[1] && (t--, t < 0)) return n;
  return t > 0 ? -2 : -1;
}
function Us(r, e, t, n, s) {
  let o = e.href, i = e.title || null, a = r[1].replace(s.other.outputLinkReplace, "$1");
  n.state.inLink = !0;
  let c = { type: r[0].charAt(0) === "!" ? "image" : "link", raw: t, href: o, title: i, text: a, tokens: n.inlineTokens(a) };
  return n.state.inLink = !1, c;
}
function ka(r, e, t) {
  let n = r.match(t.other.indentCodeCompensation);
  if (n === null) return e;
  let s = n[1];
  return e.split(`
`).map((o) => {
    let i = o.match(t.other.beginningSpace);
    if (i === null) return o;
    let [a] = i;
    return a.length >= s.length ? o.slice(s.length) : o;
  }).join(`
`);
}
var Ot = class {
  options;
  rules;
  lexer;
  constructor(r) {
    this.options = r || Ne;
  }
  space(r) {
    let e = this.rules.block.newline.exec(r);
    if (e && e[0].length > 0) return { type: "space", raw: e[0] };
  }
  code(r) {
    let e = this.rules.block.code.exec(r);
    if (e) {
      let t = e[0].replace(this.rules.other.codeRemoveIndent, "");
      return { type: "code", raw: e[0], codeBlockStyle: "indented", text: this.options.pedantic ? t : nt(t, `
`) };
    }
  }
  fences(r) {
    let e = this.rules.block.fences.exec(r);
    if (e) {
      let t = e[0], n = ka(t, e[3] || "", this.rules);
      return { type: "code", raw: t, lang: e[2] ? e[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : e[2], text: n };
    }
  }
  heading(r) {
    let e = this.rules.block.heading.exec(r);
    if (e) {
      let t = e[2].trim();
      if (this.rules.other.endingHash.test(t)) {
        let n = nt(t, "#");
        (this.options.pedantic || !n || this.rules.other.endingSpaceChar.test(n)) && (t = n.trim());
      }
      return { type: "heading", raw: e[0], depth: e[1].length, text: t, tokens: this.lexer.inline(t) };
    }
  }
  hr(r) {
    let e = this.rules.block.hr.exec(r);
    if (e) return { type: "hr", raw: nt(e[0], `
`) };
  }
  blockquote(r) {
    let e = this.rules.block.blockquote.exec(r);
    if (e) {
      let t = nt(e[0], `
`).split(`
`), n = "", s = "", o = [];
      for (; t.length > 0; ) {
        let i = !1, a = [], c;
        for (c = 0; c < t.length; c++) if (this.rules.other.blockquoteStart.test(t[c])) a.push(t[c]), i = !0;
        else if (!i) a.push(t[c]);
        else break;
        t = t.slice(c);
        let d = a.join(`
`), u = d.replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, "");
        n = n ? `${n}
${d}` : d, s = s ? `${s}
${u}` : u;
        let w = this.lexer.state.top;
        if (this.lexer.state.top = !0, this.lexer.blockTokens(u, o, !0), this.lexer.state.top = w, t.length === 0) break;
        let k = o.at(-1);
        if (k?.type === "code") break;
        if (k?.type === "blockquote") {
          let R = k, T = R.raw + `
` + t.join(`
`), y = this.blockquote(T);
          o[o.length - 1] = y, n = n.substring(0, n.length - R.raw.length) + y.raw, s = s.substring(0, s.length - R.text.length) + y.text;
          break;
        } else if (k?.type === "list") {
          let R = k, T = R.raw + `
` + t.join(`
`), y = this.list(T);
          o[o.length - 1] = y, n = n.substring(0, n.length - k.raw.length) + y.raw, s = s.substring(0, s.length - R.raw.length) + y.raw, t = T.substring(o.at(-1).raw.length).split(`
`);
          continue;
        }
      }
      return { type: "blockquote", raw: n, tokens: o, text: s };
    }
  }
  list(r) {
    let e = this.rules.block.list.exec(r);
    if (e) {
      let t = e[1].trim(), n = t.length > 1, s = { type: "list", raw: "", ordered: n, start: n ? +t.slice(0, -1) : "", loose: !1, items: [] };
      t = n ? `\\d{1,9}\\${t.slice(-1)}` : `\\${t}`, this.options.pedantic && (t = n ? t : "[*+-]");
      let o = this.rules.other.listItemRegex(t), i = !1;
      for (; r; ) {
        let c = !1, d = "", u = "";
        if (!(e = o.exec(r)) || this.rules.block.hr.test(r)) break;
        d = e[0], r = r.substring(d.length);
        let w = e[2].split(`
`, 1)[0].replace(this.rules.other.listReplaceTabs, (J) => " ".repeat(3 * J.length)), k = r.split(`
`, 1)[0], R = !w.trim(), T = 0;
        if (this.options.pedantic ? (T = 2, u = w.trimStart()) : R ? T = e[1].length + 1 : (T = e[2].search(this.rules.other.nonSpaceChar), T = T > 4 ? 1 : T, u = w.slice(T), T += e[1].length), R && this.rules.other.blankLine.test(k) && (d += k + `
`, r = r.substring(k.length + 1), c = !0), !c) {
          let J = this.rules.other.nextBulletRegex(T), ye = this.rules.other.hrRegex(T), re = this.rules.other.fencesBeginRegex(T), N = this.rules.other.headingBeginRegex(T), Te = this.rules.other.htmlBeginRegex(T);
          for (; r; ) {
            let Ee = r.split(`
`, 1)[0], Ce;
            if (k = Ee, this.options.pedantic ? (k = k.replace(this.rules.other.listReplaceNesting, "  "), Ce = k) : Ce = k.replace(this.rules.other.tabCharGlobal, "    "), re.test(k) || N.test(k) || Te.test(k) || J.test(k) || ye.test(k)) break;
            if (Ce.search(this.rules.other.nonSpaceChar) >= T || !k.trim()) u += `
` + Ce.slice(T);
            else {
              if (R || w.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || re.test(w) || N.test(w) || ye.test(w)) break;
              u += `
` + k;
            }
            !R && !k.trim() && (R = !0), d += Ee + `
`, r = r.substring(Ee.length + 1), w = Ce.slice(T);
          }
        }
        s.loose || (i ? s.loose = !0 : this.rules.other.doubleBlankLine.test(d) && (i = !0));
        let y = null, $;
        this.options.gfm && (y = this.rules.other.listIsTask.exec(u), y && ($ = y[0] !== "[ ] ", u = u.replace(this.rules.other.listReplaceTask, ""))), s.items.push({ type: "list_item", raw: d, task: !!y, checked: $, loose: !1, text: u, tokens: [] }), s.raw += d;
      }
      let a = s.items.at(-1);
      if (a) a.raw = a.raw.trimEnd(), a.text = a.text.trimEnd();
      else return;
      s.raw = s.raw.trimEnd();
      for (let c = 0; c < s.items.length; c++) if (this.lexer.state.top = !1, s.items[c].tokens = this.lexer.blockTokens(s.items[c].text, []), !s.loose) {
        let d = s.items[c].tokens.filter((w) => w.type === "space"), u = d.length > 0 && d.some((w) => this.rules.other.anyLine.test(w.raw));
        s.loose = u;
      }
      if (s.loose) for (let c = 0; c < s.items.length; c++) s.items[c].loose = !0;
      return s;
    }
  }
  html(r) {
    let e = this.rules.block.html.exec(r);
    if (e) return { type: "html", block: !0, raw: e[0], pre: e[1] === "pre" || e[1] === "script" || e[1] === "style", text: e[0] };
  }
  def(r) {
    let e = this.rules.block.def.exec(r);
    if (e) {
      let t = e[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " "), n = e[2] ? e[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", s = e[3] ? e[3].substring(1, e[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : e[3];
      return { type: "def", tag: t, raw: e[0], href: n, title: s };
    }
  }
  table(r) {
    let e = this.rules.block.table.exec(r);
    if (!e || !this.rules.other.tableDelimiter.test(e[2])) return;
    let t = Fs(e[1]), n = e[2].replace(this.rules.other.tableAlignChars, "").split("|"), s = e[3]?.trim() ? e[3].replace(this.rules.other.tableRowBlankLine, "").split(`
`) : [], o = { type: "table", raw: e[0], header: [], align: [], rows: [] };
    if (t.length === n.length) {
      for (let i of n) this.rules.other.tableAlignRight.test(i) ? o.align.push("right") : this.rules.other.tableAlignCenter.test(i) ? o.align.push("center") : this.rules.other.tableAlignLeft.test(i) ? o.align.push("left") : o.align.push(null);
      for (let i = 0; i < t.length; i++) o.header.push({ text: t[i], tokens: this.lexer.inline(t[i]), header: !0, align: o.align[i] });
      for (let i of s) o.rows.push(Fs(i, o.header.length).map((a, c) => ({ text: a, tokens: this.lexer.inline(a), header: !1, align: o.align[c] })));
      return o;
    }
  }
  lheading(r) {
    let e = this.rules.block.lheading.exec(r);
    if (e) return { type: "heading", raw: e[0], depth: e[2].charAt(0) === "=" ? 1 : 2, text: e[1], tokens: this.lexer.inline(e[1]) };
  }
  paragraph(r) {
    let e = this.rules.block.paragraph.exec(r);
    if (e) {
      let t = e[1].charAt(e[1].length - 1) === `
` ? e[1].slice(0, -1) : e[1];
      return { type: "paragraph", raw: e[0], text: t, tokens: this.lexer.inline(t) };
    }
  }
  text(r) {
    let e = this.rules.block.text.exec(r);
    if (e) return { type: "text", raw: e[0], text: e[0], tokens: this.lexer.inline(e[0]) };
  }
  escape(r) {
    let e = this.rules.inline.escape.exec(r);
    if (e) return { type: "escape", raw: e[0], text: e[1] };
  }
  tag(r) {
    let e = this.rules.inline.tag.exec(r);
    if (e) return !this.lexer.state.inLink && this.rules.other.startATag.test(e[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(e[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(e[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(e[0]) && (this.lexer.state.inRawBlock = !1), { type: "html", raw: e[0], inLink: this.lexer.state.inLink, inRawBlock: this.lexer.state.inRawBlock, block: !1, text: e[0] };
  }
  link(r) {
    let e = this.rules.inline.link.exec(r);
    if (e) {
      let t = e[2].trim();
      if (!this.options.pedantic && this.rules.other.startAngleBracket.test(t)) {
        if (!this.rules.other.endAngleBracket.test(t)) return;
        let o = nt(t.slice(0, -1), "\\");
        if ((t.length - o.length) % 2 === 0) return;
      } else {
        let o = _a(e[2], "()");
        if (o === -2) return;
        if (o > -1) {
          let i = (e[0].indexOf("!") === 0 ? 5 : 4) + e[1].length + o;
          e[2] = e[2].substring(0, o), e[0] = e[0].substring(0, i).trim(), e[3] = "";
        }
      }
      let n = e[2], s = "";
      if (this.options.pedantic) {
        let o = this.rules.other.pedanticHrefTitle.exec(n);
        o && (n = o[1], s = o[3]);
      } else s = e[3] ? e[3].slice(1, -1) : "";
      return n = n.trim(), this.rules.other.startAngleBracket.test(n) && (this.options.pedantic && !this.rules.other.endAngleBracket.test(t) ? n = n.slice(1) : n = n.slice(1, -1)), Us(e, { href: n && n.replace(this.rules.inline.anyPunctuation, "$1"), title: s && s.replace(this.rules.inline.anyPunctuation, "$1") }, e[0], this.lexer, this.rules);
    }
  }
  reflink(r, e) {
    let t;
    if ((t = this.rules.inline.reflink.exec(r)) || (t = this.rules.inline.nolink.exec(r))) {
      let n = (t[2] || t[1]).replace(this.rules.other.multipleSpaceGlobal, " "), s = e[n.toLowerCase()];
      if (!s) {
        let o = t[0].charAt(0);
        return { type: "text", raw: o, text: o };
      }
      return Us(t, s, t[0], this.lexer, this.rules);
    }
  }
  emStrong(r, e, t = "") {
    let n = this.rules.inline.emStrongLDelim.exec(r);
    if (!(!n || n[3] && t.match(this.rules.other.unicodeAlphaNumeric)) && (!(n[1] || n[2]) || !t || this.rules.inline.punctuation.exec(t))) {
      let s = [...n[0]].length - 1, o, i, a = s, c = 0, d = n[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
      for (d.lastIndex = 0, e = e.slice(-1 * r.length + s); (n = d.exec(e)) != null; ) {
        if (o = n[1] || n[2] || n[3] || n[4] || n[5] || n[6], !o) continue;
        if (i = [...o].length, n[3] || n[4]) {
          a += i;
          continue;
        } else if ((n[5] || n[6]) && s % 3 && !((s + i) % 3)) {
          c += i;
          continue;
        }
        if (a -= i, a > 0) continue;
        i = Math.min(i, i + a + c);
        let u = [...n[0]][0].length, w = r.slice(0, s + n.index + u + i);
        if (Math.min(s, i) % 2) {
          let R = w.slice(1, -1);
          return { type: "em", raw: w, text: R, tokens: this.lexer.inlineTokens(R) };
        }
        let k = w.slice(2, -2);
        return { type: "strong", raw: w, text: k, tokens: this.lexer.inlineTokens(k) };
      }
    }
  }
  codespan(r) {
    let e = this.rules.inline.code.exec(r);
    if (e) {
      let t = e[2].replace(this.rules.other.newLineCharGlobal, " "), n = this.rules.other.nonSpaceChar.test(t), s = this.rules.other.startingSpaceChar.test(t) && this.rules.other.endingSpaceChar.test(t);
      return n && s && (t = t.substring(1, t.length - 1)), { type: "codespan", raw: e[0], text: t };
    }
  }
  br(r) {
    let e = this.rules.inline.br.exec(r);
    if (e) return { type: "br", raw: e[0] };
  }
  del(r) {
    let e = this.rules.inline.del.exec(r);
    if (e) return { type: "del", raw: e[0], text: e[2], tokens: this.lexer.inlineTokens(e[2]) };
  }
  autolink(r) {
    let e = this.rules.inline.autolink.exec(r);
    if (e) {
      let t, n;
      return e[2] === "@" ? (t = e[1], n = "mailto:" + t) : (t = e[1], n = t), { type: "link", raw: e[0], text: t, href: n, tokens: [{ type: "text", raw: t, text: t }] };
    }
  }
  url(r) {
    let e;
    if (e = this.rules.inline.url.exec(r)) {
      let t, n;
      if (e[2] === "@") t = e[0], n = "mailto:" + t;
      else {
        let s;
        do
          s = e[0], e[0] = this.rules.inline._backpedal.exec(e[0])?.[0] ?? "";
        while (s !== e[0]);
        t = e[0], e[1] === "www." ? n = "http://" + e[0] : n = e[0];
      }
      return { type: "link", raw: e[0], text: t, href: n, tokens: [{ type: "text", raw: t, text: t }] };
    }
  }
  inlineText(r) {
    let e = this.rules.inline.text.exec(r);
    if (e) {
      let t = this.lexer.state.inRawBlock;
      return { type: "text", raw: e[0], text: e[0], escaped: t };
    }
  }
}, be = class Sr {
  tokens;
  options;
  state;
  tokenizer;
  inlineQueue;
  constructor(e) {
    this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = e || Ne, this.options.tokenizer = this.options.tokenizer || new Ot(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = { inLink: !1, inRawBlock: !1, top: !0 };
    let t = { other: V, block: Ct.normal, inline: st.normal };
    this.options.pedantic ? (t.block = Ct.pedantic, t.inline = st.pedantic) : this.options.gfm && (t.block = Ct.gfm, this.options.breaks ? t.inline = st.breaks : t.inline = st.gfm), this.tokenizer.rules = t;
  }
  static get rules() {
    return { block: Ct, inline: st };
  }
  static lex(e, t) {
    return new Sr(t).lex(e);
  }
  static lexInline(e, t) {
    return new Sr(t).inlineTokens(e);
  }
  lex(e) {
    e = e.replace(V.carriageReturn, `
`), this.blockTokens(e, this.tokens);
    for (let t = 0; t < this.inlineQueue.length; t++) {
      let n = this.inlineQueue[t];
      this.inlineTokens(n.src, n.tokens);
    }
    return this.inlineQueue = [], this.tokens;
  }
  blockTokens(e, t = [], n = !1) {
    for (this.options.pedantic && (e = e.replace(V.tabCharGlobal, "    ").replace(V.spaceLine, "")); e; ) {
      let s;
      if (this.options.extensions?.block?.some((i) => (s = i.call({ lexer: this }, e, t)) ? (e = e.substring(s.raw.length), t.push(s), !0) : !1)) continue;
      if (s = this.tokenizer.space(e)) {
        e = e.substring(s.raw.length);
        let i = t.at(-1);
        s.raw.length === 1 && i !== void 0 ? i.raw += `
` : t.push(s);
        continue;
      }
      if (s = this.tokenizer.code(e)) {
        e = e.substring(s.raw.length);
        let i = t.at(-1);
        i?.type === "paragraph" || i?.type === "text" ? (i.raw += (i.raw.endsWith(`
`) ? "" : `
`) + s.raw, i.text += `
` + s.text, this.inlineQueue.at(-1).src = i.text) : t.push(s);
        continue;
      }
      if (s = this.tokenizer.fences(e)) {
        e = e.substring(s.raw.length), t.push(s);
        continue;
      }
      if (s = this.tokenizer.heading(e)) {
        e = e.substring(s.raw.length), t.push(s);
        continue;
      }
      if (s = this.tokenizer.hr(e)) {
        e = e.substring(s.raw.length), t.push(s);
        continue;
      }
      if (s = this.tokenizer.blockquote(e)) {
        e = e.substring(s.raw.length), t.push(s);
        continue;
      }
      if (s = this.tokenizer.list(e)) {
        e = e.substring(s.raw.length), t.push(s);
        continue;
      }
      if (s = this.tokenizer.html(e)) {
        e = e.substring(s.raw.length), t.push(s);
        continue;
      }
      if (s = this.tokenizer.def(e)) {
        e = e.substring(s.raw.length);
        let i = t.at(-1);
        i?.type === "paragraph" || i?.type === "text" ? (i.raw += (i.raw.endsWith(`
`) ? "" : `
`) + s.raw, i.text += `
` + s.raw, this.inlineQueue.at(-1).src = i.text) : this.tokens.links[s.tag] || (this.tokens.links[s.tag] = { href: s.href, title: s.title }, t.push(s));
        continue;
      }
      if (s = this.tokenizer.table(e)) {
        e = e.substring(s.raw.length), t.push(s);
        continue;
      }
      if (s = this.tokenizer.lheading(e)) {
        e = e.substring(s.raw.length), t.push(s);
        continue;
      }
      let o = e;
      if (this.options.extensions?.startBlock) {
        let i = 1 / 0, a = e.slice(1), c;
        this.options.extensions.startBlock.forEach((d) => {
          c = d.call({ lexer: this }, a), typeof c == "number" && c >= 0 && (i = Math.min(i, c));
        }), i < 1 / 0 && i >= 0 && (o = e.substring(0, i + 1));
      }
      if (this.state.top && (s = this.tokenizer.paragraph(o))) {
        let i = t.at(-1);
        n && i?.type === "paragraph" ? (i.raw += (i.raw.endsWith(`
`) ? "" : `
`) + s.raw, i.text += `
` + s.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = i.text) : t.push(s), n = o.length !== e.length, e = e.substring(s.raw.length);
        continue;
      }
      if (s = this.tokenizer.text(e)) {
        e = e.substring(s.raw.length);
        let i = t.at(-1);
        i?.type === "text" ? (i.raw += (i.raw.endsWith(`
`) ? "" : `
`) + s.raw, i.text += `
` + s.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = i.text) : t.push(s);
        continue;
      }
      if (e) {
        let i = "Infinite loop on byte: " + e.charCodeAt(0);
        if (this.options.silent) {
          console.error(i);
          break;
        } else throw new Error(i);
      }
    }
    return this.state.top = !0, t;
  }
  inline(e, t = []) {
    return this.inlineQueue.push({ src: e, tokens: t }), t;
  }
  inlineTokens(e, t = []) {
    let n = e, s = null;
    if (this.tokens.links) {
      let a = Object.keys(this.tokens.links);
      if (a.length > 0) for (; (s = this.tokenizer.rules.inline.reflinkSearch.exec(n)) != null; ) a.includes(s[0].slice(s[0].lastIndexOf("[") + 1, -1)) && (n = n.slice(0, s.index) + "[" + "a".repeat(s[0].length - 2) + "]" + n.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
    }
    for (; (s = this.tokenizer.rules.inline.anyPunctuation.exec(n)) != null; ) n = n.slice(0, s.index) + "++" + n.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
    for (; (s = this.tokenizer.rules.inline.blockSkip.exec(n)) != null; ) n = n.slice(0, s.index) + "[" + "a".repeat(s[0].length - 2) + "]" + n.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    n = this.options.hooks?.emStrongMask?.call({ lexer: this }, n) ?? n;
    let o = !1, i = "";
    for (; e; ) {
      o || (i = ""), o = !1;
      let a;
      if (this.options.extensions?.inline?.some((d) => (a = d.call({ lexer: this }, e, t)) ? (e = e.substring(a.raw.length), t.push(a), !0) : !1)) continue;
      if (a = this.tokenizer.escape(e)) {
        e = e.substring(a.raw.length), t.push(a);
        continue;
      }
      if (a = this.tokenizer.tag(e)) {
        e = e.substring(a.raw.length), t.push(a);
        continue;
      }
      if (a = this.tokenizer.link(e)) {
        e = e.substring(a.raw.length), t.push(a);
        continue;
      }
      if (a = this.tokenizer.reflink(e, this.tokens.links)) {
        e = e.substring(a.raw.length);
        let d = t.at(-1);
        a.type === "text" && d?.type === "text" ? (d.raw += a.raw, d.text += a.text) : t.push(a);
        continue;
      }
      if (a = this.tokenizer.emStrong(e, n, i)) {
        e = e.substring(a.raw.length), t.push(a);
        continue;
      }
      if (a = this.tokenizer.codespan(e)) {
        e = e.substring(a.raw.length), t.push(a);
        continue;
      }
      if (a = this.tokenizer.br(e)) {
        e = e.substring(a.raw.length), t.push(a);
        continue;
      }
      if (a = this.tokenizer.del(e)) {
        e = e.substring(a.raw.length), t.push(a);
        continue;
      }
      if (a = this.tokenizer.autolink(e)) {
        e = e.substring(a.raw.length), t.push(a);
        continue;
      }
      if (!this.state.inLink && (a = this.tokenizer.url(e))) {
        e = e.substring(a.raw.length), t.push(a);
        continue;
      }
      let c = e;
      if (this.options.extensions?.startInline) {
        let d = 1 / 0, u = e.slice(1), w;
        this.options.extensions.startInline.forEach((k) => {
          w = k.call({ lexer: this }, u), typeof w == "number" && w >= 0 && (d = Math.min(d, w));
        }), d < 1 / 0 && d >= 0 && (c = e.substring(0, d + 1));
      }
      if (a = this.tokenizer.inlineText(c)) {
        e = e.substring(a.raw.length), a.raw.slice(-1) !== "_" && (i = a.raw.slice(-1)), o = !0;
        let d = t.at(-1);
        d?.type === "text" ? (d.raw += a.raw, d.text += a.text) : t.push(a);
        continue;
      }
      if (e) {
        let d = "Infinite loop on byte: " + e.charCodeAt(0);
        if (this.options.silent) {
          console.error(d);
          break;
        } else throw new Error(d);
      }
    }
    return t;
  }
}, Lt = class {
  options;
  parser;
  constructor(r) {
    this.options = r || Ne;
  }
  space(r) {
    return "";
  }
  code({ text: r, lang: e, escaped: t }) {
    let n = (e || "").match(V.notSpaceStart)?.[0], s = r.replace(V.endingNewline, "") + `
`;
    return n ? '<pre><code class="language-' + he(n) + '">' + (t ? s : he(s, !0)) + `</code></pre>
` : "<pre><code>" + (t ? s : he(s, !0)) + `</code></pre>
`;
  }
  blockquote({ tokens: r }) {
    return `<blockquote>
${this.parser.parse(r)}</blockquote>
`;
  }
  html({ text: r }) {
    return r;
  }
  def(r) {
    return "";
  }
  heading({ tokens: r, depth: e }) {
    return `<h${e}>${this.parser.parseInline(r)}</h${e}>
`;
  }
  hr(r) {
    return `<hr>
`;
  }
  list(r) {
    let e = r.ordered, t = r.start, n = "";
    for (let i = 0; i < r.items.length; i++) {
      let a = r.items[i];
      n += this.listitem(a);
    }
    let s = e ? "ol" : "ul", o = e && t !== 1 ? ' start="' + t + '"' : "";
    return "<" + s + o + `>
` + n + "</" + s + `>
`;
  }
  listitem(r) {
    let e = "";
    if (r.task) {
      let t = this.checkbox({ checked: !!r.checked });
      r.loose ? r.tokens[0]?.type === "paragraph" ? (r.tokens[0].text = t + " " + r.tokens[0].text, r.tokens[0].tokens && r.tokens[0].tokens.length > 0 && r.tokens[0].tokens[0].type === "text" && (r.tokens[0].tokens[0].text = t + " " + he(r.tokens[0].tokens[0].text), r.tokens[0].tokens[0].escaped = !0)) : r.tokens.unshift({ type: "text", raw: t + " ", text: t + " ", escaped: !0 }) : e += t + " ";
    }
    return e += this.parser.parse(r.tokens, !!r.loose), `<li>${e}</li>
`;
  }
  checkbox({ checked: r }) {
    return "<input " + (r ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
  }
  paragraph({ tokens: r }) {
    return `<p>${this.parser.parseInline(r)}</p>
`;
  }
  table(r) {
    let e = "", t = "";
    for (let s = 0; s < r.header.length; s++) t += this.tablecell(r.header[s]);
    e += this.tablerow({ text: t });
    let n = "";
    for (let s = 0; s < r.rows.length; s++) {
      let o = r.rows[s];
      t = "";
      for (let i = 0; i < o.length; i++) t += this.tablecell(o[i]);
      n += this.tablerow({ text: t });
    }
    return n && (n = `<tbody>${n}</tbody>`), `<table>
<thead>
` + e + `</thead>
` + n + `</table>
`;
  }
  tablerow({ text: r }) {
    return `<tr>
${r}</tr>
`;
  }
  tablecell(r) {
    let e = this.parser.parseInline(r.tokens), t = r.header ? "th" : "td";
    return (r.align ? `<${t} align="${r.align}">` : `<${t}>`) + e + `</${t}>
`;
  }
  strong({ tokens: r }) {
    return `<strong>${this.parser.parseInline(r)}</strong>`;
  }
  em({ tokens: r }) {
    return `<em>${this.parser.parseInline(r)}</em>`;
  }
  codespan({ text: r }) {
    return `<code>${he(r, !0)}</code>`;
  }
  br(r) {
    return "<br>";
  }
  del({ tokens: r }) {
    return `<del>${this.parser.parseInline(r)}</del>`;
  }
  link({ href: r, title: e, tokens: t }) {
    let n = this.parser.parseInline(t), s = zs(r);
    if (s === null) return n;
    r = s;
    let o = '<a href="' + r + '"';
    return e && (o += ' title="' + he(e) + '"'), o += ">" + n + "</a>", o;
  }
  image({ href: r, title: e, text: t, tokens: n }) {
    n && (t = this.parser.parseInline(n, this.parser.textRenderer));
    let s = zs(r);
    if (s === null) return he(t);
    r = s;
    let o = `<img src="${r}" alt="${t}"`;
    return e && (o += ` title="${he(e)}"`), o += ">", o;
  }
  text(r) {
    return "tokens" in r && r.tokens ? this.parser.parseInline(r.tokens) : "escaped" in r && r.escaped ? r.text : he(r.text);
  }
}, Wr = class {
  strong({ text: r }) {
    return r;
  }
  em({ text: r }) {
    return r;
  }
  codespan({ text: r }) {
    return r;
  }
  del({ text: r }) {
    return r;
  }
  html({ text: r }) {
    return r;
  }
  text({ text: r }) {
    return r;
  }
  link({ text: r }) {
    return "" + r;
  }
  image({ text: r }) {
    return "" + r;
  }
  br() {
    return "";
  }
}, ve = class Tr {
  options;
  renderer;
  textRenderer;
  constructor(e) {
    this.options = e || Ne, this.options.renderer = this.options.renderer || new Lt(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new Wr();
  }
  static parse(e, t) {
    return new Tr(t).parse(e);
  }
  static parseInline(e, t) {
    return new Tr(t).parseInline(e);
  }
  parse(e, t = !0) {
    let n = "";
    for (let s = 0; s < e.length; s++) {
      let o = e[s];
      if (this.options.extensions?.renderers?.[o.type]) {
        let a = o, c = this.options.extensions.renderers[a.type].call({ parser: this }, a);
        if (c !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "def", "paragraph", "text"].includes(a.type)) {
          n += c || "";
          continue;
        }
      }
      let i = o;
      switch (i.type) {
        case "space": {
          n += this.renderer.space(i);
          continue;
        }
        case "hr": {
          n += this.renderer.hr(i);
          continue;
        }
        case "heading": {
          n += this.renderer.heading(i);
          continue;
        }
        case "code": {
          n += this.renderer.code(i);
          continue;
        }
        case "table": {
          n += this.renderer.table(i);
          continue;
        }
        case "blockquote": {
          n += this.renderer.blockquote(i);
          continue;
        }
        case "list": {
          n += this.renderer.list(i);
          continue;
        }
        case "html": {
          n += this.renderer.html(i);
          continue;
        }
        case "def": {
          n += this.renderer.def(i);
          continue;
        }
        case "paragraph": {
          n += this.renderer.paragraph(i);
          continue;
        }
        case "text": {
          let a = i, c = this.renderer.text(a);
          for (; s + 1 < e.length && e[s + 1].type === "text"; ) a = e[++s], c += `
` + this.renderer.text(a);
          t ? n += this.renderer.paragraph({ type: "paragraph", raw: c, text: c, tokens: [{ type: "text", raw: c, text: c, escaped: !0 }] }) : n += c;
          continue;
        }
        default: {
          let a = 'Token with "' + i.type + '" type was not found.';
          if (this.options.silent) return console.error(a), "";
          throw new Error(a);
        }
      }
    }
    return n;
  }
  parseInline(e, t = this.renderer) {
    let n = "";
    for (let s = 0; s < e.length; s++) {
      let o = e[s];
      if (this.options.extensions?.renderers?.[o.type]) {
        let a = this.options.extensions.renderers[o.type].call({ parser: this }, o);
        if (a !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(o.type)) {
          n += a || "";
          continue;
        }
      }
      let i = o;
      switch (i.type) {
        case "escape": {
          n += t.text(i);
          break;
        }
        case "html": {
          n += t.html(i);
          break;
        }
        case "link": {
          n += t.link(i);
          break;
        }
        case "image": {
          n += t.image(i);
          break;
        }
        case "strong": {
          n += t.strong(i);
          break;
        }
        case "em": {
          n += t.em(i);
          break;
        }
        case "codespan": {
          n += t.codespan(i);
          break;
        }
        case "br": {
          n += t.br(i);
          break;
        }
        case "del": {
          n += t.del(i);
          break;
        }
        case "text": {
          n += t.text(i);
          break;
        }
        default: {
          let a = 'Token with "' + i.type + '" type was not found.';
          if (this.options.silent) return console.error(a), "";
          throw new Error(a);
        }
      }
    }
    return n;
  }
}, it = class {
  options;
  block;
  constructor(r) {
    this.options = r || Ne;
  }
  static passThroughHooks = /* @__PURE__ */ new Set(["preprocess", "postprocess", "processAllTokens", "emStrongMask"]);
  static passThroughHooksRespectAsync = /* @__PURE__ */ new Set(["preprocess", "postprocess", "processAllTokens"]);
  preprocess(r) {
    return r;
  }
  postprocess(r) {
    return r;
  }
  processAllTokens(r) {
    return r;
  }
  emStrongMask(r) {
    return r;
  }
  provideLexer() {
    return this.block ? be.lex : be.lexInline;
  }
  provideParser() {
    return this.block ? ve.parse : ve.parseInline;
  }
}, xa = class {
  defaults = Lr();
  options = this.setOptions;
  parse = this.parseMarkdown(!0);
  parseInline = this.parseMarkdown(!1);
  Parser = ve;
  Renderer = Lt;
  TextRenderer = Wr;
  Lexer = be;
  Tokenizer = Ot;
  Hooks = it;
  constructor(...r) {
    this.use(...r);
  }
  walkTokens(r, e) {
    let t = [];
    for (let n of r) switch (t = t.concat(e.call(this, n)), n.type) {
      case "table": {
        let s = n;
        for (let o of s.header) t = t.concat(this.walkTokens(o.tokens, e));
        for (let o of s.rows) for (let i of o) t = t.concat(this.walkTokens(i.tokens, e));
        break;
      }
      case "list": {
        let s = n;
        t = t.concat(this.walkTokens(s.items, e));
        break;
      }
      default: {
        let s = n;
        this.defaults.extensions?.childTokens?.[s.type] ? this.defaults.extensions.childTokens[s.type].forEach((o) => {
          let i = s[o].flat(1 / 0);
          t = t.concat(this.walkTokens(i, e));
        }) : s.tokens && (t = t.concat(this.walkTokens(s.tokens, e)));
      }
    }
    return t;
  }
  use(...r) {
    let e = this.defaults.extensions || { renderers: {}, childTokens: {} };
    return r.forEach((t) => {
      let n = { ...t };
      if (n.async = this.defaults.async || n.async || !1, t.extensions && (t.extensions.forEach((s) => {
        if (!s.name) throw new Error("extension name required");
        if ("renderer" in s) {
          let o = e.renderers[s.name];
          o ? e.renderers[s.name] = function(...i) {
            let a = s.renderer.apply(this, i);
            return a === !1 && (a = o.apply(this, i)), a;
          } : e.renderers[s.name] = s.renderer;
        }
        if ("tokenizer" in s) {
          if (!s.level || s.level !== "block" && s.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
          let o = e[s.level];
          o ? o.unshift(s.tokenizer) : e[s.level] = [s.tokenizer], s.start && (s.level === "block" ? e.startBlock ? e.startBlock.push(s.start) : e.startBlock = [s.start] : s.level === "inline" && (e.startInline ? e.startInline.push(s.start) : e.startInline = [s.start]));
        }
        "childTokens" in s && s.childTokens && (e.childTokens[s.name] = s.childTokens);
      }), n.extensions = e), t.renderer) {
        let s = this.defaults.renderer || new Lt(this.defaults);
        for (let o in t.renderer) {
          if (!(o in s)) throw new Error(`renderer '${o}' does not exist`);
          if (["options", "parser"].includes(o)) continue;
          let i = o, a = t.renderer[i], c = s[i];
          s[i] = (...d) => {
            let u = a.apply(s, d);
            return u === !1 && (u = c.apply(s, d)), u || "";
          };
        }
        n.renderer = s;
      }
      if (t.tokenizer) {
        let s = this.defaults.tokenizer || new Ot(this.defaults);
        for (let o in t.tokenizer) {
          if (!(o in s)) throw new Error(`tokenizer '${o}' does not exist`);
          if (["options", "rules", "lexer"].includes(o)) continue;
          let i = o, a = t.tokenizer[i], c = s[i];
          s[i] = (...d) => {
            let u = a.apply(s, d);
            return u === !1 && (u = c.apply(s, d)), u;
          };
        }
        n.tokenizer = s;
      }
      if (t.hooks) {
        let s = this.defaults.hooks || new it();
        for (let o in t.hooks) {
          if (!(o in s)) throw new Error(`hook '${o}' does not exist`);
          if (["options", "block"].includes(o)) continue;
          let i = o, a = t.hooks[i], c = s[i];
          it.passThroughHooks.has(o) ? s[i] = (d) => {
            if (this.defaults.async && it.passThroughHooksRespectAsync.has(o)) return Promise.resolve(a.call(s, d)).then((w) => c.call(s, w));
            let u = a.call(s, d);
            return c.call(s, u);
          } : s[i] = (...d) => {
            let u = a.apply(s, d);
            return u === !1 && (u = c.apply(s, d)), u;
          };
        }
        n.hooks = s;
      }
      if (t.walkTokens) {
        let s = this.defaults.walkTokens, o = t.walkTokens;
        n.walkTokens = function(i) {
          let a = [];
          return a.push(o.call(this, i)), s && (a = a.concat(s.call(this, i))), a;
        };
      }
      this.defaults = { ...this.defaults, ...n };
    }), this;
  }
  setOptions(r) {
    return this.defaults = { ...this.defaults, ...r }, this;
  }
  lexer(r, e) {
    return be.lex(r, e ?? this.defaults);
  }
  parser(r, e) {
    return ve.parse(r, e ?? this.defaults);
  }
  parseMarkdown(r) {
    return (e, t) => {
      let n = { ...t }, s = { ...this.defaults, ...n }, o = this.onError(!!s.silent, !!s.async);
      if (this.defaults.async === !0 && n.async === !1) return o(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
      if (typeof e > "u" || e === null) return o(new Error("marked(): input parameter is undefined or null"));
      if (typeof e != "string") return o(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(e) + ", string expected"));
      s.hooks && (s.hooks.options = s, s.hooks.block = r);
      let i = s.hooks ? s.hooks.provideLexer() : r ? be.lex : be.lexInline, a = s.hooks ? s.hooks.provideParser() : r ? ve.parse : ve.parseInline;
      if (s.async) return Promise.resolve(s.hooks ? s.hooks.preprocess(e) : e).then((c) => i(c, s)).then((c) => s.hooks ? s.hooks.processAllTokens(c) : c).then((c) => s.walkTokens ? Promise.all(this.walkTokens(c, s.walkTokens)).then(() => c) : c).then((c) => a(c, s)).then((c) => s.hooks ? s.hooks.postprocess(c) : c).catch(o);
      try {
        s.hooks && (e = s.hooks.preprocess(e));
        let c = i(e, s);
        s.hooks && (c = s.hooks.processAllTokens(c)), s.walkTokens && this.walkTokens(c, s.walkTokens);
        let d = a(c, s);
        return s.hooks && (d = s.hooks.postprocess(d)), d;
      } catch (c) {
        return o(c);
      }
    };
  }
  onError(r, e) {
    return (t) => {
      if (t.message += `
Please report this to https://github.com/markedjs/marked.`, r) {
        let n = "<p>An error occurred:</p><pre>" + he(t.message + "", !0) + "</pre>";
        return e ? Promise.resolve(n) : n;
      }
      if (e) return Promise.reject(t);
      throw t;
    };
  }
}, De = new xa();
function x(r, e) {
  return De.parse(r, e);
}
x.options = x.setOptions = function(r) {
  return De.setOptions(r), x.defaults = De.defaults, En(x.defaults), x;
};
x.getDefaults = Lr;
x.defaults = Ne;
x.use = function(...r) {
  return De.use(...r), x.defaults = De.defaults, En(x.defaults), x;
};
x.walkTokens = function(r, e) {
  return De.walkTokens(r, e);
};
x.parseInline = De.parseInline;
x.Parser = ve;
x.parser = ve.parse;
x.Renderer = Lt;
x.TextRenderer = Wr;
x.Lexer = be;
x.lexer = be.lex;
x.Tokenizer = Ot;
x.Hooks = it;
x.parse = x;
x.options;
x.setOptions;
x.use;
x.walkTokens;
x.parseInline;
ve.parse;
be.lex;
const Ge = new x.Renderer(), Nn = (r) => `<div class="overflow-x-auto"><div class="flex w-fit flex-col-reverse mr-4">${r}</div></div>`;
Ge.code = (r) => Nn(x.Renderer.prototype.code.call(Ge, r));
Ge.table = (r) => Nn(x.Renderer.prototype.table.call(Ge, r));
Ge.link = (r) => `<a href="${r.href}" target="_blank" rel="noopener noreferrer">${r.text}</a>`;
x.setOptions({ gfm: !0, breaks: !1, renderer: Ge });
let Hs = !1;
Hs || (Tn.addHook("afterSanitizeAttributes", (r) => {
  r.tagName === "A" && (r.setAttribute("target", "_blank"), r.setAttribute("rel", "noopener noreferrer"));
}), Hs = !0);
function Sa(r) {
  const e = x.parse(r, { async: !1 });
  return Tn.sanitize(e, { USE_PROFILES: { html: !0 } });
}
var Ta = Object.defineProperty, Ea = (r, e, t, n) => {
  for (var s = void 0, o = r.length - 1, i; o >= 0; o--)
    (i = r[o]) && (s = i(e, t, s) || s);
  return s && Ta(e, t, s), s;
};
class mt extends ie {
  constructor() {
    super(...arguments), this.position = "left";
  }
  connectedCallback() {
    super.connectedCallback(), this.setAttribute("role", "article");
  }
  isHidden() {
    return !1;
  }
  renderHeader() {
    return G;
  }
  renderBody() {
    return G;
  }
  renderFooter() {
    return G;
  }
  render() {
    return this.isHidden() ? G : b`<div class="relative w-full py-3 text-sm">
      <div class="group/message mx-auto my-auto px-3">
        <div class="flex max-w-full min-w-0 flex-grow-1 flex-col">
          <div
            class=${$e("relative flex flex-col empty:hidden", {
      "items-end": this.position === "right",
      "items-start": this.position === "left",
      "items-center": this.position === "center"
    })}
          >
            ${this.renderHeader()}
          </div>
          <div
            class="relative flex min-h-8 w-full flex-col items-end gap-2 text-start break-words whitespace-normal"
          >
            <div
              class=${$e("flex w-full flex-col gap-1 empty:hidden text-message", {
      "items-end": this.position === "right",
      "items-start": this.position === "left",
      "items-center": this.position === "center"
    })}
            >
              ${this.renderBody()}
            </div>
          </div>
        </div>
        <div
          class=${$e("flex justify-start empty:hidden", {
      "justify-end": this.position === "right",
      "justify-start": this.position === "left",
      "justify-center": this.position === "center"
    })}
        >
          ${this.renderFooter()}
        </div>
      </div>
    </div>`;
  }
}
Ea([
  E({ attribute: !1 })
], mt.prototype, "message");
var Ca = Object.defineProperty, Ia = Object.getOwnPropertyDescriptor, zn = (r, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? Ia(e, t) : e, o = r.length - 1, i; o >= 0; o--)
    (i = r[o]) && (s = (n ? i(e, t, s) : i(s)) || s);
  return n && s && Ca(e, t, s), s;
};
let Er = class extends mt {
  constructor() {
    super(...arguments), this.citationsExpanded = !1;
  }
  toggleCitations() {
    this.citationsExpanded = !this.citationsExpanded;
  }
  approveToolCall() {
    this.message.role === "assistant" && this.dispatchEvent(new ei(this.message.turnId, this.message.messageId));
  }
  declineToolCall() {
    this.message.role === "assistant" && this.dispatchEvent(new ti(this.message.turnId, this.message.messageId));
  }
  isHidden() {
    return !("content" in this.message) || !this.message.content;
  }
  renderHeader() {
    return b`<div class="text-primary-900 mb-1 flex h-6 items-center gap-x-2">
        <div class="flex size-4 items-center justify-center">${M(ht)}</div>
        <span class="text-sm font-medium">GAiA</span>
      </div>
      ${ks(
      [this.message.citations.length, this.citationsExpanded],
      () => this.message.citations.length ? b`<div class="text-primary-800 hover:text-primary-900 text-xs font-semibold">
              <button
                class="group flex items-center gap-2 select-none"
                aria-expanded=${this.citationsExpanded}
                @click=${this.toggleCitations}
              >
                <div
                  class="flex size-4 items-center justify-center transition-transform duration-200 ease-in-out not-group-aria-expanded:-rotate-90"
                >
                  ${M(bi)}
                </div>
                ${v(Po`Used ${this.message.citations.length} sources`, {
        id: "assistant-message-citations-length"
      })}
              </button>
              <section
                class=${$e(
        "relative grid gap-2 transition-[transform,opacity,height,visibility] duration-200 ease-in-out overflow-hidden",
        {
          "h-0 invisible opacity-0": !this.citationsExpanded,
          "h-auto py-2 visible opacity-100": this.citationsExpanded
        }
      )}
              >
                ${on(
        this.message.citations,
        (r) => r.url,
        (r) => b`<div class="flex min-w-0 items-center gap-2 overflow-x-clip">
                      <div class="flex size-4 items-center justify-center">
                        ${M(yi)}
                      </div>
                      <a
                        href=${r.url}
                        class="truncate hover:underline"
                        target="_blank"
                        rel="noopener noreferrer"
                        title=${r.url}
                      >
                        ${r.title}
                      </a>
                    </div>`
      )}
              </section>
            </div>` : G
    )}`;
  }
  renderBody() {
    return ks(this.message.content.length, () => b` <div class="prose prose-gaia prose-table:min-w-max">
        ${nn(Sa(this.message.content))}
      </div>`);
  }
  renderFooter() {
    return this.message.approvalStatus ? b`
          <div
            class="mt-2 flex items-center justify-center gap-x-2"
            data-status=${this.message.approvalStatus}
          >
            <button
              @click=${this.approveToolCall}
              data-testid="assistant-message-approve-btn"
              .disabled=${this.message.approvalStatus !== "approvalRequested"}
              class=${$e("btn btn-secondary w-fit border border-solid px-4 py-2", {
      "bg-green-100 border-green-600 text-primary-900 [&_svg]:text-green-600": this.message.approvalStatus === "approved"
    })}
            >
              <div class="flex items-center justify-center gap-2">
                <div class="flex size-4 items-center justify-center">${M(wi)}</div>
                <span class="text-sm">${v("Yes", { id: "assistant-message-approve" })}</span>
              </div>
            </button>
            <button
              @click=${this.declineToolCall}
              data-testid="assistant-message-decline-btn"
              .disabled=${this.message.approvalStatus !== "approvalRequested"}
              data-selected=${this.message.approvalStatus === "declined"}
              class=${$e("btn btn-secondary w-fit border border-solid px-4 py-2", {
      "bg-red-100 border-red-600 text-primary-900 [&_svg]:text-red-600": this.message.approvalStatus === "declined"
    })}
            >
              <div class="flex items-center justify-center gap-2">
                <div class="flex size-4 items-center justify-center">${M(vi)}</div>
                <span class="text-sm">${v("No", { id: "assistant-message-decline" })}</span>
              </div>
            </button>
          </div>
        ` : G;
  }
};
zn([
  Se()
], Er.prototype, "citationsExpanded", 2);
Er = zn([
  te("gaia-chat-assistant-message")
], Er);
const Fn = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-headset-icon lucide-headset"><path d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z"/><path d="M21 16v2a4 4 0 0 1-4 4h-5"/></svg>';
var Aa = Object.getOwnPropertyDescriptor, Ra = (r, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? Aa(e, t) : e, o = r.length - 1, i; o >= 0; o--)
    (i = r[o]) && (s = i(s) || s);
  return s;
};
let Bs = class extends mt {
  renderHeader() {
    return b`<div class="flex items-center gap-1 pb-1">
      <div class="relative size-6 p-0.5">
        <div class="aspect-square h-full w-full overflow-hidden rounded-full">
          ${this.message.operator.pictureUrl ? b`<img
                src=${this.message.operator.pictureUrl}
                alt=${this.message.operator.name}
                class="object-cover"
              />` : b`<div class="text-primary-900 flex h-full w-full items-center justify-center">
                <div class="size-4">${M(Fn)}</div>
              </div>`}
        </div>
      </div>
      <span class="text-primary-900 text-sm font-medium">${this.message.operator.name}</span>
    </div>`;
  }
  renderBody() {
    return !("content" in this.message) || !this.message.content ? null : b` <div
      class="relative flex min-h-9 w-fit max-w-[90%] rounded-sm bg-neutral-100 px-4 py-1.5"
    >
      ${this.message.isTyping ? b`<div class="flex items-center space-x-1">
            <span class="animate-grow h-2 w-2 rounded-full bg-neutral-600"></span>
            <span
              class="animate-grow h-2 w-2 rounded-full bg-neutral-600 [animation-delay:0.3s]"
            ></span>
            <span
              class="animate-grow h-2 w-2 rounded-full bg-neutral-600 [animation-delay:0.6s]"
            ></span>
          </div> ` : b`<div class="text-primary-900 whitespace-pre-wrap">${this.message.content}</div>`}
    </div>`;
  }
};
Bs = Ra([
  te("gaia-chat-operator-message")
], Bs);
var $a = Object.getOwnPropertyDescriptor, Pa = (r, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? $a(e, t) : e, o = r.length - 1, i; o >= 0; o--)
    (i = r[o]) && (s = i(s) || s);
  return s;
};
let js = class extends mt {
  constructor() {
    super(...arguments), this.position = "center";
  }
  isHidden() {
    return this.message.isVisuallyHidden;
  }
  clearConversation() {
    this.dispatchEvent(new Mr());
  }
  openFeedbackForm() {
    this.dispatchEvent(new Pr("support"));
  }
  renderBody() {
    return this.message.isSupportStartedMarker ? b`<div
        class="m-0 grid w-full grid-cols-[auto_1fr_auto] gap-2 rounded-sm border border-solid border-neutral-600 p-4 [grid-template-areas:'leading_primary']"
      >
        <div class="text-primary-900 flex flex-col gap-2 text-sm [grid-area:primary]">
          <span
            >${v("You have been connected to a human support agent.", {
      id: "system-message-support-started"
    })}</span
          >
        </div>
        <div class="flex [grid-area:leading]">
          <div class="text-primary-900 flex size-5 items-center justify-center">
            ${M(Fn)}
          </div>
        </div>
      </div>` : this.message.isSupportCompletedMarker ? b`<div
        class="m-0 grid w-full grid-cols-[auto_1fr_auto] gap-2 rounded-sm border border-solid border-neutral-600 p-4 [grid-template-areas:'leading_primary']"
      >
        <div class="text-primary-900 flex flex-col gap-2 text-sm [grid-area:primary]">
          <span
            >${v("You have been disconnected from the human support agent.", {
      id: "system-message-support-completed"
    })}</span
          >
          <span class="text-neutral-700">
            ${v(
      "To continue, please start a new conversation. We'd also love to hear your feedback on our human support experience!",
      { id: "system-message-support-feedback" }
    )}
          </span>

          <div class="mt-3 flex flex-col gap-4 @md:flex-row">
            <button class="btn btn-primary px-4 py-2" @click=${this.clearConversation}>
              <div class="flex items-center justify-center gap-x-2">
                <div class="flex size-4 items-center justify-center">
                  ${M(wn)}
                </div>
                ${v("Start New Conversation", {
      id: "system-message-start-new-conversation"
    })}
              </div>
            </button>
            <button class="btn btn-secondary px-4 py-2" @click=${this.openFeedbackForm}>
              <div class="flex items-center justify-center gap-x-2">
                <div class="flex size-4 items-center justify-center">
                  ${M(mn)}
                </div>
                ${v("Provide Feedback", {
      id: "system-message-provide-feedback"
    })}
              </div>
            </button>
          </div>
        </div>
        <div class="flex [grid-area:leading]">
          <div class="text-primary-900 flex size-5 items-center justify-center">
            ${M($r)}
          </div>
        </div>
      </div>` : G;
  }
};
js = Pa([
  te("gaia-chat-system-message")
], js);
var Ma = Object.getOwnPropertyDescriptor, Da = (r, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? Ma(e, t) : e, o = r.length - 1, i; o >= 0; o--)
    (i = r[o]) && (s = i(s) || s);
  return s;
};
let Ws = class extends mt {
  constructor() {
    super(...arguments), this.position = "right";
  }
  renderBody() {
    return !("content" in this.message) || !this.message.content ? null : b` <div class="relative max-w-[90%] rounded-sm bg-blue-100 px-4 py-1.5">
      <div class="whitespace-pre-wrap">${this.message.content}</div>
    </div>`;
  }
};
Ws = Da([
  te("gaia-chat-user-message")
], Ws);
var Oa = Object.getOwnPropertyDescriptor, La = (r, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? Oa(e, t) : e, o = r.length - 1, i; o >= 0; o--)
    (i = r[o]) && (s = i(s) || s);
  return s;
};
let qs = class extends ie {
  render() {
    return b`
      <div class="relative w-full py-3">
        <div class="mx-auto my-auto px-3 text-sm">
          <div class="text-primary-900 mb-1 flex h-6 items-center gap-x-2">
            <div class="flex size-4 items-center justify-center">${M(ht)}</div>
            <span class="text-shimmer text-shimmer-primary"
              >${v("Thinking...", { id: "thinking-indicator-text" })}</span
            >
          </div>
        </div>
      </div>
    `;
  }
};
qs = La([
  te("gaia-chat-thinking-indicator")
], qs);
const Na = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lightbulb-icon lucide-lightbulb"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg>', za = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-circle-icon lucide-message-circle"><path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"/></svg>';
var Fa = Object.defineProperty, Ua = Object.getOwnPropertyDescriptor, qr = (r, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? Ua(e, t) : e, o = r.length - 1, i; o >= 0; o--)
    (i = r[o]) && (s = (n ? i(e, t, s) : i(s)) || s);
  return n && s && Fa(e, t, s), s;
};
const Ha = {
  SparklesIcon: ht,
  LightBulbIcon: Na,
  MessageCircleIcon: za
};
let Nt = class extends ie {
  constructor() {
    super(...arguments), this.isInitialized = !1;
  }
  renderSkeleton() {
    return b`
      <div>
        <div class="skeleton my-1 h-6 w-full @md:w-36"></div>
        <div class="flex flex-col gap-y-1">
          <p class="skeleton h-4 w-full @md:w-[90%]"></p>
          <p class="skeleton h-4 w-full"></p>
          <p class="skeleton h-4 w-full @md:w-1/2"></p>
        </div>
      </div>
      <div class="hidden flex-col gap-2 @xs:flex @xl:grid @xl:grid-cols-2">
        <div class="skeleton h-14 w-full"></div>
        <div class="skeleton h-14 w-full"></div>
      </div>

      <div class="skeleton my-1 h-5 w-full @md:w-1/2"></div>
    `;
  }
  renderWelcomeMessage(r) {
    return !r && !this.isInitialized ? this.renderSkeleton() : r ? b`
      <div>
        <div class="flex items-center gap-x-2">
          <div class="flex size-5 items-center justify-center">${M(ht)}</div>
          <p class="text-shimmer text-shimmer-primary text-lg font-semibold">
            ${r.title}
          </p>
        </div>
        <p>${r.body}</p>
      </div>
      <div class="hidden flex-col gap-2 @xs:flex @xl:grid @xl:grid-cols-2">
        ${an(r.blocks, (e) => this.renderMessageBlock(e))}
      </div>

      <p class="font-semibold">${r.callToAction}</p>
    ` : b`
        <div class="flex items-center gap-x-2">
          <div class="flex size-5 items-center justify-center">${M(ht)}</div>
          <p class="text-shimmer text-shimmer-primary text-lg font-semibold">Hello!</p>
        </div>
      `;
  }
  renderMessageBlock(r) {
    const e = Ha[r.icon];
    return b`
      <div class="flex items-center gap-x-2 rounded-sm border border-solid border-neutral-300 p-2">
        <div class="text-primary-800 flex size-6 items-center justify-center">
          ${M(e)}
        </div>
        <p>${r.text}</p>
      </div>
    `;
  }
  render() {
    return b`
      <div class="relative flex h-full w-full flex-col gap-y-8 overflow-x-hidden overflow-y-auto">
        <div class="flex w-full items-center justify-center pt-2 text-center">
          <span class="text-xs text-neutral-600">
            ${v("Answers are generated by AI and may contain errors, read more", {
      id: "disclaimer-text"
    })}
            <a
              class="font-medium hover:underline"
              target="_blank"
              href="https://kundeportal.vismasoftware.no/s/article/Vilkår-for-bruk-av-Visma-Software-AI-chat"
              >${v("here", { id: "disclaimer-link" })}</a
            >.
          </span>
        </div>
        <div class="flex w-full flex-col">
          <div class="text-primary-900 flex w-full flex-col gap-y-8 text-sm text-wrap">
            ${this.renderWelcomeMessage(this.welcomeMessage)}
          </div>
        </div>
      </div>
    `;
  }
};
qr([
  E({ attribute: !1 })
], Nt.prototype, "isInitialized", 2);
qr([
  E({ attribute: !1 })
], Nt.prototype, "welcomeMessage", 2);
Nt = qr([
  te("gaia-chat-welcome-message")
], Nt);
async function Ba(r) {
  let e, t;
  try {
    e = await r.clone().text();
  } catch {
    e = void 0;
  }
  try {
    const s = r.headers.get("content-type") || "";
    (s.includes("application/problem+json") || s.includes("application/json")) && (t = JSON.parse(e || "{}"));
  } catch {
    t = void 0;
  }
  const n = t?.detail || t?.title || e && e.slice(0, 200) || `HTTP ${r.status} ${r.statusText}`;
  return new qe(n, r.status, r.url, void 0, e, t);
}
async function Gs(r) {
  if (!r.ok) throw await Ba(r);
}
function gr(r) {
  if (!r.body)
    throw new qe("No response body", r.status, r.url);
  return r.body;
}
async function Un(r) {
  try {
    return await r.json();
  } catch (e) {
    throw new qe("Failed to parse response body as JSON", r.status, r.url, e);
  }
}
class ja {
  constructor() {
    this.key = "gaia-chat:bootstrap-config", this.ttlMs = 3600 * 1e3;
  }
  // 60 minutes
  load() {
    const e = localStorage.getItem(this.key);
    if (!e)
      return null;
    try {
      const t = JSON.parse(e);
      return Date.now() - t.timestamp > this.ttlMs ? (localStorage.removeItem(this.key), null) : t.data;
    } catch {
      return localStorage.removeItem(this.key), null;
    }
  }
  save(e) {
    const t = {
      timestamp: Date.now(),
      data: e
    };
    localStorage.setItem(this.key, JSON.stringify(t));
  }
  clear() {
    localStorage.removeItem(this.key);
  }
}
class Wa {
  constructor(e) {
    this.apiClient = e, this.storage = new ja();
  }
  async getBootstrapConfig() {
    const e = this.storage.load();
    if (e)
      return e;
    const t = await this.apiClient.request("/api/v1/bootstrap", {
      method: "GET"
    }), n = await Un(t);
    return this.storage.save(n), n;
  }
  clearBootstrapConfig() {
    this.storage.clear();
  }
}
var qa = Object.defineProperty, Ga = Object.getOwnPropertyDescriptor, de = (r, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? Ga(e, t) : e, o = r.length - 1, i; o >= 0; o--)
    (i = r[o]) && (s = (n ? i(e, t, s) : i(s)) || s);
  return n && s && qa(e, t, s), s;
};
let ae = class extends ie {
  constructor() {
    super(...arguments), this.isInitialized = !1, this.isThinking = !1, this.feedbackFormOpen = !1, this.feedbackFormTarget = "assistant", this.error = null, this.isConnectedToSupport = !1, this.messages = [];
  }
  get latestMessage() {
    return this.messages.length === 0 ? null : this.messages[this.messages.length - 1];
  }
  updated(r) {
    super.updated(r), r.has("messages") && requestAnimationFrame(() => this.handleScrollMessages(r.get("messages"))), r.has("feedbackFormOpen") && this.feedbackFormOpen && requestAnimationFrame(() => this.scrollFeedbackFormIntoView());
  }
  handleScrollMessages(r) {
    const e = r?.length ?? 0, t = this.messages.length === e;
    if (!r && !t) return;
    const n = this.messages.length > e;
    if (this.messages.length === 0)
      return this.resetScroll();
    if (n && this.latestMessage?.role === "system")
      return this.latestMessage.isSupportStartedMarker ? this.scrollLatestMessageToTop() : this.scrollLatestMessageIntoView();
    if (this.isConnectedToSupport)
      return this.scrollLatestMessageIntoView();
    if (n && this.latestMessage?.role === "user")
      return this.scrollLatestMessageToTop();
    if (e === 0 && n)
      return this.scrollLatestMessageIntoView();
  }
  resetScroll() {
    const r = this.$scrollView.parentElement;
    r && (r.scrollTop = 0, this.$scrollView.style.height = `${r.getBoundingClientRect().height}px`);
  }
  scrollLatestMessageToTop() {
    const r = this.$scrollView.parentElement;
    if (!r) return;
    const e = this.renderRoot.querySelectorAll('[role="article"]');
    if (e.length < 1) return;
    const t = e[e.length - 1];
    this.$scrollView.style.height = `${r.getBoundingClientRect().height + t.offsetTop}px`, t.scrollIntoView({ behavior: "smooth", block: "start" });
  }
  scrollLatestMessageIntoView() {
    const r = this.renderRoot.querySelectorAll('[role="article"]');
    if (r.length < 1) return;
    r[r.length - 1].scrollIntoView({ behavior: "smooth", block: "start" });
  }
  scrollFeedbackFormIntoView() {
    const r = this.$scrollView.parentElement;
    r && r.scrollTo({ top: this.$scrollView.scrollHeight, behavior: "smooth" });
  }
  render() {
    return b` <div class="relative flex h-full">
      <div class="relative flex min-w-0 flex-grow-1 basis-auto flex-col">
        <div class="relative h-full overflow-y-auto">
          <div
            data-testid="message-list"
            class="mx-auto flex h-full min-h-full max-w-2xl min-w-0 flex-col @lg/main:px-4"
            id="scroll-view"
          >
            ${this.messages.length === 0 ? b`<gaia-chat-welcome-message
                  class="h-full"
                  .isInitialized=${this.isInitialized}
                  .welcomeMessage=${this.welcomeMessage}
                ></gaia-chat-welcome-message>` : G}
            ${on(
      this.messages,
      (r) => r.messageId,
      (r) => {
        switch (r.role) {
          case "assistant":
            return b`<gaia-chat-assistant-message
                      .message=${r}
                    ></gaia-chat-assistant-message>`;
          case "user":
            return b`<gaia-chat-user-message
                      .message=${r}
                    ></gaia-chat-user-message>`;
          case "operator":
            return b`<gaia-chat-operator-message
                      .message=${r}
                    ></gaia-chat-operator-message>`;
          case "system":
            return b`<gaia-chat-system-message
                      .message=${r}
                    ></gaia-chat-system-message>`;
          default:
            return G;
        }
      }
    )}
            ${this.isThinking ? b`<gaia-chat-thinking-indicator></gaia-chat-thinking-indicator>` : G}
            ${this.feedbackFormOpen ? b`<gaia-chat-feedback-form
                  .target=${this.feedbackFormTarget}
                ></gaia-chat-feedback-form>` : G}
          </div>
        </div>
      </div>
      ${this.error ? b`<gaia-chat-error .error=${this.error}></gaia-chat-error>` : G}
    </div>`;
  }
};
de([
  sn("#scroll-view")
], ae.prototype, "$scrollView", 2);
de([
  E({ attribute: !1 })
], ae.prototype, "isInitialized", 2);
de([
  E({ attribute: !1 })
], ae.prototype, "welcomeMessage", 2);
de([
  E({ attribute: !1 })
], ae.prototype, "isThinking", 2);
de([
  E({ attribute: !1 })
], ae.prototype, "feedbackFormOpen", 2);
de([
  E({ attribute: !1 })
], ae.prototype, "feedbackFormTarget", 2);
de([
  E({ attribute: !1 })
], ae.prototype, "error", 2);
de([
  E({ attribute: !1 })
], ae.prototype, "isConnectedToSupport", 2);
de([
  E({ attribute: !1 })
], ae.prototype, "messages", 2);
ae = de([
  te("gaia-chat-message-list")
], ae);
const Hn = {
  initialized: !1,
  maxInputLength: 2e3,
  welcomeMessages: {}
}, Va = () => ({
  type: "config/setInitialized"
}), Ya = (r) => ({
  type: "config/set",
  payload: r
}), Xa = () => ({
  type: "config/clear"
});
function Za(r = Hn, e) {
  switch (e.type) {
    case "config/setInitialized":
      return {
        ...r,
        initialized: !0
      };
    case "config/set":
      return {
        ...r,
        ...e.payload,
        initialized: !0
      };
    case "config/clear":
      return {
        ...r,
        initialized: !1,
        welcomeMessages: {}
      };
    default:
      return r;
  }
}
const Bn = {
  entities: {},
  ids: []
}, Ka = (r) => ({
  type: "messages/set",
  payload: r
}), _e = (r) => ({
  type: "messages/add",
  payload: r
}), Ja = (r) => ({
  type: "messages/delete",
  payload: r
}), we = (r, e) => ({
  type: "messages/patch",
  payload: { id: r, patch: e }
}), Qa = (r, e) => ({
  type: "messages/add-delta",
  payload: { id: r, delta: e }
});
function el(r = Bn, e) {
  switch (e.type) {
    case "messages/set":
      return {
        ...r,
        ids: e.payload.map((t) => t.messageId),
        entities: e.payload.reduce((t, n) => ({ ...t, [n.messageId]: n }), {})
      };
    case "messages/add": {
      const t = e.payload;
      return {
        ...r,
        ids: [...r.ids, t.messageId],
        entities: { ...r.entities, [t.messageId]: t }
      };
    }
    case "messages/delete": {
      const t = { ...r.entities };
      return delete t[e.payload], {
        ...r,
        ids: r.ids.filter((n) => n !== e.payload),
        entities: t
      };
    }
    case "messages/patch": {
      const { id: t, patch: n } = e.payload, s = r.entities[t];
      return s ? {
        ...r,
        entities: { ...r.entities, [t]: { ...s, ...n } }
      } : r;
    }
    case "messages/add-delta": {
      const { id: t, delta: n } = e.payload, s = r.entities[t];
      if (!s) return r;
      const o = ("content" in s ? s.content : "") + n;
      return {
        ...r,
        entities: { ...r.entities, [t]: { ...s, content: o } }
      };
    }
    default:
      return r;
  }
}
const jn = {
  conversationId: null,
  cursorId: null,
  channel: "assistant",
  isActive: !0,
  isThinking: !1,
  isBusy: !1
}, zt = (r) => ({
  type: "session/set-conversation-id",
  payload: r
}), lt = (r) => ({
  type: "session/set-cursor-id",
  payload: r
}), Gr = (r) => ({
  type: "session/set-channel",
  payload: r
}), Cr = (r) => ({
  type: "session/set-thinking",
  payload: r
}), Ft = (r) => ({
  type: "session/set-busy",
  payload: r
});
function tl(r = jn, e) {
  switch (e.type) {
    case "session/set-conversation-id":
      return {
        ...r,
        conversationId: e.payload
      };
    case "session/set-cursor-id":
      return {
        ...r,
        cursorId: e.payload
      };
    case "session/set-channel":
      return {
        ...r,
        channel: e.payload
      };
    case "session/set-active":
      return {
        ...r,
        isActive: e.payload
      };
    case "session/set-thinking":
      return {
        ...r,
        isThinking: e.payload
      };
    case "session/set-busy":
      return {
        ...r,
        isBusy: e.payload
      };
    default:
      return r;
  }
}
const Wn = {
  feedbackFormOpen: !1,
  feedbackFormTarget: "assistant",
  error: null,
  errorStack: []
}, rl = (r) => ({
  type: "ui/open-feedback-form",
  payload: { target: r }
}), Ir = () => ({
  type: "ui/close-feedback-form"
}), xe = (r) => ({
  type: "ui/set-error",
  payload: r
}), sl = (r) => ({
  type: "ui/push-error",
  payload: r
});
function nl(r = Wn, e) {
  switch (e.type) {
    case "ui/open-feedback-form":
      return {
        ...r,
        feedbackFormOpen: !0,
        feedbackFormTarget: e.payload.target
      };
    case "ui/close-feedback-form":
      return {
        ...r,
        feedbackFormOpen: !1
      };
    case "ui/set-error":
      return {
        ...r,
        error: e.payload
      };
    case "ui/push-error": {
      const t = r.errorStack ?? [];
      return {
        ...r,
        errorStack: [...t, e.payload],
        error: e.payload
      };
    }
    default:
      return r;
  }
}
const Ar = {
  config: Hn,
  messages: Bn,
  session: jn,
  ui: Wn
}, qn = "app/reset", ol = () => ({ type: qn });
function il(r, e) {
  if (e.type === qn)
    return { ...Ar, config: r.config };
  const t = r ?? Ar;
  return {
    config: Za(t.config, e),
    messages: el(t.messages, e),
    session: tl(t.session, e),
    ui: nl(t.ui, e)
  };
}
class al {
  constructor(e = il, t = Ar) {
    this.listeners = /* @__PURE__ */ new Set(), this.pending = !1, this.state = t, this.reducer = e;
  }
  get snapshot() {
    return this.state;
  }
  subscribe(e) {
    return this.listeners.add(e), e(this.state), () => this.listeners.delete(e);
  }
  dispatch(e) {
    this.state = this.reducer(this.state, e), this.pending || (this.pending = !0, queueMicrotask(() => {
      this.pending = !1;
      for (const t of this.listeners) t(this.state);
    }));
  }
}
const ll = /* @__PURE__ */ (() => {
  let r = [], e = {}, t = [];
  return (n) => (n.messages.ids === r && n.messages.entities === e || (r = n.messages.ids, e = n.messages.entities, t = r.map((s) => e[s])), t);
})();
class cl {
  constructor(e, t) {
    this.store = e, this.svc = t;
  }
  async initialize() {
    try {
      const e = await this.svc.getBootstrapConfig();
      this.store.dispatch(Ya(e));
    } catch (e) {
      this.store.dispatch(xe(gt(e))), console.error("Failed to load bootstrap configuration:", e);
    } finally {
      this.store.dispatch(Va());
    }
  }
  async clear() {
    this.svc.clearBootstrapConfig(), this.store.dispatch(Xa());
  }
}
class Rr {
  constructor() {
    this.key = "gaia-chat:conversation-id";
  }
  load() {
    const e = localStorage.getItem(this.key);
    return e || null;
  }
  save(e) {
    localStorage.setItem(this.key, e);
  }
  clear() {
    localStorage.removeItem(this.key);
  }
}
class Vs extends Error {
  constructor(e, t) {
    super(e), this.name = "ParseError", this.type = t.type, this.field = t.field, this.value = t.value, this.line = t.line;
  }
}
function fr(r) {
}
function hl(r) {
  if (typeof r == "function")
    throw new TypeError(
      "`callbacks` must be an object, got a function instead. Did you mean `{onEvent: fn}`?"
    );
  const { onEvent: e = fr, onError: t = fr, onRetry: n = fr, onComment: s } = r;
  let o = "", i = !0, a, c = "", d = "";
  function u(y) {
    const $ = i ? y.replace(/^\xEF\xBB\xBF/, "") : y, [J, ye] = dl(`${o}${$}`);
    for (const re of J)
      w(re);
    o = ye, i = !1;
  }
  function w(y) {
    if (y === "") {
      R();
      return;
    }
    if (y.startsWith(":")) {
      s && s(y.slice(y.startsWith(": ") ? 2 : 1));
      return;
    }
    const $ = y.indexOf(":");
    if ($ !== -1) {
      const J = y.slice(0, $), ye = y[$ + 1] === " " ? 2 : 1, re = y.slice($ + ye);
      k(J, re, y);
      return;
    }
    k(y, "", y);
  }
  function k(y, $, J) {
    switch (y) {
      case "event":
        d = $;
        break;
      case "data":
        c = `${c}${$}
`;
        break;
      case "id":
        a = $.includes("\0") ? void 0 : $;
        break;
      case "retry":
        /^\d+$/.test($) ? n(parseInt($, 10)) : t(
          new Vs(`Invalid \`retry\` value: "${$}"`, {
            type: "invalid-retry",
            value: $,
            line: J
          })
        );
        break;
      default:
        t(
          new Vs(
            `Unknown field "${y.length > 20 ? `${y.slice(0, 20)}…` : y}"`,
            { type: "unknown-field", field: y, value: $, line: J }
          )
        );
        break;
    }
  }
  function R() {
    c.length > 0 && e({
      id: a,
      event: d || void 0,
      // If the data buffer's last character is a U+000A LINE FEED (LF) character,
      // then remove the last character from the data buffer.
      data: c.endsWith(`
`) ? c.slice(0, -1) : c
    }), a = void 0, c = "", d = "";
  }
  function T(y = {}) {
    o && y.consume && w(o), i = !0, a = void 0, c = "", d = "", o = "";
  }
  return { feed: u, reset: T };
}
function dl(r) {
  const e = [];
  let t = "", n = 0;
  for (; n < r.length; ) {
    const s = r.indexOf("\r", n), o = r.indexOf(`
`, n);
    let i = -1;
    if (s !== -1 && o !== -1 ? i = Math.min(s, o) : s !== -1 ? s === r.length - 1 ? i = -1 : i = s : o !== -1 && (i = o), i === -1) {
      t = r.slice(n);
      break;
    } else {
      const a = r.slice(n, i);
      e.push(a), n = i + 1, r[n - 1] === "\r" && r[n] === `
` && n++;
    }
  }
  return [e, t];
}
class pl extends TransformStream {
  constructor({ onError: e, onRetry: t, onComment: n } = {}) {
    let s;
    super({
      start(o) {
        s = hl({
          onEvent: (i) => {
            o.enqueue(i);
          },
          onError(i) {
            e === "terminate" ? o.error(i) : typeof e == "function" && e(i);
          },
          onRetry: t,
          onComment: n
        });
      },
      transform(o) {
        s.feed(o);
      }
    });
  }
}
async function* mr(r, e) {
  const t = ul() ? new TextDecoderStream() : gl(), n = r.pipeThrough(t).pipeThrough(new pl()), s = n.getReader();
  try {
    for (; !e?.aborted; ) {
      const { value: o, done: i } = await s.read();
      if (i) break;
      yield o;
    }
  } catch (o) {
    throw new Dr(o);
  } finally {
    try {
      s.releaseLock();
    } catch {
    }
    try {
      await n.cancel();
    } catch {
    }
  }
}
function ul() {
  return typeof TextDecoderStream < "u";
}
function gl() {
  const r = new TextDecoder();
  return new TransformStream({
    transform(e, t) {
      t.enqueue(r.decode(e, { stream: !0 }));
    },
    flush(e) {
      e.enqueue(r.decode());
    }
  });
}
class fl {
  constructor(e) {
    this.apiClient = e;
  }
  async *sendMessage(e, t) {
    const n = await this.apiClient.request("/api/v1/conversations", {
      method: "POST",
      body: JSON.stringify(e),
      headers: {
        "Content-Type": "application/json"
      },
      signal: t
    }), s = gr(n);
    for await (const o of mr(s, t))
      yield this.parseSseEvent(o);
  }
  async *approveToolCall(e, t) {
    const n = await this.apiClient.request(
      `/api/v1/conversations/${e.conversationId}/turns/${e.turnId}/tool-call:approve-pending`,
      {
        method: "POST"
      }
    ), s = gr(n);
    for await (const o of mr(s, t))
      yield this.parseSseEvent(o);
  }
  async *declineToolCall(e, t) {
    const n = await this.apiClient.request(
      `/api/v1/conversations/${e.conversationId}/turns/${e.turnId}/tool-call:decline-pending`,
      {
        method: "POST"
      }
    ), s = gr(n);
    for await (const o of mr(s, t))
      yield this.parseSseEvent(o);
  }
  async getConversationHistory(e) {
    const t = await this.apiClient.request(
      `/api/v1/conversations/${encodeURIComponent(e)}/history`,
      {
        method: "GET"
      }
    );
    return Un(t);
  }
  parseSseEvent(e) {
    try {
      return {
        event: e.event,
        data: JSON.parse(e.data)
      };
    } catch {
      return {
        event: "error",
        data: { message: "Malformed server event" }
      };
    }
  }
}
class ml {
  constructor(e, t) {
    this.store = e, this.svc = t, this.storage = new Rr();
  }
  async getHistory() {
    const e = this.storage.load();
    if (e) {
      this.store.dispatch(zt(e));
      try {
        const t = await this.svc.getConversationHistory(e);
        this.store.dispatch(Ka(t.messages)), this.store.dispatch(Gr(t.channel));
      } catch {
        this.store.dispatch(zt(null)), this.storage.clear();
      }
    }
  }
  clear() {
    this.storage.clear(), this.store.dispatch(ol());
  }
}
class wl {
  constructor(e) {
    this.apiClient = e;
  }
  async submitFeedback(e) {
    await this.apiClient.request("/api/v1/feedback", {
      method: "POST",
      body: JSON.stringify(e),
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
}
class bl {
  constructor(e, t) {
    this.store = e, this.svc = t;
  }
  async submitFeedback(e, t, n) {
    const s = this.store.snapshot.session.conversationId;
    if (s) {
      this.store.dispatch(zt(s));
      try {
        await this.svc.submitFeedback({
          conversationId: s,
          target: e,
          score: t,
          comment: n
        }), this.store.dispatch(Ir());
      } catch (o) {
        this.store.dispatch(xe(gt(o)));
      }
    }
  }
}
const dt = () => crypto.randomUUID(), Vr = () => (/* @__PURE__ */ new Date()).toISOString();
function Gn(r, e) {
  const t = e?.now?.() ?? Vr();
  return {
    messageId: e?.idGen?.() ?? dt(),
    turnId: dt(),
    role: "user",
    status: e?.status ?? "completed",
    content: r,
    createdAt: t,
    updatedAt: t
  };
}
function vl(r) {
  const e = Vr();
  return {
    messageId: dt(),
    turnId: dt(),
    role: "system",
    status: "completed",
    content: "",
    createdAt: e,
    updatedAt: e,
    isSupportCompletedMarker: !0,
    isSupportStartedMarker: !1,
    isVisuallyHidden: !1
  };
}
function Ys(r, e, t) {
  const n = t?.now?.() ?? Vr();
  return {
    messageId: t?.idGen?.() ?? dt(),
    role: "operator",
    status: t?.status ?? "pending",
    operator: r,
    content: e,
    createdAt: n,
    updatedAt: n,
    isTyping: t?.isTyping ?? !1
  };
}
const yl = (r) => ({
  "conversation.start": (e) => {
    r.dispatch(zt(e.data));
  },
  "turn.start": (e) => {
    const t = r.snapshot.session.cursorId;
    t && r.dispatch(we(t, e.data.message));
  },
  "assistant.start": (e) => {
    r.dispatch(_e(e.data)), r.dispatch(lt(e.data.messageId));
  },
  "assistant.delta": (e) => {
    const t = r.snapshot.session.cursorId;
    t && (r.dispatch(Qa(t, e.data)), r.dispatch(Cr(!1)));
  },
  "assistant.tool": (e) => {
    const t = r.snapshot.session.cursorId;
    if (!t) return;
    const n = r.snapshot.messages.entities[t];
    n && r.dispatch(we(t, { toolCalls: [...n.toolCalls ?? [], e.data] }));
  },
  "assistant.complete": (e) => {
    r.dispatch(we(e.data.messageId, e.data));
  },
  "tool.start": (e) => {
    r.dispatch(_e(e.data)), r.dispatch(lt(e.data.messageId));
  },
  "tool.complete": (e) => {
    const t = r.snapshot.session.cursorId;
    t && r.dispatch(we(t, { toolCallResult: e.data }));
  },
  "tool.failed": (e) => {
    const t = r.snapshot.session.cursorId;
    t && r.dispatch(we(t, { toolCallResult: e.data }));
  },
  "turn.toolcalls.approved": (e) => {
    r.dispatch(we(e.data.messageId, { approvalStatus: "approved" }));
  },
  "turn.toolcalls.declined": (e) => {
    r.dispatch(we(e.data.messageId, { approvalStatus: "declined" }));
  },
  "support.handoff.start": (e) => {
    r.dispatch(_e(e.data.message)), r.dispatch(lt(e.data.message.messageId)), r.dispatch(Gr("support"));
  },
  error: (e) => {
    r.dispatch(
      xe(
        gt(new Dr(null, e.data.message ?? "Stream error", e.data.errorType))
      )
    );
  }
});
class _l {
  async run(e) {
    return this.abort?.abort(), this.abort = new AbortController(), e(this.abort.signal).finally(() => {
      this.abort?.signal.aborted === !1 && (this.abort = void 0);
    });
  }
  cancel() {
    this.abort?.abort();
  }
}
class kl {
  constructor(e, t) {
    this.store = e, this.svc = t, this.tasks = new _l(), this.storage = new Rr(), this.handlers = yl(this.store), this.storage = new Rr();
  }
  async sendMessage(e, t, n) {
    const s = crypto.randomUUID();
    this.store.dispatch(
      _e(
        Gn(e, {
          idGen: () => s
        })
      )
    ), this.store.dispatch(lt(s));
    const o = await this.tasks.run(
      async (i) => this.consume(
        this.svc.sendMessage(
          {
            message: e,
            profileId: t,
            conversationId: this.store.snapshot.session.conversationId,
            partnerId: n ?? null
          },
          i
        )
      )
    );
    return this.store.snapshot.session.conversationId && this.storage.save(this.store.snapshot.session.conversationId), o;
  }
  async approveToolCall(e, t) {
    const n = this.requireConversation();
    return this.tasks.run(
      async (s) => this.consume(
        this.svc.approveToolCall(
          {
            conversationId: n,
            turnId: e,
            messageId: t
          },
          s
        )
      )
    );
  }
  async declineToolCall(e, t) {
    const n = this.requireConversation();
    return this.tasks.run(
      async (s) => this.consume(
        this.svc.declineToolCall(
          {
            conversationId: n,
            turnId: e,
            messageId: t
          },
          s
        )
      )
    );
  }
  abortCurrentTask() {
    this.tasks.cancel();
  }
  async consume(e) {
    this.store.dispatch(Ft(!0)), this.store.dispatch(Cr(!0));
    try {
      for await (const t of e)
        this.handlers[t.event]?.(t);
    } catch (t) {
      console.error("[SSE] stream error", t), this.store.dispatch(sl(gt(t)));
    } finally {
      this.store.dispatch(Cr(!1)), this.store.dispatch(Ft(!1));
    }
  }
  requireConversation() {
    const e = this.store.snapshot.session.conversationId;
    if (!e) throw new Error("No conversation id");
    return e;
  }
}
class Pe extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.HttpError}.
   *
   * @param {string} errorMessage A descriptive error message.
   * @param {number} statusCode The HTTP status code represented by this error.
   */
  constructor(e, t) {
    const n = new.target.prototype;
    super(`${e}: Status code '${t}'`), this.statusCode = t, this.__proto__ = n;
  }
}
class Yr extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.TimeoutError}.
   *
   * @param {string} errorMessage A descriptive error message.
   */
  constructor(e = "A timeout occurred.") {
    const t = new.target.prototype;
    super(e), this.__proto__ = t;
  }
}
class ne extends Error {
  /** Constructs a new instance of {@link AbortError}.
   *
   * @param {string} errorMessage A descriptive error message.
   */
  constructor(e = "An abort occurred.") {
    const t = new.target.prototype;
    super(e), this.__proto__ = t;
  }
}
class xl extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.UnsupportedTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
   */
  constructor(e, t) {
    const n = new.target.prototype;
    super(e), this.transport = t, this.errorType = "UnsupportedTransportError", this.__proto__ = n;
  }
}
class Sl extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.DisabledTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
   */
  constructor(e, t) {
    const n = new.target.prototype;
    super(e), this.transport = t, this.errorType = "DisabledTransportError", this.__proto__ = n;
  }
}
class Tl extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.FailedToStartTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
   */
  constructor(e, t) {
    const n = new.target.prototype;
    super(e), this.transport = t, this.errorType = "FailedToStartTransportError", this.__proto__ = n;
  }
}
class Xs extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.FailedToNegotiateWithServerError}.
   *
   * @param {string} message A descriptive error message.
   */
  constructor(e) {
    const t = new.target.prototype;
    super(e), this.errorType = "FailedToNegotiateWithServerError", this.__proto__ = t;
  }
}
class El extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.AggregateErrors}.
   *
   * @param {string} message A descriptive error message.
   * @param {Error[]} innerErrors The collection of errors this error is aggregating.
   */
  constructor(e, t) {
    const n = new.target.prototype;
    super(e), this.innerErrors = t, this.__proto__ = n;
  }
}
class Vn {
  constructor(e, t, n) {
    this.statusCode = e, this.statusText = t, this.content = n;
  }
}
class Wt {
  get(e, t) {
    return this.send({
      ...t,
      method: "GET",
      url: e
    });
  }
  post(e, t) {
    return this.send({
      ...t,
      method: "POST",
      url: e
    });
  }
  delete(e, t) {
    return this.send({
      ...t,
      method: "DELETE",
      url: e
    });
  }
  /** Gets all cookies that apply to the specified URL.
   *
   * @param url The URL that the cookies are valid for.
   * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
   */
  // @ts-ignore
  getCookieString(e) {
    return "";
  }
}
var h;
(function(r) {
  r[r.Trace = 0] = "Trace", r[r.Debug = 1] = "Debug", r[r.Information = 2] = "Information", r[r.Warning = 3] = "Warning", r[r.Error = 4] = "Error", r[r.Critical = 5] = "Critical", r[r.None = 6] = "None";
})(h || (h = {}));
class pt {
  constructor() {
  }
  /** @inheritDoc */
  // eslint-disable-next-line
  log(e, t) {
  }
}
pt.instance = new pt();
const Cl = "9.0.6";
class O {
  static isRequired(e, t) {
    if (e == null)
      throw new Error(`The '${t}' argument is required.`);
  }
  static isNotEmpty(e, t) {
    if (!e || e.match(/^\s*$/))
      throw new Error(`The '${t}' argument should not be empty.`);
  }
  static isIn(e, t, n) {
    if (!(e in t))
      throw new Error(`Unknown ${n} value: ${e}.`);
  }
}
class A {
  // react-native has a window but no document so we should check both
  static get isBrowser() {
    return !A.isNode && typeof window == "object" && typeof window.document == "object";
  }
  // WebWorkers don't have a window object so the isBrowser check would fail
  static get isWebWorker() {
    return !A.isNode && typeof self == "object" && "importScripts" in self;
  }
  // react-native has a window but no document
  static get isReactNative() {
    return !A.isNode && typeof window == "object" && typeof window.document > "u";
  }
  // Node apps shouldn't have a window object, but WebWorkers don't either
  // so we need to check for both WebWorker and window
  static get isNode() {
    return typeof process < "u" && process.release && process.release.name === "node";
  }
}
function ut(r, e) {
  let t = "";
  return Oe(r) ? (t = `Binary data of length ${r.byteLength}`, e && (t += `. Content: '${Il(r)}'`)) : typeof r == "string" && (t = `String data of length ${r.length}`, e && (t += `. Content: '${r}'`)), t;
}
function Il(r) {
  const e = new Uint8Array(r);
  let t = "";
  return e.forEach((n) => {
    const s = n < 16 ? "0" : "";
    t += `0x${s}${n.toString(16)} `;
  }), t.substr(0, t.length - 1);
}
function Oe(r) {
  return r && typeof ArrayBuffer < "u" && (r instanceof ArrayBuffer || // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
  r.constructor && r.constructor.name === "ArrayBuffer");
}
async function Yn(r, e, t, n, s, o) {
  const i = {}, [a, c] = Ve();
  i[a] = c, r.log(h.Trace, `(${e} transport) sending data. ${ut(s, o.logMessageContent)}.`);
  const d = Oe(s) ? "arraybuffer" : "text", u = await t.post(n, {
    content: s,
    headers: { ...i, ...o.headers },
    responseType: d,
    timeout: o.timeout,
    withCredentials: o.withCredentials
  });
  r.log(h.Trace, `(${e} transport) request complete. Response status: ${u.statusCode}.`);
}
function Al(r) {
  return r === void 0 ? new Ut(h.Information) : r === null ? pt.instance : r.log !== void 0 ? r : new Ut(r);
}
class Rl {
  constructor(e, t) {
    this._subject = e, this._observer = t;
  }
  dispose() {
    const e = this._subject.observers.indexOf(this._observer);
    e > -1 && this._subject.observers.splice(e, 1), this._subject.observers.length === 0 && this._subject.cancelCallback && this._subject.cancelCallback().catch((t) => {
    });
  }
}
class Ut {
  constructor(e) {
    this._minLevel = e, this.out = console;
  }
  log(e, t) {
    if (e >= this._minLevel) {
      const n = `[${(/* @__PURE__ */ new Date()).toISOString()}] ${h[e]}: ${t}`;
      switch (e) {
        case h.Critical:
        case h.Error:
          this.out.error(n);
          break;
        case h.Warning:
          this.out.warn(n);
          break;
        case h.Information:
          this.out.info(n);
          break;
        default:
          this.out.log(n);
          break;
      }
    }
  }
}
function Ve() {
  let r = "X-SignalR-User-Agent";
  return A.isNode && (r = "User-Agent"), [r, $l(Cl, Pl(), Dl(), Ml())];
}
function $l(r, e, t, n) {
  let s = "Microsoft SignalR/";
  const o = r.split(".");
  return s += `${o[0]}.${o[1]}`, s += ` (${r}; `, e && e !== "" ? s += `${e}; ` : s += "Unknown OS; ", s += `${t}`, n ? s += `; ${n}` : s += "; Unknown Runtime Version", s += ")", s;
}
function Pl() {
  if (A.isNode)
    switch (process.platform) {
      case "win32":
        return "Windows NT";
      case "darwin":
        return "macOS";
      case "linux":
        return "Linux";
      default:
        return process.platform;
    }
  else
    return "";
}
function Ml() {
  if (A.isNode)
    return process.versions.node;
}
function Dl() {
  return A.isNode ? "NodeJS" : "Browser";
}
function wr(r) {
  return r.stack ? r.stack : r.message ? r.message : `${r}`;
}
function Ol() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("could not find global");
}
class Ll extends Wt {
  constructor(e) {
    if (super(), this._logger = e, typeof fetch > "u" || A.isNode) {
      const t = typeof __webpack_require__ == "function" ? __non_webpack_require__ : require;
      this._jar = new (t("tough-cookie")).CookieJar(), typeof fetch > "u" ? this._fetchType = t("node-fetch") : this._fetchType = fetch, this._fetchType = t("fetch-cookie")(this._fetchType, this._jar);
    } else
      this._fetchType = fetch.bind(Ol());
    if (typeof AbortController > "u") {
      const t = typeof __webpack_require__ == "function" ? __non_webpack_require__ : require;
      this._abortControllerType = t("abort-controller");
    } else
      this._abortControllerType = AbortController;
  }
  /** @inheritDoc */
  async send(e) {
    if (e.abortSignal && e.abortSignal.aborted)
      throw new ne();
    if (!e.method)
      throw new Error("No method defined.");
    if (!e.url)
      throw new Error("No url defined.");
    const t = new this._abortControllerType();
    let n;
    e.abortSignal && (e.abortSignal.onabort = () => {
      t.abort(), n = new ne();
    });
    let s = null;
    if (e.timeout) {
      const c = e.timeout;
      s = setTimeout(() => {
        t.abort(), this._logger.log(h.Warning, "Timeout from HTTP request."), n = new Yr();
      }, c);
    }
    e.content === "" && (e.content = void 0), e.content && (e.headers = e.headers || {}, Oe(e.content) ? e.headers["Content-Type"] = "application/octet-stream" : e.headers["Content-Type"] = "text/plain;charset=UTF-8");
    let o;
    try {
      o = await this._fetchType(e.url, {
        body: e.content,
        cache: "no-cache",
        credentials: e.withCredentials === !0 ? "include" : "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          ...e.headers
        },
        method: e.method,
        mode: "cors",
        redirect: "follow",
        signal: t.signal
      });
    } catch (c) {
      throw n || (this._logger.log(h.Warning, `Error from HTTP request. ${c}.`), c);
    } finally {
      s && clearTimeout(s), e.abortSignal && (e.abortSignal.onabort = null);
    }
    if (!o.ok) {
      const c = await Zs(o, "text");
      throw new Pe(c || o.statusText, o.status);
    }
    const a = await Zs(o, e.responseType);
    return new Vn(o.status, o.statusText, a);
  }
  getCookieString(e) {
    let t = "";
    return A.isNode && this._jar && this._jar.getCookies(e, (n, s) => t = s.join("; ")), t;
  }
}
function Zs(r, e) {
  let t;
  switch (e) {
    case "arraybuffer":
      t = r.arrayBuffer();
      break;
    case "text":
      t = r.text();
      break;
    case "blob":
    case "document":
    case "json":
      throw new Error(`${e} is not supported.`);
    default:
      t = r.text();
      break;
  }
  return t;
}
class Nl extends Wt {
  constructor(e) {
    super(), this._logger = e;
  }
  /** @inheritDoc */
  send(e) {
    return e.abortSignal && e.abortSignal.aborted ? Promise.reject(new ne()) : e.method ? e.url ? new Promise((t, n) => {
      const s = new XMLHttpRequest();
      s.open(e.method, e.url, !0), s.withCredentials = e.withCredentials === void 0 ? !0 : e.withCredentials, s.setRequestHeader("X-Requested-With", "XMLHttpRequest"), e.content === "" && (e.content = void 0), e.content && (Oe(e.content) ? s.setRequestHeader("Content-Type", "application/octet-stream") : s.setRequestHeader("Content-Type", "text/plain;charset=UTF-8"));
      const o = e.headers;
      o && Object.keys(o).forEach((i) => {
        s.setRequestHeader(i, o[i]);
      }), e.responseType && (s.responseType = e.responseType), e.abortSignal && (e.abortSignal.onabort = () => {
        s.abort(), n(new ne());
      }), e.timeout && (s.timeout = e.timeout), s.onload = () => {
        e.abortSignal && (e.abortSignal.onabort = null), s.status >= 200 && s.status < 300 ? t(new Vn(s.status, s.statusText, s.response || s.responseText)) : n(new Pe(s.response || s.responseText || s.statusText, s.status));
      }, s.onerror = () => {
        this._logger.log(h.Warning, `Error from HTTP request. ${s.status}: ${s.statusText}.`), n(new Pe(s.statusText, s.status));
      }, s.ontimeout = () => {
        this._logger.log(h.Warning, "Timeout from HTTP request."), n(new Yr());
      }, s.send(e.content);
    }) : Promise.reject(new Error("No url defined.")) : Promise.reject(new Error("No method defined."));
  }
}
class zl extends Wt {
  /** Creates a new instance of the {@link @microsoft/signalr.DefaultHttpClient}, using the provided {@link @microsoft/signalr.ILogger} to log messages. */
  constructor(e) {
    if (super(), typeof fetch < "u" || A.isNode)
      this._httpClient = new Ll(e);
    else if (typeof XMLHttpRequest < "u")
      this._httpClient = new Nl(e);
    else
      throw new Error("No usable HttpClient found.");
  }
  /** @inheritDoc */
  send(e) {
    return e.abortSignal && e.abortSignal.aborted ? Promise.reject(new ne()) : e.method ? e.url ? this._httpClient.send(e) : Promise.reject(new Error("No url defined.")) : Promise.reject(new Error("No method defined."));
  }
  getCookieString(e) {
    return this._httpClient.getCookieString(e);
  }
}
class K {
  static write(e) {
    return `${e}${K.RecordSeparator}`;
  }
  static parse(e) {
    if (e[e.length - 1] !== K.RecordSeparator)
      throw new Error("Message is incomplete.");
    const t = e.split(K.RecordSeparator);
    return t.pop(), t;
  }
}
K.RecordSeparatorCode = 30;
K.RecordSeparator = String.fromCharCode(K.RecordSeparatorCode);
class Fl {
  // Handshake request is always JSON
  writeHandshakeRequest(e) {
    return K.write(JSON.stringify(e));
  }
  parseHandshakeResponse(e) {
    let t, n;
    if (Oe(e)) {
      const a = new Uint8Array(e), c = a.indexOf(K.RecordSeparatorCode);
      if (c === -1)
        throw new Error("Message is incomplete.");
      const d = c + 1;
      t = String.fromCharCode.apply(null, Array.prototype.slice.call(a.slice(0, d))), n = a.byteLength > d ? a.slice(d).buffer : null;
    } else {
      const a = e, c = a.indexOf(K.RecordSeparator);
      if (c === -1)
        throw new Error("Message is incomplete.");
      const d = c + 1;
      t = a.substring(0, d), n = a.length > d ? a.substring(d) : null;
    }
    const s = K.parse(t), o = JSON.parse(s[0]);
    if (o.type)
      throw new Error("Expected a handshake response from the server.");
    return [n, o];
  }
}
var m;
(function(r) {
  r[r.Invocation = 1] = "Invocation", r[r.StreamItem = 2] = "StreamItem", r[r.Completion = 3] = "Completion", r[r.StreamInvocation = 4] = "StreamInvocation", r[r.CancelInvocation = 5] = "CancelInvocation", r[r.Ping = 6] = "Ping", r[r.Close = 7] = "Close", r[r.Ack = 8] = "Ack", r[r.Sequence = 9] = "Sequence";
})(m || (m = {}));
class Ul {
  constructor() {
    this.observers = [];
  }
  next(e) {
    for (const t of this.observers)
      t.next(e);
  }
  error(e) {
    for (const t of this.observers)
      t.error && t.error(e);
  }
  complete() {
    for (const e of this.observers)
      e.complete && e.complete();
  }
  subscribe(e) {
    return this.observers.push(e), new Rl(this, e);
  }
}
class Hl {
  constructor(e, t, n) {
    this._bufferSize = 1e5, this._messages = [], this._totalMessageCount = 0, this._waitForSequenceMessage = !1, this._nextReceivingSequenceId = 1, this._latestReceivedSequenceId = 0, this._bufferedByteCount = 0, this._reconnectInProgress = !1, this._protocol = e, this._connection = t, this._bufferSize = n;
  }
  async _send(e) {
    const t = this._protocol.writeMessage(e);
    let n = Promise.resolve();
    if (this._isInvocationMessage(e)) {
      this._totalMessageCount++;
      let s = () => {
      }, o = () => {
      };
      Oe(t) ? this._bufferedByteCount += t.byteLength : this._bufferedByteCount += t.length, this._bufferedByteCount >= this._bufferSize && (n = new Promise((i, a) => {
        s = i, o = a;
      })), this._messages.push(new Bl(t, this._totalMessageCount, s, o));
    }
    try {
      this._reconnectInProgress || await this._connection.send(t);
    } catch {
      this._disconnected();
    }
    await n;
  }
  _ack(e) {
    let t = -1;
    for (let n = 0; n < this._messages.length; n++) {
      const s = this._messages[n];
      if (s._id <= e.sequenceId)
        t = n, Oe(s._message) ? this._bufferedByteCount -= s._message.byteLength : this._bufferedByteCount -= s._message.length, s._resolver();
      else if (this._bufferedByteCount < this._bufferSize)
        s._resolver();
      else
        break;
    }
    t !== -1 && (this._messages = this._messages.slice(t + 1));
  }
  _shouldProcessMessage(e) {
    if (this._waitForSequenceMessage)
      return e.type !== m.Sequence ? !1 : (this._waitForSequenceMessage = !1, !0);
    if (!this._isInvocationMessage(e))
      return !0;
    const t = this._nextReceivingSequenceId;
    return this._nextReceivingSequenceId++, t <= this._latestReceivedSequenceId ? (t === this._latestReceivedSequenceId && this._ackTimer(), !1) : (this._latestReceivedSequenceId = t, this._ackTimer(), !0);
  }
  _resetSequence(e) {
    if (e.sequenceId > this._nextReceivingSequenceId) {
      this._connection.stop(new Error("Sequence ID greater than amount of messages we've received."));
      return;
    }
    this._nextReceivingSequenceId = e.sequenceId;
  }
  _disconnected() {
    this._reconnectInProgress = !0, this._waitForSequenceMessage = !0;
  }
  async _resend() {
    const e = this._messages.length !== 0 ? this._messages[0]._id : this._totalMessageCount + 1;
    await this._connection.send(this._protocol.writeMessage({ type: m.Sequence, sequenceId: e }));
    const t = this._messages;
    for (const n of t)
      await this._connection.send(n._message);
    this._reconnectInProgress = !1;
  }
  _dispose(e) {
    e ?? (e = new Error("Unable to reconnect to server."));
    for (const t of this._messages)
      t._rejector(e);
  }
  _isInvocationMessage(e) {
    switch (e.type) {
      case m.Invocation:
      case m.StreamItem:
      case m.Completion:
      case m.StreamInvocation:
      case m.CancelInvocation:
        return !0;
      case m.Close:
      case m.Sequence:
      case m.Ping:
      case m.Ack:
        return !1;
    }
  }
  _ackTimer() {
    this._ackTimerHandle === void 0 && (this._ackTimerHandle = setTimeout(async () => {
      try {
        this._reconnectInProgress || await this._connection.send(this._protocol.writeMessage({ type: m.Ack, sequenceId: this._latestReceivedSequenceId }));
      } catch {
      }
      clearTimeout(this._ackTimerHandle), this._ackTimerHandle = void 0;
    }, 1e3));
  }
}
class Bl {
  constructor(e, t, n, s) {
    this._message = e, this._id = t, this._resolver = n, this._rejector = s;
  }
}
const jl = 30 * 1e3, Wl = 15 * 1e3, ql = 1e5;
var I;
(function(r) {
  r.Disconnected = "Disconnected", r.Connecting = "Connecting", r.Connected = "Connected", r.Disconnecting = "Disconnecting", r.Reconnecting = "Reconnecting";
})(I || (I = {}));
class Xr {
  /** @internal */
  // Using a public static factory method means we can have a private constructor and an _internal_
  // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
  // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
  // public parameter-less constructor.
  static create(e, t, n, s, o, i, a) {
    return new Xr(e, t, n, s, o, i, a);
  }
  constructor(e, t, n, s, o, i, a) {
    this._nextKeepAlive = 0, this._freezeEventListener = () => {
      this._logger.log(h.Warning, "The page is being frozen, this will likely lead to the connection being closed and messages being lost. For more information see the docs at https://learn.microsoft.com/aspnet/core/signalr/javascript-client#bsleep");
    }, O.isRequired(e, "connection"), O.isRequired(t, "logger"), O.isRequired(n, "protocol"), this.serverTimeoutInMilliseconds = o ?? jl, this.keepAliveIntervalInMilliseconds = i ?? Wl, this._statefulReconnectBufferSize = a ?? ql, this._logger = t, this._protocol = n, this.connection = e, this._reconnectPolicy = s, this._handshakeProtocol = new Fl(), this.connection.onreceive = (c) => this._processIncomingData(c), this.connection.onclose = (c) => this._connectionClosed(c), this._callbacks = {}, this._methods = {}, this._closedCallbacks = [], this._reconnectingCallbacks = [], this._reconnectedCallbacks = [], this._invocationId = 0, this._receivedHandshakeResponse = !1, this._connectionState = I.Disconnected, this._connectionStarted = !1, this._cachedPingMessage = this._protocol.writeMessage({ type: m.Ping });
  }
  /** Indicates the state of the {@link HubConnection} to the server. */
  get state() {
    return this._connectionState;
  }
  /** Represents the connection id of the {@link HubConnection} on the server. The connection id will be null when the connection is either
   *  in the disconnected state or if the negotiation step was skipped.
   */
  get connectionId() {
    return this.connection && this.connection.connectionId || null;
  }
  /** Indicates the url of the {@link HubConnection} to the server. */
  get baseUrl() {
    return this.connection.baseUrl || "";
  }
  /**
   * Sets a new url for the HubConnection. Note that the url can only be changed when the connection is in either the Disconnected or
   * Reconnecting states.
   * @param {string} url The url to connect to.
   */
  set baseUrl(e) {
    if (this._connectionState !== I.Disconnected && this._connectionState !== I.Reconnecting)
      throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
    if (!e)
      throw new Error("The HubConnection url must be a valid url.");
    this.connection.baseUrl = e;
  }
  /** Starts the connection.
   *
   * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
   */
  start() {
    return this._startPromise = this._startWithStateTransitions(), this._startPromise;
  }
  async _startWithStateTransitions() {
    if (this._connectionState !== I.Disconnected)
      return Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state."));
    this._connectionState = I.Connecting, this._logger.log(h.Debug, "Starting HubConnection.");
    try {
      await this._startInternal(), A.isBrowser && window.document.addEventListener("freeze", this._freezeEventListener), this._connectionState = I.Connected, this._connectionStarted = !0, this._logger.log(h.Debug, "HubConnection connected successfully.");
    } catch (e) {
      return this._connectionState = I.Disconnected, this._logger.log(h.Debug, `HubConnection failed to start successfully because of error '${e}'.`), Promise.reject(e);
    }
  }
  async _startInternal() {
    this._stopDuringStartError = void 0, this._receivedHandshakeResponse = !1;
    const e = new Promise((t, n) => {
      this._handshakeResolver = t, this._handshakeRejecter = n;
    });
    await this.connection.start(this._protocol.transferFormat);
    try {
      let t = this._protocol.version;
      this.connection.features.reconnect || (t = 1);
      const n = {
        protocol: this._protocol.name,
        version: t
      };
      if (this._logger.log(h.Debug, "Sending handshake request."), await this._sendMessage(this._handshakeProtocol.writeHandshakeRequest(n)), this._logger.log(h.Information, `Using HubProtocol '${this._protocol.name}'.`), this._cleanupTimeout(), this._resetTimeoutPeriod(), this._resetKeepAliveInterval(), await e, this._stopDuringStartError)
        throw this._stopDuringStartError;
      (this.connection.features.reconnect || !1) && (this._messageBuffer = new Hl(this._protocol, this.connection, this._statefulReconnectBufferSize), this.connection.features.disconnected = this._messageBuffer._disconnected.bind(this._messageBuffer), this.connection.features.resend = () => {
        if (this._messageBuffer)
          return this._messageBuffer._resend();
      }), this.connection.features.inherentKeepAlive || await this._sendMessage(this._cachedPingMessage);
    } catch (t) {
      throw this._logger.log(h.Debug, `Hub handshake failed with error '${t}' during start(). Stopping HubConnection.`), this._cleanupTimeout(), this._cleanupPingTimer(), await this.connection.stop(t), t;
    }
  }
  /** Stops the connection.
   *
   * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
   */
  async stop() {
    const e = this._startPromise;
    this.connection.features.reconnect = !1, this._stopPromise = this._stopInternal(), await this._stopPromise;
    try {
      await e;
    } catch {
    }
  }
  _stopInternal(e) {
    if (this._connectionState === I.Disconnected)
      return this._logger.log(h.Debug, `Call to HubConnection.stop(${e}) ignored because it is already in the disconnected state.`), Promise.resolve();
    if (this._connectionState === I.Disconnecting)
      return this._logger.log(h.Debug, `Call to HttpConnection.stop(${e}) ignored because the connection is already in the disconnecting state.`), this._stopPromise;
    const t = this._connectionState;
    return this._connectionState = I.Disconnecting, this._logger.log(h.Debug, "Stopping HubConnection."), this._reconnectDelayHandle ? (this._logger.log(h.Debug, "Connection stopped during reconnect delay. Done reconnecting."), clearTimeout(this._reconnectDelayHandle), this._reconnectDelayHandle = void 0, this._completeClose(), Promise.resolve()) : (t === I.Connected && this._sendCloseMessage(), this._cleanupTimeout(), this._cleanupPingTimer(), this._stopDuringStartError = e || new ne("The connection was stopped before the hub handshake could complete."), this.connection.stop(e));
  }
  async _sendCloseMessage() {
    try {
      await this._sendWithProtocol(this._createCloseMessage());
    } catch {
    }
  }
  /** Invokes a streaming hub method on the server using the specified name and arguments.
   *
   * @typeparam T The type of the items returned by the server.
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
   */
  stream(e, ...t) {
    const [n, s] = this._replaceStreamingParams(t), o = this._createStreamInvocation(e, t, s);
    let i;
    const a = new Ul();
    return a.cancelCallback = () => {
      const c = this._createCancelInvocation(o.invocationId);
      return delete this._callbacks[o.invocationId], i.then(() => this._sendWithProtocol(c));
    }, this._callbacks[o.invocationId] = (c, d) => {
      if (d) {
        a.error(d);
        return;
      } else c && (c.type === m.Completion ? c.error ? a.error(new Error(c.error)) : a.complete() : a.next(c.item));
    }, i = this._sendWithProtocol(o).catch((c) => {
      a.error(c), delete this._callbacks[o.invocationId];
    }), this._launchStreams(n, i), a;
  }
  _sendMessage(e) {
    return this._resetKeepAliveInterval(), this.connection.send(e);
  }
  /**
   * Sends a js object to the server.
   * @param message The js object to serialize and send.
   */
  _sendWithProtocol(e) {
    return this._messageBuffer ? this._messageBuffer._send(e) : this._sendMessage(this._protocol.writeMessage(e));
  }
  /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
   *
   * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
   * be processing the invocation.
   *
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
   */
  send(e, ...t) {
    const [n, s] = this._replaceStreamingParams(t), o = this._sendWithProtocol(this._createInvocation(e, t, !0, s));
    return this._launchStreams(n, o), o;
  }
  /** Invokes a hub method on the server using the specified name and arguments.
   *
   * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
   * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
   * resolving the Promise.
   *
   * @typeparam T The expected return type.
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
   */
  invoke(e, ...t) {
    const [n, s] = this._replaceStreamingParams(t), o = this._createInvocation(e, t, !1, s);
    return new Promise((a, c) => {
      this._callbacks[o.invocationId] = (u, w) => {
        if (w) {
          c(w);
          return;
        } else u && (u.type === m.Completion ? u.error ? c(new Error(u.error)) : a(u.result) : c(new Error(`Unexpected message type: ${u.type}`)));
      };
      const d = this._sendWithProtocol(o).catch((u) => {
        c(u), delete this._callbacks[o.invocationId];
      });
      this._launchStreams(n, d);
    });
  }
  on(e, t) {
    !e || !t || (e = e.toLowerCase(), this._methods[e] || (this._methods[e] = []), this._methods[e].indexOf(t) === -1 && this._methods[e].push(t));
  }
  off(e, t) {
    if (!e)
      return;
    e = e.toLowerCase();
    const n = this._methods[e];
    if (n)
      if (t) {
        const s = n.indexOf(t);
        s !== -1 && (n.splice(s, 1), n.length === 0 && delete this._methods[e]);
      } else
        delete this._methods[e];
  }
  /** Registers a handler that will be invoked when the connection is closed.
   *
   * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
   */
  onclose(e) {
    e && this._closedCallbacks.push(e);
  }
  /** Registers a handler that will be invoked when the connection starts reconnecting.
   *
   * @param {Function} callback The handler that will be invoked when the connection starts reconnecting. Optionally receives a single argument containing the error that caused the connection to start reconnecting (if any).
   */
  onreconnecting(e) {
    e && this._reconnectingCallbacks.push(e);
  }
  /** Registers a handler that will be invoked when the connection successfully reconnects.
   *
   * @param {Function} callback The handler that will be invoked when the connection successfully reconnects.
   */
  onreconnected(e) {
    e && this._reconnectedCallbacks.push(e);
  }
  _processIncomingData(e) {
    if (this._cleanupTimeout(), this._receivedHandshakeResponse || (e = this._processHandshakeResponse(e), this._receivedHandshakeResponse = !0), e) {
      const t = this._protocol.parseMessages(e, this._logger);
      for (const n of t)
        if (!(this._messageBuffer && !this._messageBuffer._shouldProcessMessage(n)))
          switch (n.type) {
            case m.Invocation:
              this._invokeClientMethod(n).catch((s) => {
                this._logger.log(h.Error, `Invoke client method threw error: ${wr(s)}`);
              });
              break;
            case m.StreamItem:
            case m.Completion: {
              const s = this._callbacks[n.invocationId];
              if (s) {
                n.type === m.Completion && delete this._callbacks[n.invocationId];
                try {
                  s(n);
                } catch (o) {
                  this._logger.log(h.Error, `Stream callback threw error: ${wr(o)}`);
                }
              }
              break;
            }
            case m.Ping:
              break;
            case m.Close: {
              this._logger.log(h.Information, "Close message received from server.");
              const s = n.error ? new Error("Server returned an error on close: " + n.error) : void 0;
              n.allowReconnect === !0 ? this.connection.stop(s) : this._stopPromise = this._stopInternal(s);
              break;
            }
            case m.Ack:
              this._messageBuffer && this._messageBuffer._ack(n);
              break;
            case m.Sequence:
              this._messageBuffer && this._messageBuffer._resetSequence(n);
              break;
            default:
              this._logger.log(h.Warning, `Invalid message type: ${n.type}.`);
              break;
          }
    }
    this._resetTimeoutPeriod();
  }
  _processHandshakeResponse(e) {
    let t, n;
    try {
      [n, t] = this._handshakeProtocol.parseHandshakeResponse(e);
    } catch (s) {
      const o = "Error parsing handshake response: " + s;
      this._logger.log(h.Error, o);
      const i = new Error(o);
      throw this._handshakeRejecter(i), i;
    }
    if (t.error) {
      const s = "Server returned handshake error: " + t.error;
      this._logger.log(h.Error, s);
      const o = new Error(s);
      throw this._handshakeRejecter(o), o;
    } else
      this._logger.log(h.Debug, "Server handshake complete.");
    return this._handshakeResolver(), n;
  }
  _resetKeepAliveInterval() {
    this.connection.features.inherentKeepAlive || (this._nextKeepAlive = (/* @__PURE__ */ new Date()).getTime() + this.keepAliveIntervalInMilliseconds, this._cleanupPingTimer());
  }
  _resetTimeoutPeriod() {
    if ((!this.connection.features || !this.connection.features.inherentKeepAlive) && (this._timeoutHandle = setTimeout(() => this.serverTimeout(), this.serverTimeoutInMilliseconds), this._pingServerHandle === void 0)) {
      let e = this._nextKeepAlive - (/* @__PURE__ */ new Date()).getTime();
      e < 0 && (e = 0), this._pingServerHandle = setTimeout(async () => {
        if (this._connectionState === I.Connected)
          try {
            await this._sendMessage(this._cachedPingMessage);
          } catch {
            this._cleanupPingTimer();
          }
      }, e);
    }
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  serverTimeout() {
    this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
  }
  async _invokeClientMethod(e) {
    const t = e.target.toLowerCase(), n = this._methods[t];
    if (!n) {
      this._logger.log(h.Warning, `No client method with the name '${t}' found.`), e.invocationId && (this._logger.log(h.Warning, `No result given for '${t}' method and invocation ID '${e.invocationId}'.`), await this._sendWithProtocol(this._createCompletionMessage(e.invocationId, "Client didn't provide a result.", null)));
      return;
    }
    const s = n.slice(), o = !!e.invocationId;
    let i, a, c;
    for (const d of s)
      try {
        const u = i;
        i = await d.apply(this, e.arguments), o && i && u && (this._logger.log(h.Error, `Multiple results provided for '${t}'. Sending error to server.`), c = this._createCompletionMessage(e.invocationId, "Client provided multiple results.", null)), a = void 0;
      } catch (u) {
        a = u, this._logger.log(h.Error, `A callback for the method '${t}' threw error '${u}'.`);
      }
    c ? await this._sendWithProtocol(c) : o ? (a ? c = this._createCompletionMessage(e.invocationId, `${a}`, null) : i !== void 0 ? c = this._createCompletionMessage(e.invocationId, null, i) : (this._logger.log(h.Warning, `No result given for '${t}' method and invocation ID '${e.invocationId}'.`), c = this._createCompletionMessage(e.invocationId, "Client didn't provide a result.", null)), await this._sendWithProtocol(c)) : i && this._logger.log(h.Error, `Result given for '${t}' method but server is not expecting a result.`);
  }
  _connectionClosed(e) {
    this._logger.log(h.Debug, `HubConnection.connectionClosed(${e}) called while in state ${this._connectionState}.`), this._stopDuringStartError = this._stopDuringStartError || e || new ne("The underlying connection was closed before the hub handshake could complete."), this._handshakeResolver && this._handshakeResolver(), this._cancelCallbacksWithError(e || new Error("Invocation canceled due to the underlying connection being closed.")), this._cleanupTimeout(), this._cleanupPingTimer(), this._connectionState === I.Disconnecting ? this._completeClose(e) : this._connectionState === I.Connected && this._reconnectPolicy ? this._reconnect(e) : this._connectionState === I.Connected && this._completeClose(e);
  }
  _completeClose(e) {
    if (this._connectionStarted) {
      this._connectionState = I.Disconnected, this._connectionStarted = !1, this._messageBuffer && (this._messageBuffer._dispose(e ?? new Error("Connection closed.")), this._messageBuffer = void 0), A.isBrowser && window.document.removeEventListener("freeze", this._freezeEventListener);
      try {
        this._closedCallbacks.forEach((t) => t.apply(this, [e]));
      } catch (t) {
        this._logger.log(h.Error, `An onclose callback called with error '${e}' threw error '${t}'.`);
      }
    }
  }
  async _reconnect(e) {
    const t = Date.now();
    let n = 0, s = e !== void 0 ? e : new Error("Attempting to reconnect due to a unknown error."), o = this._getNextRetryDelay(n++, 0, s);
    if (o === null) {
      this._logger.log(h.Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt."), this._completeClose(e);
      return;
    }
    if (this._connectionState = I.Reconnecting, e ? this._logger.log(h.Information, `Connection reconnecting because of error '${e}'.`) : this._logger.log(h.Information, "Connection reconnecting."), this._reconnectingCallbacks.length !== 0) {
      try {
        this._reconnectingCallbacks.forEach((i) => i.apply(this, [e]));
      } catch (i) {
        this._logger.log(h.Error, `An onreconnecting callback called with error '${e}' threw error '${i}'.`);
      }
      if (this._connectionState !== I.Reconnecting) {
        this._logger.log(h.Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");
        return;
      }
    }
    for (; o !== null; ) {
      if (this._logger.log(h.Information, `Reconnect attempt number ${n} will start in ${o} ms.`), await new Promise((i) => {
        this._reconnectDelayHandle = setTimeout(i, o);
      }), this._reconnectDelayHandle = void 0, this._connectionState !== I.Reconnecting) {
        this._logger.log(h.Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");
        return;
      }
      try {
        if (await this._startInternal(), this._connectionState = I.Connected, this._logger.log(h.Information, "HubConnection reconnected successfully."), this._reconnectedCallbacks.length !== 0)
          try {
            this._reconnectedCallbacks.forEach((i) => i.apply(this, [this.connection.connectionId]));
          } catch (i) {
            this._logger.log(h.Error, `An onreconnected callback called with connectionId '${this.connection.connectionId}; threw error '${i}'.`);
          }
        return;
      } catch (i) {
        if (this._logger.log(h.Information, `Reconnect attempt failed because of error '${i}'.`), this._connectionState !== I.Reconnecting) {
          this._logger.log(h.Debug, `Connection moved to the '${this._connectionState}' from the reconnecting state during reconnect attempt. Done reconnecting.`), this._connectionState === I.Disconnecting && this._completeClose();
          return;
        }
        s = i instanceof Error ? i : new Error(i.toString()), o = this._getNextRetryDelay(n++, Date.now() - t, s);
      }
    }
    this._logger.log(h.Information, `Reconnect retries have been exhausted after ${Date.now() - t} ms and ${n} failed attempts. Connection disconnecting.`), this._completeClose();
  }
  _getNextRetryDelay(e, t, n) {
    try {
      return this._reconnectPolicy.nextRetryDelayInMilliseconds({
        elapsedMilliseconds: t,
        previousRetryCount: e,
        retryReason: n
      });
    } catch (s) {
      return this._logger.log(h.Error, `IRetryPolicy.nextRetryDelayInMilliseconds(${e}, ${t}) threw error '${s}'.`), null;
    }
  }
  _cancelCallbacksWithError(e) {
    const t = this._callbacks;
    this._callbacks = {}, Object.keys(t).forEach((n) => {
      const s = t[n];
      try {
        s(null, e);
      } catch (o) {
        this._logger.log(h.Error, `Stream 'error' callback called with '${e}' threw error: ${wr(o)}`);
      }
    });
  }
  _cleanupPingTimer() {
    this._pingServerHandle && (clearTimeout(this._pingServerHandle), this._pingServerHandle = void 0);
  }
  _cleanupTimeout() {
    this._timeoutHandle && clearTimeout(this._timeoutHandle);
  }
  _createInvocation(e, t, n, s) {
    if (n)
      return s.length !== 0 ? {
        target: e,
        arguments: t,
        streamIds: s,
        type: m.Invocation
      } : {
        target: e,
        arguments: t,
        type: m.Invocation
      };
    {
      const o = this._invocationId;
      return this._invocationId++, s.length !== 0 ? {
        target: e,
        arguments: t,
        invocationId: o.toString(),
        streamIds: s,
        type: m.Invocation
      } : {
        target: e,
        arguments: t,
        invocationId: o.toString(),
        type: m.Invocation
      };
    }
  }
  _launchStreams(e, t) {
    if (e.length !== 0) {
      t || (t = Promise.resolve());
      for (const n in e)
        e[n].subscribe({
          complete: () => {
            t = t.then(() => this._sendWithProtocol(this._createCompletionMessage(n)));
          },
          error: (s) => {
            let o;
            s instanceof Error ? o = s.message : s && s.toString ? o = s.toString() : o = "Unknown error", t = t.then(() => this._sendWithProtocol(this._createCompletionMessage(n, o)));
          },
          next: (s) => {
            t = t.then(() => this._sendWithProtocol(this._createStreamItemMessage(n, s)));
          }
        });
    }
  }
  _replaceStreamingParams(e) {
    const t = [], n = [];
    for (let s = 0; s < e.length; s++) {
      const o = e[s];
      if (this._isObservable(o)) {
        const i = this._invocationId;
        this._invocationId++, t[i] = o, n.push(i.toString()), e.splice(s, 1);
      }
    }
    return [t, n];
  }
  _isObservable(e) {
    return e && e.subscribe && typeof e.subscribe == "function";
  }
  _createStreamInvocation(e, t, n) {
    const s = this._invocationId;
    return this._invocationId++, n.length !== 0 ? {
      target: e,
      arguments: t,
      invocationId: s.toString(),
      streamIds: n,
      type: m.StreamInvocation
    } : {
      target: e,
      arguments: t,
      invocationId: s.toString(),
      type: m.StreamInvocation
    };
  }
  _createCancelInvocation(e) {
    return {
      invocationId: e,
      type: m.CancelInvocation
    };
  }
  _createStreamItemMessage(e, t) {
    return {
      invocationId: e,
      item: t,
      type: m.StreamItem
    };
  }
  _createCompletionMessage(e, t, n) {
    return t ? {
      error: t,
      invocationId: e,
      type: m.Completion
    } : {
      invocationId: e,
      result: n,
      type: m.Completion
    };
  }
  _createCloseMessage() {
    return { type: m.Close };
  }
}
const Gl = [0, 2e3, 1e4, 3e4, null];
class Ks {
  constructor(e) {
    this._retryDelays = e !== void 0 ? [...e, null] : Gl;
  }
  nextRetryDelayInMilliseconds(e) {
    return this._retryDelays[e.previousRetryCount];
  }
}
class Me {
}
Me.Authorization = "Authorization";
Me.Cookie = "Cookie";
class Vl extends Wt {
  constructor(e, t) {
    super(), this._innerClient = e, this._accessTokenFactory = t;
  }
  async send(e) {
    let t = !0;
    this._accessTokenFactory && (!this._accessToken || e.url && e.url.indexOf("/negotiate?") > 0) && (t = !1, this._accessToken = await this._accessTokenFactory()), this._setAuthorizationHeader(e);
    const n = await this._innerClient.send(e);
    return t && n.statusCode === 401 && this._accessTokenFactory ? (this._accessToken = await this._accessTokenFactory(), this._setAuthorizationHeader(e), await this._innerClient.send(e)) : n;
  }
  _setAuthorizationHeader(e) {
    e.headers || (e.headers = {}), this._accessToken ? e.headers[Me.Authorization] = `Bearer ${this._accessToken}` : this._accessTokenFactory && e.headers[Me.Authorization] && delete e.headers[Me.Authorization];
  }
  getCookieString(e) {
    return this._innerClient.getCookieString(e);
  }
}
var L;
(function(r) {
  r[r.None = 0] = "None", r[r.WebSockets = 1] = "WebSockets", r[r.ServerSentEvents = 2] = "ServerSentEvents", r[r.LongPolling = 4] = "LongPolling";
})(L || (L = {}));
var j;
(function(r) {
  r[r.Text = 1] = "Text", r[r.Binary = 2] = "Binary";
})(j || (j = {}));
let Yl = class {
  constructor() {
    this._isAborted = !1, this.onabort = null;
  }
  abort() {
    this._isAborted || (this._isAborted = !0, this.onabort && this.onabort());
  }
  get signal() {
    return this;
  }
  get aborted() {
    return this._isAborted;
  }
};
class Js {
  // This is an internal type, not exported from 'index' so this is really just internal.
  get pollAborted() {
    return this._pollAbort.aborted;
  }
  constructor(e, t, n) {
    this._httpClient = e, this._logger = t, this._pollAbort = new Yl(), this._options = n, this._running = !1, this.onreceive = null, this.onclose = null;
  }
  async connect(e, t) {
    if (O.isRequired(e, "url"), O.isRequired(t, "transferFormat"), O.isIn(t, j, "transferFormat"), this._url = e, this._logger.log(h.Trace, "(LongPolling transport) Connecting."), t === j.Binary && typeof XMLHttpRequest < "u" && typeof new XMLHttpRequest().responseType != "string")
      throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
    const [n, s] = Ve(), o = { [n]: s, ...this._options.headers }, i = {
      abortSignal: this._pollAbort.signal,
      headers: o,
      timeout: 1e5,
      withCredentials: this._options.withCredentials
    };
    t === j.Binary && (i.responseType = "arraybuffer");
    const a = `${e}&_=${Date.now()}`;
    this._logger.log(h.Trace, `(LongPolling transport) polling: ${a}.`);
    const c = await this._httpClient.get(a, i);
    c.statusCode !== 200 ? (this._logger.log(h.Error, `(LongPolling transport) Unexpected response code: ${c.statusCode}.`), this._closeError = new Pe(c.statusText || "", c.statusCode), this._running = !1) : this._running = !0, this._receiving = this._poll(this._url, i);
  }
  async _poll(e, t) {
    try {
      for (; this._running; )
        try {
          const n = `${e}&_=${Date.now()}`;
          this._logger.log(h.Trace, `(LongPolling transport) polling: ${n}.`);
          const s = await this._httpClient.get(n, t);
          s.statusCode === 204 ? (this._logger.log(h.Information, "(LongPolling transport) Poll terminated by server."), this._running = !1) : s.statusCode !== 200 ? (this._logger.log(h.Error, `(LongPolling transport) Unexpected response code: ${s.statusCode}.`), this._closeError = new Pe(s.statusText || "", s.statusCode), this._running = !1) : s.content ? (this._logger.log(h.Trace, `(LongPolling transport) data received. ${ut(s.content, this._options.logMessageContent)}.`), this.onreceive && this.onreceive(s.content)) : this._logger.log(h.Trace, "(LongPolling transport) Poll timed out, reissuing.");
        } catch (n) {
          this._running ? n instanceof Yr ? this._logger.log(h.Trace, "(LongPolling transport) Poll timed out, reissuing.") : (this._closeError = n, this._running = !1) : this._logger.log(h.Trace, `(LongPolling transport) Poll errored after shutdown: ${n.message}`);
        }
    } finally {
      this._logger.log(h.Trace, "(LongPolling transport) Polling complete."), this.pollAborted || this._raiseOnClose();
    }
  }
  async send(e) {
    return this._running ? Yn(this._logger, "LongPolling", this._httpClient, this._url, e, this._options) : Promise.reject(new Error("Cannot send until the transport is connected"));
  }
  async stop() {
    this._logger.log(h.Trace, "(LongPolling transport) Stopping polling."), this._running = !1, this._pollAbort.abort();
    try {
      await this._receiving, this._logger.log(h.Trace, `(LongPolling transport) sending DELETE request to ${this._url}.`);
      const e = {}, [t, n] = Ve();
      e[t] = n;
      const s = {
        headers: { ...e, ...this._options.headers },
        timeout: this._options.timeout,
        withCredentials: this._options.withCredentials
      };
      let o;
      try {
        await this._httpClient.delete(this._url, s);
      } catch (i) {
        o = i;
      }
      o ? o instanceof Pe && (o.statusCode === 404 ? this._logger.log(h.Trace, "(LongPolling transport) A 404 response was returned from sending a DELETE request.") : this._logger.log(h.Trace, `(LongPolling transport) Error sending a DELETE request: ${o}`)) : this._logger.log(h.Trace, "(LongPolling transport) DELETE request accepted.");
    } finally {
      this._logger.log(h.Trace, "(LongPolling transport) Stop finished."), this._raiseOnClose();
    }
  }
  _raiseOnClose() {
    if (this.onclose) {
      let e = "(LongPolling transport) Firing onclose event.";
      this._closeError && (e += " Error: " + this._closeError), this._logger.log(h.Trace, e), this.onclose(this._closeError);
    }
  }
}
class Xl {
  constructor(e, t, n, s) {
    this._httpClient = e, this._accessToken = t, this._logger = n, this._options = s, this.onreceive = null, this.onclose = null;
  }
  async connect(e, t) {
    return O.isRequired(e, "url"), O.isRequired(t, "transferFormat"), O.isIn(t, j, "transferFormat"), this._logger.log(h.Trace, "(SSE transport) Connecting."), this._url = e, this._accessToken && (e += (e.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(this._accessToken)}`), new Promise((n, s) => {
      let o = !1;
      if (t !== j.Text) {
        s(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
        return;
      }
      let i;
      if (A.isBrowser || A.isWebWorker)
        i = new this._options.EventSource(e, { withCredentials: this._options.withCredentials });
      else {
        const a = this._httpClient.getCookieString(e), c = {};
        c.Cookie = a;
        const [d, u] = Ve();
        c[d] = u, i = new this._options.EventSource(e, { withCredentials: this._options.withCredentials, headers: { ...c, ...this._options.headers } });
      }
      try {
        i.onmessage = (a) => {
          if (this.onreceive)
            try {
              this._logger.log(h.Trace, `(SSE transport) data received. ${ut(a.data, this._options.logMessageContent)}.`), this.onreceive(a.data);
            } catch (c) {
              this._close(c);
              return;
            }
        }, i.onerror = (a) => {
          o ? this._close() : s(new Error("EventSource failed to connect. The connection could not be found on the server, either the connection ID is not present on the server, or a proxy is refusing/buffering the connection. If you have multiple servers check that sticky sessions are enabled."));
        }, i.onopen = () => {
          this._logger.log(h.Information, `SSE connected to ${this._url}`), this._eventSource = i, o = !0, n();
        };
      } catch (a) {
        s(a);
        return;
      }
    });
  }
  async send(e) {
    return this._eventSource ? Yn(this._logger, "SSE", this._httpClient, this._url, e, this._options) : Promise.reject(new Error("Cannot send until the transport is connected"));
  }
  stop() {
    return this._close(), Promise.resolve();
  }
  _close(e) {
    this._eventSource && (this._eventSource.close(), this._eventSource = void 0, this.onclose && this.onclose(e));
  }
}
class Zl {
  constructor(e, t, n, s, o, i) {
    this._logger = n, this._accessTokenFactory = t, this._logMessageContent = s, this._webSocketConstructor = o, this._httpClient = e, this.onreceive = null, this.onclose = null, this._headers = i;
  }
  async connect(e, t) {
    O.isRequired(e, "url"), O.isRequired(t, "transferFormat"), O.isIn(t, j, "transferFormat"), this._logger.log(h.Trace, "(WebSockets transport) Connecting.");
    let n;
    return this._accessTokenFactory && (n = await this._accessTokenFactory()), new Promise((s, o) => {
      e = e.replace(/^http/, "ws");
      let i;
      const a = this._httpClient.getCookieString(e);
      let c = !1;
      if (A.isNode || A.isReactNative) {
        const d = {}, [u, w] = Ve();
        d[u] = w, n && (d[Me.Authorization] = `Bearer ${n}`), a && (d[Me.Cookie] = a), i = new this._webSocketConstructor(e, void 0, {
          headers: { ...d, ...this._headers }
        });
      } else
        n && (e += (e.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(n)}`);
      i || (i = new this._webSocketConstructor(e)), t === j.Binary && (i.binaryType = "arraybuffer"), i.onopen = (d) => {
        this._logger.log(h.Information, `WebSocket connected to ${e}.`), this._webSocket = i, c = !0, s();
      }, i.onerror = (d) => {
        let u = null;
        typeof ErrorEvent < "u" && d instanceof ErrorEvent ? u = d.error : u = "There was an error with the transport", this._logger.log(h.Information, `(WebSockets transport) ${u}.`);
      }, i.onmessage = (d) => {
        if (this._logger.log(h.Trace, `(WebSockets transport) data received. ${ut(d.data, this._logMessageContent)}.`), this.onreceive)
          try {
            this.onreceive(d.data);
          } catch (u) {
            this._close(u);
            return;
          }
      }, i.onclose = (d) => {
        if (c)
          this._close(d);
        else {
          let u = null;
          typeof ErrorEvent < "u" && d instanceof ErrorEvent ? u = d.error : u = "WebSocket failed to connect. The connection could not be found on the server, either the endpoint may not be a SignalR endpoint, the connection ID is not present on the server, or there is a proxy blocking WebSockets. If you have multiple servers check that sticky sessions are enabled.", o(new Error(u));
        }
      };
    });
  }
  send(e) {
    return this._webSocket && this._webSocket.readyState === this._webSocketConstructor.OPEN ? (this._logger.log(h.Trace, `(WebSockets transport) sending data. ${ut(e, this._logMessageContent)}.`), this._webSocket.send(e), Promise.resolve()) : Promise.reject("WebSocket is not in the OPEN state");
  }
  stop() {
    return this._webSocket && this._close(void 0), Promise.resolve();
  }
  _close(e) {
    this._webSocket && (this._webSocket.onclose = () => {
    }, this._webSocket.onmessage = () => {
    }, this._webSocket.onerror = () => {
    }, this._webSocket.close(), this._webSocket = void 0), this._logger.log(h.Trace, "(WebSockets transport) socket closed."), this.onclose && (this._isCloseEvent(e) && (e.wasClean === !1 || e.code !== 1e3) ? this.onclose(new Error(`WebSocket closed with status code: ${e.code} (${e.reason || "no reason given"}).`)) : e instanceof Error ? this.onclose(e) : this.onclose());
  }
  _isCloseEvent(e) {
    return e && typeof e.wasClean == "boolean" && typeof e.code == "number";
  }
}
const Qs = 100;
class Kl {
  constructor(e, t = {}) {
    if (this._stopPromiseResolver = () => {
    }, this.features = {}, this._negotiateVersion = 1, O.isRequired(e, "url"), this._logger = Al(t.logger), this.baseUrl = this._resolveUrl(e), t = t || {}, t.logMessageContent = t.logMessageContent === void 0 ? !1 : t.logMessageContent, typeof t.withCredentials == "boolean" || t.withCredentials === void 0)
      t.withCredentials = t.withCredentials === void 0 ? !0 : t.withCredentials;
    else
      throw new Error("withCredentials option was not a 'boolean' or 'undefined' value");
    t.timeout = t.timeout === void 0 ? 100 * 1e3 : t.timeout;
    let n = null, s = null;
    if (A.isNode && typeof require < "u") {
      const o = typeof __webpack_require__ == "function" ? __non_webpack_require__ : require;
      n = o("ws"), s = o("eventsource");
    }
    !A.isNode && typeof WebSocket < "u" && !t.WebSocket ? t.WebSocket = WebSocket : A.isNode && !t.WebSocket && n && (t.WebSocket = n), !A.isNode && typeof EventSource < "u" && !t.EventSource ? t.EventSource = EventSource : A.isNode && !t.EventSource && typeof s < "u" && (t.EventSource = s), this._httpClient = new Vl(t.httpClient || new zl(this._logger), t.accessTokenFactory), this._connectionState = "Disconnected", this._connectionStarted = !1, this._options = t, this.onreceive = null, this.onclose = null;
  }
  async start(e) {
    if (e = e || j.Binary, O.isIn(e, j, "transferFormat"), this._logger.log(h.Debug, `Starting connection with transfer format '${j[e]}'.`), this._connectionState !== "Disconnected")
      return Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state."));
    if (this._connectionState = "Connecting", this._startInternalPromise = this._startInternal(e), await this._startInternalPromise, this._connectionState === "Disconnecting") {
      const t = "Failed to start the HttpConnection before stop() was called.";
      return this._logger.log(h.Error, t), await this._stopPromise, Promise.reject(new ne(t));
    } else if (this._connectionState !== "Connected") {
      const t = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
      return this._logger.log(h.Error, t), Promise.reject(new ne(t));
    }
    this._connectionStarted = !0;
  }
  send(e) {
    return this._connectionState !== "Connected" ? Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State.")) : (this._sendQueue || (this._sendQueue = new Zr(this.transport)), this._sendQueue.send(e));
  }
  async stop(e) {
    if (this._connectionState === "Disconnected")
      return this._logger.log(h.Debug, `Call to HttpConnection.stop(${e}) ignored because the connection is already in the disconnected state.`), Promise.resolve();
    if (this._connectionState === "Disconnecting")
      return this._logger.log(h.Debug, `Call to HttpConnection.stop(${e}) ignored because the connection is already in the disconnecting state.`), this._stopPromise;
    this._connectionState = "Disconnecting", this._stopPromise = new Promise((t) => {
      this._stopPromiseResolver = t;
    }), await this._stopInternal(e), await this._stopPromise;
  }
  async _stopInternal(e) {
    this._stopError = e;
    try {
      await this._startInternalPromise;
    } catch {
    }
    if (this.transport) {
      try {
        await this.transport.stop();
      } catch (t) {
        this._logger.log(h.Error, `HttpConnection.transport.stop() threw error '${t}'.`), this._stopConnection();
      }
      this.transport = void 0;
    } else
      this._logger.log(h.Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
  }
  async _startInternal(e) {
    let t = this.baseUrl;
    this._accessTokenFactory = this._options.accessTokenFactory, this._httpClient._accessTokenFactory = this._accessTokenFactory;
    try {
      if (this._options.skipNegotiation)
        if (this._options.transport === L.WebSockets)
          this.transport = this._constructTransport(L.WebSockets), await this._startTransport(t, e);
        else
          throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
      else {
        let n = null, s = 0;
        do {
          if (n = await this._getNegotiationResponse(t), this._connectionState === "Disconnecting" || this._connectionState === "Disconnected")
            throw new ne("The connection was stopped during negotiation.");
          if (n.error)
            throw new Error(n.error);
          if (n.ProtocolVersion)
            throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
          if (n.url && (t = n.url), n.accessToken) {
            const o = n.accessToken;
            this._accessTokenFactory = () => o, this._httpClient._accessToken = o, this._httpClient._accessTokenFactory = void 0;
          }
          s++;
        } while (n.url && s < Qs);
        if (s === Qs && n.url)
          throw new Error("Negotiate redirection limit exceeded.");
        await this._createTransport(t, this._options.transport, n, e);
      }
      this.transport instanceof Js && (this.features.inherentKeepAlive = !0), this._connectionState === "Connecting" && (this._logger.log(h.Debug, "The HttpConnection connected successfully."), this._connectionState = "Connected");
    } catch (n) {
      return this._logger.log(h.Error, "Failed to start the connection: " + n), this._connectionState = "Disconnected", this.transport = void 0, this._stopPromiseResolver(), Promise.reject(n);
    }
  }
  async _getNegotiationResponse(e) {
    const t = {}, [n, s] = Ve();
    t[n] = s;
    const o = this._resolveNegotiateUrl(e);
    this._logger.log(h.Debug, `Sending negotiation request: ${o}.`);
    try {
      const i = await this._httpClient.post(o, {
        content: "",
        headers: { ...t, ...this._options.headers },
        timeout: this._options.timeout,
        withCredentials: this._options.withCredentials
      });
      if (i.statusCode !== 200)
        return Promise.reject(new Error(`Unexpected status code returned from negotiate '${i.statusCode}'`));
      const a = JSON.parse(i.content);
      return (!a.negotiateVersion || a.negotiateVersion < 1) && (a.connectionToken = a.connectionId), a.useStatefulReconnect && this._options._useStatefulReconnect !== !0 ? Promise.reject(new Xs("Client didn't negotiate Stateful Reconnect but the server did.")) : a;
    } catch (i) {
      let a = "Failed to complete negotiation with the server: " + i;
      return i instanceof Pe && i.statusCode === 404 && (a = a + " Either this is not a SignalR endpoint or there is a proxy blocking the connection."), this._logger.log(h.Error, a), Promise.reject(new Xs(a));
    }
  }
  _createConnectUrl(e, t) {
    return t ? e + (e.indexOf("?") === -1 ? "?" : "&") + `id=${t}` : e;
  }
  async _createTransport(e, t, n, s) {
    let o = this._createConnectUrl(e, n.connectionToken);
    if (this._isITransport(t)) {
      this._logger.log(h.Debug, "Connection was provided an instance of ITransport, using that directly."), this.transport = t, await this._startTransport(o, s), this.connectionId = n.connectionId;
      return;
    }
    const i = [], a = n.availableTransports || [];
    let c = n;
    for (const d of a) {
      const u = this._resolveTransportOrError(d, t, s, c?.useStatefulReconnect === !0);
      if (u instanceof Error)
        i.push(`${d.transport} failed:`), i.push(u);
      else if (this._isITransport(u)) {
        if (this.transport = u, !c) {
          try {
            c = await this._getNegotiationResponse(e);
          } catch (w) {
            return Promise.reject(w);
          }
          o = this._createConnectUrl(e, c.connectionToken);
        }
        try {
          await this._startTransport(o, s), this.connectionId = c.connectionId;
          return;
        } catch (w) {
          if (this._logger.log(h.Error, `Failed to start the transport '${d.transport}': ${w}`), c = void 0, i.push(new Tl(`${d.transport} failed: ${w}`, L[d.transport])), this._connectionState !== "Connecting") {
            const k = "Failed to select transport before stop() was called.";
            return this._logger.log(h.Debug, k), Promise.reject(new ne(k));
          }
        }
      }
    }
    return i.length > 0 ? Promise.reject(new El(`Unable to connect to the server with any of the available transports. ${i.join(" ")}`, i)) : Promise.reject(new Error("None of the transports supported by the client are supported by the server."));
  }
  _constructTransport(e) {
    switch (e) {
      case L.WebSockets:
        if (!this._options.WebSocket)
          throw new Error("'WebSocket' is not supported in your environment.");
        return new Zl(this._httpClient, this._accessTokenFactory, this._logger, this._options.logMessageContent, this._options.WebSocket, this._options.headers || {});
      case L.ServerSentEvents:
        if (!this._options.EventSource)
          throw new Error("'EventSource' is not supported in your environment.");
        return new Xl(this._httpClient, this._httpClient._accessToken, this._logger, this._options);
      case L.LongPolling:
        return new Js(this._httpClient, this._logger, this._options);
      default:
        throw new Error(`Unknown transport: ${e}.`);
    }
  }
  _startTransport(e, t) {
    return this.transport.onreceive = this.onreceive, this.features.reconnect ? this.transport.onclose = async (n) => {
      let s = !1;
      if (this.features.reconnect)
        try {
          this.features.disconnected(), await this.transport.connect(e, t), await this.features.resend();
        } catch {
          s = !0;
        }
      else {
        this._stopConnection(n);
        return;
      }
      s && this._stopConnection(n);
    } : this.transport.onclose = (n) => this._stopConnection(n), this.transport.connect(e, t);
  }
  _resolveTransportOrError(e, t, n, s) {
    const o = L[e.transport];
    if (o == null)
      return this._logger.log(h.Debug, `Skipping transport '${e.transport}' because it is not supported by this client.`), new Error(`Skipping transport '${e.transport}' because it is not supported by this client.`);
    if (Jl(t, o))
      if (e.transferFormats.map((a) => j[a]).indexOf(n) >= 0) {
        if (o === L.WebSockets && !this._options.WebSocket || o === L.ServerSentEvents && !this._options.EventSource)
          return this._logger.log(h.Debug, `Skipping transport '${L[o]}' because it is not supported in your environment.'`), new xl(`'${L[o]}' is not supported in your environment.`, o);
        this._logger.log(h.Debug, `Selecting transport '${L[o]}'.`);
        try {
          return this.features.reconnect = o === L.WebSockets ? s : void 0, this._constructTransport(o);
        } catch (a) {
          return a;
        }
      } else
        return this._logger.log(h.Debug, `Skipping transport '${L[o]}' because it does not support the requested transfer format '${j[n]}'.`), new Error(`'${L[o]}' does not support ${j[n]}.`);
    else
      return this._logger.log(h.Debug, `Skipping transport '${L[o]}' because it was disabled by the client.`), new Sl(`'${L[o]}' is disabled by the client.`, o);
  }
  _isITransport(e) {
    return e && typeof e == "object" && "connect" in e;
  }
  _stopConnection(e) {
    if (this._logger.log(h.Debug, `HttpConnection.stopConnection(${e}) called while in state ${this._connectionState}.`), this.transport = void 0, e = this._stopError || e, this._stopError = void 0, this._connectionState === "Disconnected") {
      this._logger.log(h.Debug, `Call to HttpConnection.stopConnection(${e}) was ignored because the connection is already in the disconnected state.`);
      return;
    }
    if (this._connectionState === "Connecting")
      throw this._logger.log(h.Warning, `Call to HttpConnection.stopConnection(${e}) was ignored because the connection is still in the connecting state.`), new Error(`HttpConnection.stopConnection(${e}) was called while the connection is still in the connecting state.`);
    if (this._connectionState === "Disconnecting" && this._stopPromiseResolver(), e ? this._logger.log(h.Error, `Connection disconnected with error '${e}'.`) : this._logger.log(h.Information, "Connection disconnected."), this._sendQueue && (this._sendQueue.stop().catch((t) => {
      this._logger.log(h.Error, `TransportSendQueue.stop() threw error '${t}'.`);
    }), this._sendQueue = void 0), this.connectionId = void 0, this._connectionState = "Disconnected", this._connectionStarted) {
      this._connectionStarted = !1;
      try {
        this.onclose && this.onclose(e);
      } catch (t) {
        this._logger.log(h.Error, `HttpConnection.onclose(${e}) threw error '${t}'.`);
      }
    }
  }
  _resolveUrl(e) {
    if (e.lastIndexOf("https://", 0) === 0 || e.lastIndexOf("http://", 0) === 0)
      return e;
    if (!A.isBrowser)
      throw new Error(`Cannot resolve '${e}'.`);
    const t = window.document.createElement("a");
    return t.href = e, this._logger.log(h.Information, `Normalizing '${e}' to '${t.href}'.`), t.href;
  }
  _resolveNegotiateUrl(e) {
    const t = new URL(e);
    t.pathname.endsWith("/") ? t.pathname += "negotiate" : t.pathname += "/negotiate";
    const n = new URLSearchParams(t.searchParams);
    return n.has("negotiateVersion") || n.append("negotiateVersion", this._negotiateVersion.toString()), n.has("useStatefulReconnect") ? n.get("useStatefulReconnect") === "true" && (this._options._useStatefulReconnect = !0) : this._options._useStatefulReconnect === !0 && n.append("useStatefulReconnect", "true"), t.search = n.toString(), t.toString();
  }
}
function Jl(r, e) {
  return !r || (e & r) !== 0;
}
class Zr {
  constructor(e) {
    this._transport = e, this._buffer = [], this._executing = !0, this._sendBufferedData = new It(), this._transportResult = new It(), this._sendLoopPromise = this._sendLoop();
  }
  send(e) {
    return this._bufferData(e), this._transportResult || (this._transportResult = new It()), this._transportResult.promise;
  }
  stop() {
    return this._executing = !1, this._sendBufferedData.resolve(), this._sendLoopPromise;
  }
  _bufferData(e) {
    if (this._buffer.length && typeof this._buffer[0] != typeof e)
      throw new Error(`Expected data to be of type ${typeof this._buffer} but was of type ${typeof e}`);
    this._buffer.push(e), this._sendBufferedData.resolve();
  }
  async _sendLoop() {
    for (; ; ) {
      if (await this._sendBufferedData.promise, !this._executing) {
        this._transportResult && this._transportResult.reject("Connection stopped.");
        break;
      }
      this._sendBufferedData = new It();
      const e = this._transportResult;
      this._transportResult = void 0;
      const t = typeof this._buffer[0] == "string" ? this._buffer.join("") : Zr._concatBuffers(this._buffer);
      this._buffer.length = 0;
      try {
        await this._transport.send(t), e.resolve();
      } catch (n) {
        e.reject(n);
      }
    }
  }
  static _concatBuffers(e) {
    const t = e.map((o) => o.byteLength).reduce((o, i) => o + i), n = new Uint8Array(t);
    let s = 0;
    for (const o of e)
      n.set(new Uint8Array(o), s), s += o.byteLength;
    return n.buffer;
  }
}
class It {
  constructor() {
    this.promise = new Promise((e, t) => [this._resolver, this._rejecter] = [e, t]);
  }
  resolve() {
    this._resolver();
  }
  reject(e) {
    this._rejecter(e);
  }
}
const Ql = "json";
class ec {
  constructor() {
    this.name = Ql, this.version = 2, this.transferFormat = j.Text;
  }
  /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
   *
   * @param {string} input A string containing the serialized representation.
   * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
   */
  parseMessages(e, t) {
    if (typeof e != "string")
      throw new Error("Invalid input for JSON hub protocol. Expected a string.");
    if (!e)
      return [];
    t === null && (t = pt.instance);
    const n = K.parse(e), s = [];
    for (const o of n) {
      const i = JSON.parse(o);
      if (typeof i.type != "number")
        throw new Error("Invalid payload.");
      switch (i.type) {
        case m.Invocation:
          this._isInvocationMessage(i);
          break;
        case m.StreamItem:
          this._isStreamItemMessage(i);
          break;
        case m.Completion:
          this._isCompletionMessage(i);
          break;
        case m.Ping:
          break;
        case m.Close:
          break;
        case m.Ack:
          this._isAckMessage(i);
          break;
        case m.Sequence:
          this._isSequenceMessage(i);
          break;
        default:
          t.log(h.Information, "Unknown message type '" + i.type + "' ignored.");
          continue;
      }
      s.push(i);
    }
    return s;
  }
  /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
   *
   * @param {HubMessage} message The message to write.
   * @returns {string} A string containing the serialized representation of the message.
   */
  writeMessage(e) {
    return K.write(JSON.stringify(e));
  }
  _isInvocationMessage(e) {
    this._assertNotEmptyString(e.target, "Invalid payload for Invocation message."), e.invocationId !== void 0 && this._assertNotEmptyString(e.invocationId, "Invalid payload for Invocation message.");
  }
  _isStreamItemMessage(e) {
    if (this._assertNotEmptyString(e.invocationId, "Invalid payload for StreamItem message."), e.item === void 0)
      throw new Error("Invalid payload for StreamItem message.");
  }
  _isCompletionMessage(e) {
    if (e.result && e.error)
      throw new Error("Invalid payload for Completion message.");
    !e.result && e.error && this._assertNotEmptyString(e.error, "Invalid payload for Completion message."), this._assertNotEmptyString(e.invocationId, "Invalid payload for Completion message.");
  }
  _isAckMessage(e) {
    if (typeof e.sequenceId != "number")
      throw new Error("Invalid SequenceId for Ack message.");
  }
  _isSequenceMessage(e) {
    if (typeof e.sequenceId != "number")
      throw new Error("Invalid SequenceId for Sequence message.");
  }
  _assertNotEmptyString(e, t) {
    if (typeof e != "string" || e === "")
      throw new Error(t);
  }
}
const tc = {
  trace: h.Trace,
  debug: h.Debug,
  info: h.Information,
  information: h.Information,
  warn: h.Warning,
  warning: h.Warning,
  error: h.Error,
  critical: h.Critical,
  none: h.None
};
function rc(r) {
  const e = tc[r.toLowerCase()];
  if (typeof e < "u")
    return e;
  throw new Error(`Unknown log level: ${r}`);
}
class sc {
  configureLogging(e) {
    if (O.isRequired(e, "logging"), nc(e))
      this.logger = e;
    else if (typeof e == "string") {
      const t = rc(e);
      this.logger = new Ut(t);
    } else
      this.logger = new Ut(e);
    return this;
  }
  withUrl(e, t) {
    return O.isRequired(e, "url"), O.isNotEmpty(e, "url"), this.url = e, typeof t == "object" ? this.httpConnectionOptions = { ...this.httpConnectionOptions, ...t } : this.httpConnectionOptions = {
      ...this.httpConnectionOptions,
      transport: t
    }, this;
  }
  /** Configures the {@link @microsoft/signalr.HubConnection} to use the specified Hub Protocol.
   *
   * @param {IHubProtocol} protocol The {@link @microsoft/signalr.IHubProtocol} implementation to use.
   */
  withHubProtocol(e) {
    return O.isRequired(e, "protocol"), this.protocol = e, this;
  }
  withAutomaticReconnect(e) {
    if (this.reconnectPolicy)
      throw new Error("A reconnectPolicy has already been set.");
    return e ? Array.isArray(e) ? this.reconnectPolicy = new Ks(e) : this.reconnectPolicy = e : this.reconnectPolicy = new Ks(), this;
  }
  /** Configures {@link @microsoft/signalr.HubConnection.serverTimeoutInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
   *
   * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
   */
  withServerTimeout(e) {
    return O.isRequired(e, "milliseconds"), this._serverTimeoutInMilliseconds = e, this;
  }
  /** Configures {@link @microsoft/signalr.HubConnection.keepAliveIntervalInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
   *
   * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
   */
  withKeepAliveInterval(e) {
    return O.isRequired(e, "milliseconds"), this._keepAliveIntervalInMilliseconds = e, this;
  }
  /** Enables and configures options for the Stateful Reconnect feature.
   *
   * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
   */
  withStatefulReconnect(e) {
    return this.httpConnectionOptions === void 0 && (this.httpConnectionOptions = {}), this.httpConnectionOptions._useStatefulReconnect = !0, this._statefulReconnectBufferSize = e?.bufferSize, this;
  }
  /** Creates a {@link @microsoft/signalr.HubConnection} from the configuration options specified in this builder.
   *
   * @returns {HubConnection} The configured {@link @microsoft/signalr.HubConnection}.
   */
  build() {
    const e = this.httpConnectionOptions || {};
    if (e.logger === void 0 && (e.logger = this.logger), !this.url)
      throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
    const t = new Kl(this.url, e);
    return Xr.create(t, this.logger || pt.instance, this.protocol || new ec(), this.reconnectPolicy, this._serverTimeoutInMilliseconds, this._keepAliveIntervalInMilliseconds, this._statefulReconnectBufferSize);
  }
}
function nc(r) {
  return r.log !== void 0;
}
class oc {
  constructor(e, t) {
    this.store = e, this.authProvider = t, this.typingTimeoutMs = 1e4, this.operatorMsgIdByOp = /* @__PURE__ */ new Map(), this.typingTimeoutByOp = /* @__PURE__ */ new Map();
  }
  async start(e, t) {
    this.connection && await this.stop();
    const s = `${new URL(e).origin}/ws/support`;
    this.connection = new sc().withUrl(s, {
      accessTokenFactory: () => this.authProvider.getAccessToken()
    }).withAutomaticReconnect().configureLogging(h.Information).build(), this.connection.on("Typing", (o) => this.onTyping(o)), this.connection.on("Text", (o) => this.onText(o)), this.connection.on("Close", (o) => this.onClose(o)), this.connection.onclose((o) => {
      console.error("Support Hub connection closed.", o), o && this.onError(o), this.onSupportEnded();
    });
    try {
      await this.connection.start(), await this.connection.invoke("JoinConversation", t);
    } catch (o) {
      console.error("Failed to connect to support hub:", o), this.onError(o);
    }
  }
  async stop() {
    await this.connection?.stop(), this.connection = void 0;
    for (const e of this.typingTimeoutByOp.values()) clearTimeout(e);
    this.typingTimeoutByOp.clear(), this.operatorMsgIdByOp.clear();
  }
  async sendMessage(e) {
    if (this.connection) {
      this.store.dispatch(_e(Gn(e)));
      try {
        await this.connection.invoke("SendMessage", e);
      } catch (t) {
        console.error("Failed to send message via SignalR:", t), this.onError(t);
      }
    }
  }
  async sendTyping() {
    if (this.connection)
      try {
        await this.connection.invoke("SendTyping");
      } catch (e) {
        console.error("Failed to send typing message via SignalR:", e), this.onError(e);
      }
  }
  async sendSeenMessage(e, t) {
    if (this.connection)
      try {
        await this.connection.invoke("SendSeen", e, t);
      } catch (n) {
        console.error("Failed to send seen message via SignalR:", n), this.onError(n);
      }
  }
  async close() {
    if (this.connection)
      try {
        await this.connection.invoke("SendClose");
      } catch (e) {
        console.error("Failed to close support connection via SignalR:", e), this.onError(e);
      }
  }
  onError(e) {
    this.store.dispatch(xe(gt(new bn("Support connection error", e))));
  }
  clearTyping(e) {
    const t = this.typingTimeoutByOp.get(e);
    t && clearTimeout(t), this.typingTimeoutByOp.delete(e);
  }
  scheduleTypingRemoval(e) {
    this.clearTyping(e);
    const t = window.setTimeout(() => {
      const n = this.operatorMsgIdByOp.get(e);
      n && this.store.dispatch(Ja(n)), this.operatorMsgIdByOp.delete(e), this.typingTimeoutByOp.delete(e);
    }, this.typingTimeoutMs);
    this.typingTimeoutByOp.set(e, t);
  }
  async onTyping(e) {
    const t = e.operator;
    if (t) {
      if (this.operatorMsgIdByOp.has(t.id))
        this.store.dispatch(
          we(this.operatorMsgIdByOp.get(t.id), { isTyping: !0 })
        );
      else {
        const n = crypto.randomUUID();
        this.operatorMsgIdByOp.set(t.id, n), this.store.dispatch(
          _e(
            Ys(t, "...", { idGen: () => n, isTyping: !0 })
          )
        );
      }
      this.scheduleTypingRemoval(t.id);
    }
  }
  async onText(e) {
    const t = e.operator;
    if (!t) return;
    this.clearTyping(t.id);
    const n = this.operatorMsgIdByOp.get(t.id);
    n ? (this.store.dispatch(
      we(n, {
        content: e.content,
        isTyping: !1,
        status: "completed"
      })
    ), this.operatorMsgIdByOp.delete(t.id)) : this.store.dispatch(
      _e(Ys(t, e.content, { status: "completed" }))
    );
  }
  async onClose(e) {
    this.stop();
  }
  onSupportEnded() {
    const e = vl();
    this.store.dispatch(_e(e)), this.store.dispatch(lt(e.messageId)), this.store.dispatch(Gr("assistant"));
  }
}
class Ye extends CustomEvent {
  constructor(e, t) {
    super(e, { ...t, bubbles: !0 });
  }
}
class ic extends Ye {
  constructor() {
    super("conversation-cleared");
  }
}
class en extends Ye {
  constructor(e, t) {
    super("message-sent", { detail: { message: e, channel: t } });
  }
}
class ac extends Ye {
  constructor(e, t) {
    super("tool-call-approved", { detail: { turnId: e, messageId: t } });
  }
}
class lc extends Ye {
  constructor(e, t) {
    super("tool-call-declined", { detail: { turnId: e, messageId: t } });
  }
}
class cc extends Ye {
  constructor(e, t) {
    super("feedback-submitted", { detail: { rating: e, comment: t } });
  }
}
class hc extends Ye {
  constructor() {
    super("close-requested");
  }
}
const dc = "3.0.0", pc = {
  version: dc
};
class uc {
  constructor() {
    this.headerName = "Authorization";
  }
  headerValue(e) {
    return `Bearer ${e}`;
  }
}
class gc {
  constructor() {
    this.headerName = "VSN-Assistant-Visitor";
  }
  headerValue(e) {
    return e;
  }
}
function fc(r) {
  return r.getName() === "visma" ? new uc() : new gc();
}
class mc {
  constructor(e, t) {
    this.authProvider = e, this.version = pc.version, this._baseUrl = t;
  }
  set baseUrl(e) {
    this._baseUrl = e;
  }
  async request(e, t = {}) {
    const n = async () => this.sendRequestOnce(e, t), s = await n();
    return s.status !== 401 ? (await Gs(s), s) : this.handleAuthRetry(n);
  }
  async handleAuthRetry(e) {
    this.authProvider.clear();
    const t = await e();
    if (t.status === 401) throw new qe("Unauthorized", t.status, t.url);
    return await Gs(t), t;
  }
  async sendRequestOnce(e, t = {}) {
    try {
      const n = await this.authProvider.getAccessToken(), s = fc(this.authProvider.getStrategy()), o = this.composeHeaders(t.headers, s, n);
      return await fetch(this.formatUrl(e), {
        ...t,
        headers: o
      });
    } catch (n) {
      throw n instanceof oe ? n : new qe("Network error", 0, this.formatUrl(e), n);
    }
  }
  composeHeaders(e, t, n) {
    const s = new Headers(e);
    return s.set(t.headerName, t.headerValue(n ?? "")), s.set("App-Version", this.version), s.set("App-Origin", window.location.href || ""), s;
  }
  formatUrl(e) {
    const t = String(e);
    return /^https?:\/\//i.test(t) ? t : `${this._baseUrl}${t.startsWith("/") ? "" : "/"}${t}`;
  }
}
class wc {
  constructor() {
    this.key = "gaia-chat:visitor-token";
  }
  load() {
    const e = localStorage.getItem(this.key);
    return e || null;
  }
  save(e) {
    localStorage.setItem(this.key, e);
  }
  clear() {
    localStorage.removeItem(this.key);
  }
}
class bc {
  constructor(e, t) {
    this.onOffline = () => {
      this.store.dispatch(
        xe({
          code: "NETWORK",
          message: v("You're offline. Check your connection.", { id: "error-offline" }),
          retryable: !1,
          source: "ui"
        })
      );
    }, this.onOnline = () => {
      this.store.snapshot.ui.error?.code === "NETWORK" && this.store.dispatch(xe(null));
    }, e.addController(this), this.store = t;
  }
  hostConnected() {
    window.addEventListener("offline", this.onOffline), window.addEventListener("online", this.onOnline);
  }
  hostDisconnected() {
    window.removeEventListener("offline", this.onOffline), window.removeEventListener("online", this.onOnline);
  }
}
const vc = (r, e, t) => {
  const n = r[e];
  return n ? typeof n == "function" ? n() : Promise.resolve(n) : new Promise((s, o) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(o.bind(null, /* @__PURE__ */ new Error("Unknown variable dynamic import: " + e + (e.split("/").length !== t ? ". Note that variables only represent file names one level deep." : ""))));
  });
}, Xn = "en", yc = ["da", "nb", "sv"], _c = ["da", "en", "nb", "sv"], { getLocale: kc, setLocale: tn } = Go({
  sourceLocale: Xn,
  targetLocales: yc,
  loadLocale: (r) => vc(/* @__PURE__ */ Object.assign({ "../generated/locales/da.ts": () => import("./da-Cj_KR5nk.js"), "../generated/locales/nb.ts": () => import("./nb-CZ_wxmV3.js"), "../generated/locales/sv.ts": () => import("./sv-vI7UPOlk.js") }), `../generated/locales/${r}.ts`, 4)
});
function rn(r) {
  const [e] = r.split("-"), t = e.toLowerCase();
  return xc(t);
}
function xc(r) {
  switch (r) {
    case "no":
    case "nn":
      return "nb";
    default:
      return Sc(r) ? r : Xn;
  }
}
function Sc(r) {
  return _c.includes(r);
}
var Tc = Object.defineProperty, Ec = Object.getOwnPropertyDescriptor, le = (r, e, t, n) => {
  for (var s = n > 1 ? void 0 : n ? Ec(e, t) : e, o = r.length - 1, i; o >= 0; o--)
    (i = r[o]) && (s = (n ? i(e, t, s) : i(s)) || s);
  return n && s && Tc(e, t, s), s;
};
let ee = class extends ie {
  constructor() {
    super(...arguments), this.baseUrl = "https://api.assistant.stag.vsn.dev", this.profileId = "default", this.authStrategy = "visitor", this.closeable = !0, this.state = null, this.messages = [], this.isConnectedToSupport = !1, this.store = new al();
  }
  connectedCallback() {
    super.connectedCallback(), tn(rn(this.lang || this.ownerDocument.documentElement.lang || "en")), this.langObserver = new MutationObserver((e) => {
      for (const t of e)
        if (t.type === "attributes" && t.attributeName === "lang") {
          const n = this.lang || this.ownerDocument.documentElement.lang || "en";
          tn(rn(n)), this.requestUpdate();
        }
    }), this.langObserver.observe(this, {
      attributes: !0,
      attributeFilter: ["lang"]
    }), new bc(this, this.store), this.checkPlatform(), this.strategyFactory = new Ro({
      storage: new wc()
    }), this.authProvider = new ko(), this.apiClient = new mc(this.authProvider, this.baseUrl);
    const r = new fl(this.apiClient);
    this.bootstrapEffect = new cl(this.store, new Wa(this.apiClient)), this.streamEffect = new kl(this.store, r), this.supportEffect = new oc(this.store, this.authProvider), this.conversationEffect = new ml(this.store, r), this.feedbackEffect = new bl(this.store, new wl(this.apiClient)), this.unsubscribe = this.store.subscribe((e) => {
      const t = this.state;
      this.state = e, this.messages = ll(e), this.isConnectedToSupport = e.session.channel === "support", this.welcomeMessages = e.config.welcomeMessages, this.isConnectedToSupport && t?.session.channel !== "support" && this.supportEffect?.start(this.baseUrl, this.store.snapshot.session.conversationId);
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.unsubscribe?.(), this.supportEffect?.stop(), this.langObserver?.disconnect();
  }
  async handleAuthChanged() {
    this.store.dispatch(xe(null)), this.store.dispatch(Ft(!0));
    try {
      const r = this.authProvider.getIdentifier();
      if (this.authStrategy === "visma" && !this.tokenProvider) {
        console.warn("Waiting for tokenProvider to be set...");
        return;
      }
      const e = this.strategyFactory.create(
        this.authStrategy,
        this.tokenProvider,
        this.baseUrl
      );
      await e.refresh(), this.authProvider.useStrategy(e);
      const t = this.authProvider.getIdentifier();
      r !== t && (this.bootstrapEffect.clear(), r && (this.conversationEffect.clear(), this.streamEffect.abortCurrentTask?.(), this.supportEffect.close(), this.supportEffect.stop()), this.bootstrapEffect.initialize(), this.conversationEffect.getHistory());
    } finally {
      this.store.dispatch(Ft(!1));
    }
  }
  willUpdate(r) {
    super.willUpdate(r), (r.has("tokenProvider") || r.has("authStrategy") || r.has("baseUrl")) && this.handleAuthChanged(), r.has("baseUrl") && (this.apiClient.baseUrl = this.baseUrl);
  }
  checkPlatform() {
    const r = window.navigator.userAgent;
    let e = "unknown";
    r.indexOf("Win") !== -1 ? e = "windows" : r.indexOf("Mac") !== -1 ? e = "macos" : e = "unknown", this.setAttribute("data-platform", e);
  }
  async onSendMessage(r) {
    r.stopPropagation();
    const e = r.detail.message;
    !e || !this.streamEffect || (this.closeFeedbackIfOpen(), this.isConnectedToSupport ? (this.supportEffect.sendMessage(e), this.dispatchEvent(new en(e, "support"))) : (this.streamEffect?.sendMessage(e, this.profileId, this.supportPartnerId), this.dispatchEvent(new en(e, "assistant"))));
  }
  onApproveToolCall(r) {
    r.stopPropagation(), this.closeFeedbackIfOpen(), this.streamEffect?.approveToolCall(r.detail.turnId, r.detail.messageId), this.dispatchEvent(new ac(r.detail.turnId, r.detail.messageId));
  }
  onDeclineToolCall(r) {
    r.stopPropagation(), this.closeFeedbackIfOpen(), this.streamEffect?.declineToolCall(r.detail.turnId, r.detail.messageId), this.dispatchEvent(new lc(r.detail.turnId, r.detail.messageId));
  }
  onSubmitFeedback(r) {
    r.stopPropagation(), this.feedbackEffect?.submitFeedback(r.detail.target, r.detail.rating, r.detail.comment), this.dispatchEvent(new cc(r.detail.rating, r.detail.comment));
  }
  onToggleFeedbackForm(r) {
    r.stopPropagation(), r.detail.target ? this.store.dispatch(rl(r.detail.target)) : this.store.dispatch(Ir());
  }
  onClearConversation(r) {
    r.stopPropagation(), this.conversationEffect?.clear(), this.supportEffect?.stop(), this.dispatchEvent(new ic());
  }
  onClearError() {
    this.store.dispatch(xe(null));
  }
  closeFeedbackIfOpen() {
    this.state?.ui.feedbackFormOpen && this.store.dispatch(Ir());
  }
  onSendTyping(r) {
    r.stopPropagation(), this.isConnectedToSupport && this.supportEffect?.sendTyping();
  }
  // + NEW
  onMarkSeen(r) {
    if (r.stopPropagation(), this.isConnectedToSupport) {
      const { messageId: e, seenAt: t } = r.detail;
      this.supportEffect?.sendSeenMessage(e, t);
    }
  }
  onCloseChat(r) {
    r.stopPropagation(), this.dispatchEvent(new hc());
  }
  render() {
    return b`
      <div
        class=${$e(
      "@container/main grid h-full w-full [grid-template-rows:auto_1fr_auto] overflow-hidden [grid-template-areas:'header''content''footer']",
      {
        "border border-solid border-neutral-300 shadow-md": this.closeable
      }
    )}
      >
        <gaia-chat-menu
          .hasEmptyMessages=${this.messages.length === 0}
          class="[grid-area:header]"
          .disabled=${!this.state.session.isActive}
          .closeable=${this.closeable}
          @clear-conversation=${this.onClearConversation}
          @toggle-feedback-form=${this.onToggleFeedbackForm}
          @close-chat=${this.onCloseChat}
        ></gaia-chat-menu>
        <gaia-chat-message-list
          .messages=${this.messages}
          .isInitialized=${this.state.config.initialized}
          .isThinking=${this.state.session.isThinking}
          .feedbackFormOpen=${this.state.ui.feedbackFormOpen}
          .feedbackFormTarget=${this.state.ui.feedbackFormTarget}
          .error=${this.state.ui.error ?? null}
          .isConnectedToSupport=${this.isConnectedToSupport}
          .welcomeMessage=${this.welcomeMessages?.[kc()]}
          @clear-conversation=${this.onClearConversation}
          @approve-tool-call=${this.onApproveToolCall}
          @decline-tool-call=${this.onDeclineToolCall}
          @submit-feedback=${this.onSubmitFeedback}
          @toggle-feedback-form=${this.onToggleFeedbackForm}
          @clear-error=${this.onClearError}
          @mark-seen=${this.onMarkSeen}
          class="overflow-hidden [grid-area:content]"
        ></gaia-chat-message-list>
        <gaia-chat-composer
          class="[grid-area:footer]"
          .disabled=${!this.state.session.isActive}
          .loading=${this.state.session.isBusy}
          .maxInputLength=${this.state.config.maxInputLength}
          @send-message=${this.onSendMessage}
          @send-typing=${this.onSendTyping}
        ></gaia-chat-composer>
      </div>
    `;
  }
};
le([
  E({ type: String, attribute: "base-url" })
], ee.prototype, "baseUrl", 2);
le([
  E({ type: String, attribute: "profile-id" })
], ee.prototype, "profileId", 2);
le([
  E({ type: String, attribute: "support-partner-id" })
], ee.prototype, "supportPartnerId", 2);
le([
  E({ attribute: !1 })
], ee.prototype, "tokenProvider", 2);
le([
  E({ attribute: "auth-strategy" })
], ee.prototype, "authStrategy", 2);
le([
  E({
    type: Boolean,
    attribute: "closeable",
    reflect: !0,
    converter: (r) => r === "true" || r === ""
  })
], ee.prototype, "closeable", 2);
le([
  Se()
], ee.prototype, "state", 2);
le([
  Se()
], ee.prototype, "messages", 2);
le([
  Se()
], ee.prototype, "isConnectedToSupport", 2);
le([
  Se()
], ee.prototype, "welcomeMessages", 2);
ee = le([
  te("gaia-chat")
], ee);
export {
  ee as C,
  Po as s
};
